webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(208);
	module.exports = __webpack_require__(329);


/***/ },

/***/ 11:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _events = __webpack_require__(613);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emitter = new _events2.default();
	exports.default = emitter;
	module.exports = exports['default'];

/***/ },

/***/ 22:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(35);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _mobileDetect = __webpack_require__(631);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	var _Breakpoints = __webpack_require__(332);
	
	var _Breakpoints2 = _interopRequireDefault(_Breakpoints);
	
	var _bowser = __webpack_require__(358);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Detector = function () {
	  function Detector() {
	    (0, _classCallCheck3.default)(this, Detector);
	
	    this.ua = window.navigator.userAgent;
	    this.md = new _mobileDetect2.default(this.ua);
	
	    this.BP_MOBILE = 300;
	    this.BP_TABLET = 400;
	    this.BP_DESKTOP = 1050;
	  }
	
	  (0, _createClass3.default)(Detector, [{
	    key: 'isWindow7',
	    value: function isWindow7() {
	      return this.ua.indexOf('Windows NT 5.1') > 0;
	    }
	  }, {
	    key: 'isOld',
	    value: function isOld() {
	      if (_bowser2.default.msie && _bowser2.default.version < 10) {
	        return true;
	      }
	
	      if (_bowser2.default.safari && _bowser2.default.version < 8) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isMobile',
	    value: function isMobile() {
	      return this.md.mobile();
	    }
	  }, {
	    key: 'isPhone',
	    value: function isPhone() {
	      return this.md.phone();
	    }
	  }, {
	    key: 'isTablet',
	    value: function isTablet() {
	      return this.md.tablet();
	    }
	  }, {
	    key: 'isChromeSimulator',
	    value: function isChromeSimulator() {
	      if (window.navigator.vendor) {
	        return window.navigator.vendor.indexOf('Google Inc.') !== -1 && window.navigator.maxTouchPoints < 2;
	      } else {
	        return;
	      }
	    }
	  }, {
	    key: 'is',
	    value: function is(test) {
	      return this.md.is(test);
	    }
	  }, {
	    key: 'isLandscape',
	    value: function isLandscape() {
	      return Math.abs(window.orientation) === 90;
	    }
	  }, {
	    key: 'isPortrait',
	    value: function isPortrait() {
	      return Math.abs(window.orientation) === 0;
	    }
	  }, {
	    key: 'getScreenSize',
	    value: function getScreenSize() {
	      var isMobile = this.isMobile();
	      var urlBar = this.getOffsetUrlBar();
	
	      var size = {
	        w: isMobile ? screen.width : window.innerWidth,
	        h: isMobile ? window.innerHeight + urlBar : window.innerHeight
	      };
	
	      if (isMobile && this.md.is('iOS')) {
	        if (this.isLandscape()) {
	          size = {
	            w: screen.height,
	            h: screen.width - urlBar
	          };
	        }
	      }
	
	      size.hW = size.w / 2;
	      size.hH = size.h / 2;
	
	      size.BP = this.getBreakpoint(size.w);
	      return size;
	    }
	
	    // "Mozilla/5.0 (iPhone; CPU iPhone OS 9_1 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Version/9.0 Mobile/13B143 Safari/601.1"
	    /**
	     * getOffsetUrlBar : return int
	     * Get size of adress bar on device
	     */
	
	  }, {
	    key: 'getOffsetUrlBar',
	    value: function getOffsetUrlBar() {
	      var offset = 0;
	      if (this.isChromeSimulator()) {
	        return 0;
	      }
	      if (this.md.is('AndroidOS')) {
	        offset = this.isLandscape() ? 20 : 56;
	        // offset = 0
	      } else if (this.md.is('iOS')) {
	        if (this.md.is('Chrome')) {
	          offset = 20;
	        } else {
	          offset = this.is('iPhone') && this.isLandscape() ? 0 : 40;
	        }
	      }
	      return offset;
	    }
	  }, {
	    key: 'getBreakpoint',
	    value: function getBreakpoint(w) {
	      return _Breakpoints2.default.detect(w);
	    }
	  }]);
	  return Detector;
	}();
	
	var d = new Detector();
	exports.default = d;
	module.exports = exports['default'];

/***/ },

/***/ 56:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clamp = clamp;
	exports.random = random;
	exports.shuffle = shuffle;
	exports.degToRad = degToRad;
	exports.norm = norm;
	exports.map = map;
	exports.round = round;
	exports.isInArray = isInArray;
	function clamp(value, min, max) {
	  return Math.min(Math.max(value, min), max);
	}
	function random(min, max) {
	  var float = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!float) {
	    return Math.floor(Math.random() * (max - min + 1)) + min;
	  } else {
	    return Math.random() * (max - min + 1) + min;
	  }
	}
	
	function shuffle(a) {
	  for (var i = a.length; i; i--) {
	    var j = Math.floor(Math.random() * i);
	    var _ref = [a[j], a[i - 1]];
	    a[i - 1] = _ref[0];
	    a[j] = _ref[1];
	  }
	}
	
	function degToRad(angle) {
	  return angle * Math.PI / 180;
	}
	
	function norm(X, MIN, MAX) {
	  return (X - MIN) / (MAX - MIN);
	}
	
	function map(X, MIN, MAX, A, B) {
	  var norm = (X - MIN) / (MAX - MIN);
	  return A + norm * (B - A);
	}
	
	function round(value) {
	  var decimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e2;
	
	  return Math.round(value * decimal) / decimal;
	}
	
	function isInArray(array, search) {
	  return array.indexOf(search) > -1;
	}

/***/ },

/***/ 77:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSize = getSize;
	exports.getPrefix = getPrefix;
	exports.getTransform = getTransform;
	exports.getMatrixTransform = getMatrixTransform;
	exports.getCssMatrix = getCssMatrix;
	
	var _prefix = __webpack_require__(197);
	
	var _prefix2 = _interopRequireDefault(_prefix);
	
	var _getSize = __webpack_require__(628);
	
	var _getSize2 = _interopRequireDefault(_getSize);
	
	var _cssToMatrix = __webpack_require__(611);
	
	var _cssToMatrix2 = _interopRequireDefault(_cssToMatrix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cssToMatrix = new _cssToMatrix2.default();
	
	function getSize(object) {
	  return (0, _getSize2.default)(object);
	}
	
	function getPrefix() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
	
	  return (0, _prefix2.default)(value);
	}
	
	function getTransform() {
	  var y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var rotation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var scale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	  return 'translate3d(' + x + 'px,' + y + 'px,0) rotateZ(' + rotation + 'deg) scale3d(' + scale + ',' + scale + ',' + scale + ')';
	}
	
	function getMatrixTransform() {
	  var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	  var rotation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	  var mat = cssToMatrix.translate3d(x, y, 0).scale3d(scale, scale, scale).rotate(rotation + 'deg').getMatrixCSS();
	  return mat;
	}
	
	function getCssMatrix() {
	  return cssToMatrix;
	}

/***/ },

/***/ 132:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(89);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(35);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(106);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(105);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import glslify from 'glslify'
	
	var maskVS = __webpack_require__(316);
	var maskFS = __webpack_require__(725);
	
	var MaskFilter = function (_PIXI$Filter) {
	  (0, _inherits3.default)(MaskFilter, _PIXI$Filter);
	
	  function MaskFilter(sprite) {
	    (0, _classCallCheck3.default)(this, MaskFilter);
	
	    var maskMatrix = new PIXI.Matrix();
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MaskFilter.__proto__ || (0, _getPrototypeOf2.default)(MaskFilter)).call(this, maskVS, maskFS));
	
	    _this.resolution = PIXI.settings.RESOLUTION;
	    sprite.renderable = false;
	
	    _this.maskSprite = sprite;
	    _this.maskMatrix = maskMatrix;
	    return _this;
	  }
	
	  (0, _createClass3.default)(MaskFilter, [{
	    key: 'apply',
	    value: function apply(filterManager, input, output) {
	      var maskSprite = this.maskSprite;
	
	      this.uniforms.mask = maskSprite._texture;
	      this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite);
	
	      filterManager.applyFilter(this, input, output);
	    }
	  }]);
	  return MaskFilter;
	}(PIXI.Filter);
	
	exports.default = MaskFilter;
	module.exports = exports['default'];

/***/ },

/***/ 200:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(344),
	  /* template */
	  __webpack_require__(750),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 202:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(89);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(35);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(106);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(209);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(105);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	var _prefix = __webpack_require__(197);
	
	var _prefix2 = _interopRequireDefault(_prefix);
	
	var _math = __webpack_require__(56);
	
	var math = _interopRequireWildcard(_math);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	var _gsap = __webpack_require__(39);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _MaskFilter = __webpack_require__(132);
	
	var _MaskFilter2 = _interopRequireDefault(_MaskFilter);
	
	var _OpacifyFilter = __webpack_require__(328);
	
	var _OpacifyFilter2 = _interopRequireDefault(_OpacifyFilter);
	
	var _simplexNoise = __webpack_require__(199);
	
	var _simplexNoise2 = _interopRequireDefault(_simplexNoise);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Flower = function (_PIXI$Container) {
	  (0, _inherits3.default)(Flower, _PIXI$Container);
	
	  function Flower(opts) {
	    (0, _classCallCheck3.default)(this, Flower);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Flower.__proto__ || (0, _getPrototypeOf2.default)(Flower)).call(this));
	
	    _this.indexFlower = opts.index;
	    _this.isSingle = opts.isSingle;
	    _this.renderer = opts.renderer;
	    _this.resources = opts.resources;
	    _this.data = opts.data;
	    _this.scene = opts.scene;
	    _this.originalSize = _this.data.size;
	    _this.prefix = _this.data.id + '_' + _this.data.title;
	    _this.filtersArray = _this.data.filters;
	    _this.moveBase = _this.data.move_base;
	    _this.prefixTransform = (0, _prefix2.default)('transform');
	    _this.anchorPoint = _this.data.anchor || [0.5, 1];
	    _this.size = _Detector2.default.getScreenSize();
	    _this.simplex = new _simplexNoise2.default();
	
	    _this.wind = {
	      force: 0,
	      speed: 0
	    };
	
	    _this.interactive = true;
	    _this.isOvered = false;
	    _this.mousePoint = {
	      x: -1000,
	      y: -1000
	    };
	
	    _this.isUnmasked = false;
	    _this.isUnmasking = false;
	
	    _this.bindAll();
	    _this.addListeners();
	
	    _this.flowerContainer = new PIXI.Container();
	    _this.addChild(_this.flowerContainer);
	
	    _this.data.children.forEach(function (el) {
	      return _this.createChild(el);
	    });
	
	    _this.scene.addChild(_this);
	
	    if (!_this.isSingle) _this.createTitle();
	    _this.createHtml();
	
	    _this.renderTextureMask = PIXI.RenderTexture.create(_this.width, _this.height);
	    _this.createMask();
	    _this.createOpacityFilter();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Flower, [{
	    key: 'bindAll',
	    value: function bindAll() {
	      var _this2 = this;
	
	      ['update', 'resize', 'createChild'].forEach(function (fn) {
	        return _this2[fn] = _this2[fn].bind(_this2);
	      });
	    }
	
	    /**
	     * Handler mouse
	     */
	
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      var _this3 = this;
	
	      if (_Detector2.default.isMobile()) {
	        if (!this.isSingle) {
	          if (_Detector2.default.is('iOS')) {
	            this.click = function () {
	              _Emitter2.default.emit('OPEN_SINGLE', _this3.data.title);
	            };
	          } else {
	            this.tap = function () {
	              _Emitter2.default.emit('OPEN_SINGLE', _this3.data.title);
	            };
	          }
	        }
	
	        // this.touchstart = () => {
	        //   this.isOvered = true
	        //   // Emitter.emit('SHOW_PARTICLES', this)
	        // }
	        //
	        // this.touchend = () => {
	        //   this.isOvered = false
	        //   // Emitter.emit('HIDE_PARTICLES', this)
	        // }
	      } else {
	        this.mouseover = function () {
	          _this3.isOvered = true;
	          // Emitter.emit('SHOW_PARTICLES', this)
	          _Emitter2.default.emit('SOUND::PLAY_FLOWER_OVER');
	
	          // this.wind.force = 5
	
	          _this3.tlWind = new TimelineMax({
	            onComplete: function onComplete() {}
	          });
	
	          _this3.tlWind.fromTo(_this3.wind, 2, {
	            force: _this3.wind.force,
	            speed: _this3.wind.speed,
	            ease: Quint.easeOut
	          }, {
	            force: function force() {
	              return math.random(-5, 6);
	            },
	            speed: function speed() {
	              return math.random(0, 5);
	            },
	            ease: Expo.easeOut
	          }, 'start');
	          // .to(this.wind, 1, {
	          //   force: 0,
	          //   speed: 0,
	          //   ease: Elastic.easeOut
	          // }, 'start+=1')
	
	          // this.tlWind.reverse()
	
	          if (_this3.titleBar) {
	            _gsap2.default.to(_this3.titleBar.scale, 0.8, {
	              x: 1,
	              ease: Quint.easeOut
	            });
	            _gsap2.default.to(_this3.titleBar, 0.8, {
	              alpha: 1,
	              ease: Quint.easeOut
	            });
	          }
	
	          !_this3.isSingle && document.body.classList.add('is-hovered');
	        };
	
	        this.mouseout = function () {
	          _this3.isOvered = false;
	          _Emitter2.default.emit('HIDE_PARTICLES', _this3);
	          _Emitter2.default.emit('SOUND::STOP_FLOWER_OVER');
	
	          _this3.tlWind.stop();
	          _this3.tlWind = new TimelineMax();
	
	          var d = math.random(1, 3, true);
	
	          _this3.tlWind.to(_this3.wind, d, {
	            force: 0,
	            speed: 0,
	            ease: Sine.easeOut
	          });
	
	          // this.tlWind.stop()
	          // // this.tlWind = new TimelineMax({
	          // //   onComplete: () => {
	          // //     console.log(this.wind)
	          // //   }
	          // // })
	          // TweenMax.to(this.wind, 1, {
	          //   force: 0,
	          //   speed: 0,
	          //   ease: Quint.easeOut
	          // })
	
	          if (_this3.titleBar) {
	            _gsap2.default.to(_this3.titleBar.scale, 0.8, {
	              x: 0,
	              ease: Quint.easeOut
	            });
	            _gsap2.default.to(_this3.titleBar, 0.8, {
	              alpha: 0,
	              ease: Quint.easeOut
	            });
	          }
	
	          !_this3.isSingle && document.body.classList.remove('is-hovered');
	        };
	
	        if (!this.isSingle) {
	          this.click = function () {
	            _Emitter2.default.emit('OPEN_SINGLE', _this3.data.title);
	            _Emitter2.default.emit('SOUND::PLAY_FLOWER_CLICK');
	          };
	        }
	      }
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      if (_Detector2.default.isMobile()) {
	        this.tap = null;
	        this.touchstart = null;
	        this.touchend = null;
	      } else {
	        this.mousemove = null;
	        this.mouseover = null;
	        this.mouseout = null;
	        this.click = null;
	      }
	    }
	  }, {
	    key: 'isSprite',
	    value: function isSprite(el) {
	      return !el.children;
	    }
	  }, {
	    key: 'isContainer',
	    value: function isContainer(el) {
	      return el.children;
	    }
	  }, {
	    key: 'isInViewport',
	    value: function isInViewport(scrollY) {
	      var rect = {};
	      rect.top = this.position.y - this.size.h;
	      rect.bottom = rect.top + this.height + this.size.h;
	      // let result = rect.top <= this.size.h && rect.bottom > 0
	
	      /**
	          let limitIn = (this.bounds.filtersContainer.top)
	          let limitOut = limitIn + this.offsetHeight + (this.size.h / 2 - this.offsetHeight / 2)
	          let limitOutVp = limitIn + this.offsetHeight - this.size.h - this.bounds.filtersContainer.paddingTop
	           let vp = this.scrollY.current > limitIn &&
	          this.scrollY.current < limitOutVp
	      **/
	      var offsetY = 0;
	      if (scrollY.offset) offsetY = scrollY.offset;
	      var result = scrollY.dest - offsetY > rect.top && scrollY.dest - offsetY < rect.bottom;
	
	      if (result) {
	        // this.alpha = 1
	        if (!this.interactive) {
	          if (!this.renderer.isCanvas) {
	            this.cacheAsBitmap = false;
	          }
	          this.interactive = true;
	          // this.visible = true
	        }
	      } else {
	        // this.alpha = 0.5
	        if (this.interactive) {
	          if (!this.renderer.isCanvas) {
	            this.cacheAsBitmap = true;
	          }
	          this.interactive = false;
	          // this.visible = false
	        }
	      }
	
	      return result;
	    }
	  }, {
	    key: 'createOpacityFilter',
	    value: function createOpacityFilter() {
	      if (this.renderer.isCanvas) {
	        this.fallbackOpacity = new PIXI.Graphics();
	        this.fallbackOpacity.beginFill(0xf3f1dd);
	        this.fallbackOpacity.drawRect(0, 0, this.width, this.height);
	        this.fallbackOpacity.endFill();
	
	        this.fallbackOpacity.alpha = 0;
	
	        this.flowerContainer.addChild(this.fallbackOpacity);
	      } else {
	        this.opacityFilter = new _OpacifyFilter2.default();
	        this.opacityFilter.uniforms.alpha = 1;
	      }
	    }
	  }, {
	    key: 'opacifyFlower',
	    value: function opacifyFlower() {
	      var _this4 = this;
	
	      if (this.renderer.isCanvas) {
	        _gsap2.default.to(this.fallbackOpacity, 2, {
	          alpha: 0.85,
	          ease: Expo.easeOut,
	          onComplete: function onComplete() {
	            _this4.isOpacified = true;
	            // this.flowerContainer.filters = null
	          }
	        });
	      } else {
	        this.flowerContainer.filters = [this.opacityFilter];
	        _gsap2.default.to(this.opacityFilter.uniforms, 2, {
	          alpha: 0.1,
	          ease: Expo.easeOut,
	          onComplete: function onComplete() {
	            _this4.isOpacified = true;
	            // this.flowerContainer.filters = null
	          }
	        });
	      }
	    }
	  }, {
	    key: 'desopacifyFlower',
	    value: function desopacifyFlower() {
	      var _this5 = this;
	
	      if (this.renderer.isCanvas) {
	        _gsap2.default.to(this.fallbackOpacity, 2, {
	          alpha: 0,
	          ease: Expo.easeOut,
	          onComplete: function onComplete() {
	            _this5.isOpacified = false;
	          }
	        });
	      } else {
	        _gsap2.default.to(this.opacityFilter.uniforms, 2, {
	          alpha: 1,
	          ease: Expo.easeOut,
	          onComplete: function onComplete() {
	            _this5.isOpacified = false;
	            _this5.flowerContainer.filters = null;
	          }
	        });
	      }
	    }
	  }, {
	    key: 'createMask',
	    value: function createMask() {
	      this.thresholdSprite = new PIXI.Sprite(PIXI.Texture.fromFrame('threshold'));
	      // this.thresholdSprite.width = this.width
	      // this.thresholdSprite.height = this.height
	
	      var maskIntroContainer = new PIXI.Container();
	      maskIntroContainer.addChild(this.thresholdSprite);
	
	      this.renderer.render(maskIntroContainer, this.renderTextureMask);
	
	      this.maskIntroSprite = new PIXI.Sprite(this.renderTextureMask);
	      // this.maskIntroSprite.alpha = 0.5
	      // this.maskIntroSprite.width = this.width
	      // this.maskIntroSprite.height = this.height
	
	      this.maskIntroFilter = new _MaskFilter2.default(this.maskIntroSprite);
	      this.filters = [this.maskIntroFilter];
	
	      this.addChild(this.maskIntroSprite);
	
	      this.setAlphaMask(0);
	
	      this.filterMask = new PIXI.Graphics();
	      this.filterMask.beginFill(0x000000, 0.5);
	      this.filterMask.drawRect(0, 0, this.width, this.height);
	      this.filterMask.endFill();
	      //
	      // this.filterMask.alpha = 0.2
	      //
	      // this.flowerContainer.addChild(this.filterMask)
	      // this.flowerContainer.mask = this.filterMask
	    }
	  }, {
	    key: 'setAlphaMask',
	    value: function setAlphaMask(value) {
	      this.maskIntroFilter.uniforms.alpha = value;
	    }
	  }, {
	    key: 'showMask',
	    value: function showMask() {
	      var _this6 = this;
	
	      this.isUnmasking = true;
	      _gsap2.default.to(this.maskIntroFilter.uniforms, 4, {
	        alpha: 1,
	        delay: this.indexFlower % 5 * 0.2,
	        ease: Expo.easeOut,
	        onComplete: function onComplete() {
	          _this6.isUnmasked = true;
	          _this6.isUnmasking = false;
	          _this6.filters = null;
	          // var index = this.filters.indexOf(this.maskIntroFilter)
	          // this.filters.splice(index, 1)
	        }
	      });
	    }
	  }, {
	    key: 'hideMask',
	    value: function hideMask(cb) {
	      var _this7 = this;
	
	      this.filters = [this.maskIntroFilter];
	      this.isUnmasking = true;
	
	      if (this.hideMaskTl) {
	        this.hideMaskTl.kill();
	        this.hideMaskTl.eventCallback('onComplete', null);
	      }
	
	      this.hideMaskTl = _gsap2.default.to(this.maskIntroFilter.uniforms, 4, {
	        alpha: 0,
	        ease: Expo.easeOut,
	        onComplete: function onComplete() {
	          _this7.isUnmasked = false;
	          _this7.isUnmasking = false;
	
	          if (cb) {
	            cb();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'removeMask',
	    value: function removeMask() {}
	  }, {
	    key: 'createHtml',
	    value: function createHtml() {
	      if (!document.querySelector('.app .flowers')) {} else {
	        this.divFlowers = document.querySelector('.app .flowers');
	      }
	
	      this.divContainer = document.createElement('div');
	      this.divContainer.classList.add('flower-container');
	      // if (this.data.background) {
	      //   this.divContainer.style.backgroundColor = this.data.background
	      // }
	      this.divFlowers.appendChild(this.divContainer);
	
	      this.div = document.createElement('div');
	      this.div.classList.add('flower');
	      this.divContainer.appendChild(this.div);
	
	      this.divPivot = document.createElement('div');
	      this.divPivot.classList.add('pivot');
	      this.div.appendChild(this.divPivot);
	    }
	  }, {
	    key: 'createChild',
	    value: function createChild(el, parent) {
	      var _this8 = this;
	
	      if (this.isContainer(el)) {
	        var container = new PIXI.Container();
	        container.anchorPoint = el.anchor || [0.5, 1];
	
	        container.data = el;
	        container.data.mathOscillation = Math.round(Math.random()) ? 'cos' : 'sin';
	        container.data.velocity = el.velocity || math.random(5, 15) / 10000;
	
	        el.children.forEach(function (child, i) {
	          return _this8.createChild(child, container);
	        });
	
	        if (parent) {
	          parent.addChild(container);
	        } else {
	          this.flowerContainer.addChild(container);
	        }
	      } else {
	        var sprite = new PIXI.Sprite(PIXI.Texture.fromFrame(this.prefix + '_' + el.name + '.png'));
	
	        sprite.data = el;
	        sprite.data.mathOscillation = Math.round(Math.random()) ? 'cos' : 'sin';
	        sprite.data.velocity = el.velocity || math.random(5, 15) / 10000;
	
	        sprite.anchor.set(el.anchor[0] || 0, el.anchor[1] || 0);
	
	        sprite.x = sprite.width * el.anchor[0];
	        sprite.y = sprite.height * el.anchor[1];
	
	        sprite.x += el.position[0];
	        sprite.y += el.position[1];
	
	        if (parent) {
	          parent.addChild(sprite);
	        } else {
	          this.flowerContainer.addChild(sprite);
	        }
	      }
	    }
	  }, {
	    key: 'createTitle',
	    value: function createTitle() {
	      var title = this.data.title_long ? this.data.title_long : this.data.title.charAt(0).toUpperCase() + this.data.title.slice(1);
	
	      this.titleText = new PIXI.Text(title, {
	        fontFamily: 'ChronicleTextG1-Italic',
	        fontSize: _Detector2.default.isMobile() ? 25 : 20,
	        fill: 0x000000,
	        align: 'center'
	      });
	
	      this.titleText.anchor.set(0.5, 1);
	
	      this.addChild(this.titleText);
	
	      this.titleBar = new PIXI.Graphics();
	      this.titleBar.beginFill(0xff3600);
	      this.titleBar.drawRect(0, 2, this.titleText.width, 4);
	      this.titleBar.endFill();
	
	      this.titleBar.pivot.x = -this.titleText.width / 2;
	      this.titleBar.scale.x = 0;
	      this.titleBar.alpha = 0;
	      this.titleBar.x = -this.titleText.width;
	
	      this.titleText.addChild(this.titleBar);
	    }
	  }, {
	    key: 'positionPivot',
	    value: function positionPivot(child) {
	      var _this9 = this;
	
	      if (child instanceof PIXI.Sprite || child instanceof PIXI.Graphics) return;
	
	      var bounds = child.getLocalBounds();
	      var xOffset = bounds.x;
	      var x = xOffset + child.width * child.anchorPoint[0];
	
	      var yOffset = bounds.y;
	      var y = yOffset + child.height * child.anchorPoint[1];
	
	      child.pivot.set(x, y);
	      child.position.set(x, y);
	
	      if (child.children) {
	        child.children.forEach(function (el, i) {
	          return _this9.positionPivot(el);
	        });
	      }
	
	      // if (!child.hasPivotPointDrawed) {
	      //   child.hasPivotPointDrawed = true
	      //   let gr = new PIXI.Graphics()
	      //   gr.x = x
	      //   gr.y = y
	      //   gr.beginFill(0x165af2)
	      //   gr.drawCircle(0, 0, 6)
	      //   gr.endFill()
	      //   child.parent.addChild(gr)
	      // }
	    }
	  }, {
	    key: 'resize',
	    value: function resize(size, index, grid) {
	      this.size = size;
	
	      if (this.isSingle) {
	        var newW = this.size.w;
	        var newH = this.size.h;
	
	        var textureRatio = this.originalSize[0] / this.originalSize[1];
	        var boxRatio = newW / newH;
	
	        var ratioW = void 0;
	        if (boxRatio < 1) {
	          if (textureRatio < boxRatio) {
	            ratioW = newH / this.originalSize[1];
	          } else {
	            ratioW = newW / this.originalSize[0];
	          }
	        } else {
	          ratioW = newH / this.originalSize[1];
	        }
	
	        this.flowerContainer.scale.set(ratioW);
	
	        var offsetWidth = (newW - this.flowerContainer.width) / 2;
	        var offsetHeight = (newH - this.flowerContainer.height) / 2;
	
	        this.positionPivot(this.flowerContainer.children[0]);
	
	        this.flowerContainer.pivot.set(this.originalSize[0] * this.anchorPoint[0], this.originalSize[1] * this.anchorPoint[1]);
	        this.flowerContainer.position.set(this.flowerContainer.width * this.anchorPoint[0], this.flowerContainer.height * this.anchorPoint[1]);
	
	        this.position.set(offsetWidth, offsetHeight);
	      } else {
	        this.flowerIndex = index;
	        this.grid = grid;
	
	        var bigElement = false;
	        var _newW = Math.min(this.size.w, this.grid.maxWidth) / grid.column();
	        var h = Math.min(this.size.h, this.grid.maxHeight());
	        var hH = h / 2;
	
	        var _newH = 0;
	        var xPadding = 0;
	
	        if (size.w > this.grid.maxWidth) {
	          xPadding = (size.w - this.grid.maxWidth) / 2;
	        }
	
	        var xPos = xPadding;
	        var yPos = this.grid.startTop;
	        var itemsByRow = grid.itemsByRow();
	        var col = grid.currentCol;
	        var marginMultiplier = void 0;
	        var offsetTypo = 0;
	        var bpMobile = false;
	
	        switch (this.size.BP) {
	          case 'mobile':
	          case 'xs-tablet':
	            marginMultiplier = 0.9;
	            offsetTypo = 0;
	            bpMobile = true;
	            break;
	
	          default:
	            marginMultiplier = 0.8;
	            break;
	        }
	
	        if (index % (itemsByRow * 2) === 0 || index % (itemsByRow * 2) === itemsByRow) {
	          switch (this.size.BP) {
	            case 'mobile':
	            case 'xs-tablet':
	              marginMultiplier = 0.9;
	              break;
	            case 'tablet':
	              marginMultiplier = 1;
	              break;
	            default:
	              marginMultiplier = 1.2;
	              break;
	          }
	
	          _newH = h;
	          xPos += index % (itemsByRow * 2) === 0 ? 0 : _newW * (grid.column() - 1);
	          yPos += h * (grid.row - 1);
	
	          bigElement = true;
	        } else {
	          _newH = hH;
	          xPos += index % (itemsByRow * 2) < itemsByRow ? _newW * col : _newW * (grid.column() - 1 - col);
	          yPos += h * (grid.row - 1);
	          yPos += index % 2 === 0 ? hH : 0;
	
	          bigElement = false;
	        }
	
	        var _textureRatio = this.originalSize[0] / this.originalSize[1];
	        var _boxRatio = _newW / _newH;
	
	        var _ratioW = void 0;
	        if (_boxRatio < 1) {
	          if (_textureRatio < _boxRatio) {
	            _ratioW = _newH * marginMultiplier / this.originalSize[1];
	          } else {
	            _ratioW = _newW * marginMultiplier / this.originalSize[0];
	          }
	        } else {
	          _ratioW = _newH * marginMultiplier / this.originalSize[1];
	        }
	
	        this.flowerContainer.scale.set(_ratioW);
	
	        var _offsetWidth = (_newW - this.flowerContainer.width) / 2;
	        var _offsetHeight = (_newH - this.flowerContainer.height) / 2;
	
	        this.positionPivot(this.flowerContainer.children[0]);
	
	        this.flowerContainer.pivot.set(this.originalSize[0] * this.anchorPoint[0], this.originalSize[1] * this.anchorPoint[1]);
	        this.flowerContainer.position.set(this.flowerContainer.width * this.anchorPoint[0], this.flowerContainer.height * this.anchorPoint[1]);
	
	        this.position.set(_offsetWidth + xPos, _offsetHeight + yPos);
	
	        this.titleText.position.x = this.flowerContainer.width / 2;
	        if (bpMobile) {
	          this.titleText.position.y = this.flowerContainer.height + _offsetHeight + offsetTypo;
	        } else {
	          this.titleText.position.y = bigElement ? this.flowerContainer.height + _offsetHeight / 2 : this.flowerContainer.height + _offsetHeight;
	        }
	
	        if (this.maskIntroSprite) {
	          this.maskIntroSprite.width = this.flowerContainer.width;
	          this.maskIntroSprite.height = this.flowerContainer.height;
	
	          this.filterMask.width = this.width * 1.2;
	          this.filterMask.height = this.height * 1.2;
	        }
	
	        this.divContainer.style.width = _newW + 'px';
	        this.divContainer.style.height = _newH + 'px';
	        this.divContainer.style.left = xPos + 'px';
	        this.divContainer.style.top = yPos + 'px';
	
	        this.div.style.width = this.flowerContainer.width + 'px';
	        this.div.style.height = this.flowerContainer.height - 1 + 'px';
	        this.div.style.left = _offsetWidth + 'px';
	        this.div.style.top = _offsetHeight + 'px';
	
	        this.divPivot.style.left = this.flowerContainer.width * this.anchorPoint[0] - 5 + 'px';
	        this.divPivot.style.top = this.flowerContainer.height * this.anchorPoint[1] - 10 - 2 + 'px';
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(_ref) {
	      var _this10 = this;
	
	      var time = _ref.time,
	          wind = _ref.wind,
	          scrollY = _ref.scrollY;
	
	      // let destY = ((this.originalPosition.y) + (scrollY.current * -0.3))
	      // this.position.y = destY
	      // if (this.flowerIndex === 0 || this.flowerIndex === 2 || this.flowerIndex === 7) {
	
	      // }
	
	      if (this.isInViewport(scrollY)) {
	        if (!this.isUnmasked && !this.isUnmasking) {
	          this.showMask();
	        }
	
	        var force = wind.force.value + this.wind.force;
	        var speed = wind.speed.value;
	        // console.log(speed)
	        // let maxRotation = this.children[0].data.maxRotation || 0
	        var noForce = this.flowerContainer.children[0].data.noForce;
	        // let maxRotation = 5 * Math.PI / 180
	        this.flowerContainer.rotation = noForce ? 0 : force * 0.3 * Math.PI / 180;
	
	        this.flowerContainer.children[0].children.forEach(function (container) {
	          if (container.children.length > 0) {
	            container.children.forEach(function (sprite) {
	              var data = sprite.data;
	              var maxRotation = data.maxRotation || 0;
	              var mathOscillation = data.mathOscillation || 'cos';
	              var velocity = data.velocity || '0.001';
	              var vx = Date.now() * velocity;
	              //
	              // if (this.wind.speed > 0) {
	              //   vx = this.wind.speed * speed
	              // }
	
	              var noForce = data.noForce;
	              var noise = _this10.simplex.noise2D(Date.now() * 0.0001, 1);
	              var noisyWind = noise * speed;
	
	              sprite.rotation = force * (noForce ? 0.0 : 0.2) * Math.PI / 180 + Math[mathOscillation](speed * noisyWind + vx + _this10.wind.speed * 1) * (Math.PI / 180 * maxRotation);
	            });
	
	            var data = container.data;
	            var maxRotation = data.maxRotation !== undefined ? data.maxRotation : 2;
	            var mathOscillation = data.mathOscillation || 'cos';
	            var velocity = data.velocity || '0.001';
	
	            if (maxRotation) {
	              container.rotation = force * 0.6 * Math.PI / 180 + Math[mathOscillation](Date.now() * (velocity * speed)) * Math.PI / 180 * maxRotation;
	            }
	          } else {
	            var _data = container.data;
	            var _maxRotation = _data.maxRotation !== undefined ? _data.maxRotation : 2;
	            var _mathOscillation = _data.mathOscillation || 'cos';
	            var _velocity = _data.velocity || '0.001';
	
	            if (_maxRotation) {
	              container.rotation = force * 0.6 * Math.PI / 180 + Math[_mathOscillation](Date.now() * (_velocity * speed)) * Math.PI / 180 * _maxRotation;
	            }
	          }
	
	          /**
	          var startRange = 0.98 // your chosen start value
	          var endRange = 1.02 // your chose end value
	          var oscilationRange = (endRange - startRange) / 2
	          var oscilationOffset = oscilationRange + startRange
	           this.flower1__flower1Sprite.scale.set(oscilationOffset + Math.cos(Date.now() * (0.001 * this.wind.speed)) * oscilationRange)
	          this.flower1__flower2Sprite.scale.set(oscilationOffset + Math.sin(Date.now() * (0.001 * this.wind.speed)) * oscilationRange)
	          **/
	        });
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.divFlowers.removeChild(this.divContainer);
	
	      document.body.classList.remove('is-hovered');
	      this.scene.removeChild(this);
	      (0, _get3.default)(Flower.prototype.__proto__ || (0, _getPrototypeOf2.default)(Flower.prototype), 'destroy', this).call(this, {
	        children: true
	      });
	
	      if (this.hideMaskTl) {
	        this.hideMaskTl.kill();
	        this.hideMaskTl.eventCallback('onComplete', null);
	      }
	
	      this.removeListeners();
	    }
	  }]);
	  return Flower;
	}(PIXI.Container);
	
	exports.default = Flower;
	module.exports = exports['default'];

/***/ },

/***/ 203:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(35);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	var _prefix = __webpack_require__(197);
	
	var _prefix2 = _interopRequireDefault(_prefix);
	
	var _math = __webpack_require__(56);
	
	var math = _interopRequireWildcard(_math);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	var _gsap = __webpack_require__(39);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FlowerParticles = function () {
	  function FlowerParticles(opts) {
	    (0, _classCallCheck3.default)(this, FlowerParticles);
	
	    this.bindAll();
	    this.parent = opts.parent;
	    this.size = _Detector2.default.getScreenSize();
	    this.currentFlower = null;
	    this.particles = [];
	    this.particlesClones = [];
	    this.totalParticles = _Detector2.default.isMobile() ? 50 : 70;
	    this.dustBoundsPadding = 20;
	    this.dustBounds = new PIXI.Rectangle(this.dustBoundsPadding, this.dustBoundsPadding, this.size.w - this.dustBoundsPadding * 2, this.size.h - this.dustBoundsPadding * 2);
	
	    var particlesContainerOpts = {
	      scale: true,
	      position: true,
	      rotation: true,
	      uvs: true,
	      alpha: true
	    };
	
	    this.particlesContainer = new PIXI.particles.ParticleContainer(1000, particlesContainerOpts);
	    this.particlesContainer2 = new PIXI.particles.ParticleContainer(1000, particlesContainerOpts);
	
	    this.isShowed = false;
	    this.isShowing = false;
	    this.particlesContainer.alpha = 0;
	    this.particlesContainer2.alpha = 0;
	
	    this.parent.scene.addChild(this.particlesContainer);
	    this.parent.scene.addChild(this.particlesContainer2);
	
	    this.createParticles();
	
	    this.addListeners();
	  }
	
	  (0, _createClass3.default)(FlowerParticles, [{
	    key: 'showParticles',
	    value: function showParticles(flower) {
	      var _this = this;
	
	      if (this.currentFlower === flower.indexFlower) return;
	      this.currentFlower = flower.indexFlower;
	
	      this.canHideParticles = false;
	
	      this.fixtimeout = setTimeout(function () {
	        _this.canHideParticles = true;
	      }, 100);
	
	      this.positionParticles(flower);
	
	      if (this.tweenShow) {
	        this.tweenShow.isActive() && this.tweenShow.kill();
	      }
	
	      if (this.tweenHide) {
	        if (!this.tweenHide.isActive()) {
	          // this.particlesContainer2.alpha = 0
	        }
	      }
	
	      this.tweenShow = _gsap2.default.to(this.particlesContainer, 2, {
	        alpha: 1,
	        ease: Quint.easeOut,
	        onComplete: function onComplete() {}
	      });
	
	      /**
	      if (!this.isHiding) {
	        this.particlesContainer2.alpha = 0
	      }
	      this.isHidden = false
	      // this.tweenHide && this.tweenHide.kill()
	      // this.isHiding = false
	      // this.isHidden = false
	       this.currentFlower = flower.indexFlower
	      this.isShowing = true
	       this.positionParticles(flower)
	       this.particlesContainer.alpha = 0
	       this.tweenShow = TweenMax.to(this.particlesContainer, 2, {
	        alpha: 1,
	        ease: Expo.easeOut,
	        onComplete: () => {
	          console.log(':: on complete this.tweenShow')
	          this.isShowed = true
	          this.isShowing = false
	          this.isHidden = false
	          this.isHiding = false
	        }
	      })
	      */
	    }
	  }, {
	    key: 'hideParticles',
	    value: function hideParticles(flower) {
	      if (!this.canHideParticles) return;
	
	      if (this.tweenShow) {
	        this.tweenShow.isActive() && this.tweenShow.kill();
	      }
	
	      if (this.currentFlower === flower.indexFlower) {
	        this.currentFlower = null;
	
	        for (var i = 0; i < this.particlesClones.length; i++) {
	          var dust = this.particles[i];
	          var dustClone = this.particlesClones[i];
	          dustClone.position.x = dust.position.x;
	          dustClone.position.y = dust.position.y;
	          dustClone.alpha = dust.alpha;
	          dustClone.scale.set(dust.scale.x);
	        }
	      }
	
	      this.particlesContainer.alpha = 0;
	      this.particlesContainer2.alpha = 1;
	
	      this.tweenHide = _gsap2.default.to(this.particlesContainer2, 1.5, {
	        alpha: 0,
	        ease: Expo.easeIn,
	        onComplete: function onComplete() {}
	      });
	
	      /**
	      if (this.isHiding || this.isHidden) return
	       this.currentFlower = null
	      this.tweenShow && this.tweenShow.isActive() && this.tweenShow.kill()
	      this.tweenHide && this.tweenHide.isActive() && this.tweenHide.kill()
	      this.isShowing = false
	       this.isHiding = true
	      this.isHidden = false
	      this.particlesContainer.alpha = 0
	      this.particlesContainer2.alpha = 1
	       for (let i = 0; i < this.particlesClones.length; i++) {
	        let dust = this.particles[i]
	        let dustClone = this.particlesClones[i]
	        dustClone.position.x = dust.position.x
	        dustClone.position.y = dust.position.y
	        dustClone.alpha = dust.alpha
	        dustClone.scale.set(dust.scale.x)
	      }
	       this.tweenHide = TweenMax.to(this.particlesContainer2, 1.5, {
	        alpha: 0,
	        ease: Expo.easeIn,
	        onComplete: () => {
	          console.log(':: on complete this.tweenHide')
	          this.isHidden = true
	          this.isHiding = false
	        }
	      })
	       // if (this.isHiding || this.isHidden) return
	      /**
	       for (let i = 0; i < this.particlesClones.length; i++) {
	        let dust = this.particles[i]
	        let dustClone = this.particlesClones[i]
	        dustClone.position.x = dust.position.x
	        dustClone.position.y = dust.position.y
	        dustClone.alpha = dust.alpha
	        dustClone.scale.set(dust.scale.x)
	      }
	       this.isHiding = true
	       this.timeoutHide && window.clearTimeout(this.timeoutHide)
	       this.particlesContainer.alpha = 0
	      this.particlesContainer2.alpha = 1
	       TweenMax.to(this.particlesContainer2, 2, {
	        alpha: 0,
	        ease: Expo.easeOut,
	        onComplete: () => {
	          this.isHidden = true
	          this.isHiding = false
	          this.isShowed = false
	        }
	      })
	      **/
	    }
	  }, {
	    key: 'bindAll',
	    value: function bindAll() {
	      var _this2 = this;
	
	      ['showParticles', 'hideParticles'].forEach(function (fn) {
	        return _this2[fn] = _this2[fn].bind(_this2);
	      });
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      _Emitter2.default.on('SHOW_PARTICLES', this.showParticles);
	      _Emitter2.default.on('HIDE_PARTICLES', this.hideParticles);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      _Emitter2.default.removeListener('SHOW_PARTICLES', this.showParticles);
	      _Emitter2.default.removeListener('HIDE_PARTICLES', this.hideParticles);
	    }
	  }, {
	    key: 'createParticles',
	    value: function createParticles(particlesContainer) {
	      var _this3 = this;
	
	      for (var i = 0; i < this.totalParticles; i++) {
	        // create a new Sprite
	        var dust = new PIXI.Sprite(PIXI.Texture.fromFrame('little_particle'));
	        // set the anchor point so the texture is centerd on the sprite
	        dust.anchor.set(0.5);
	        // different maggots, different sizes
	        var maxScale = i % 10 === 0 ? 2 : 1;
	        var scale = Math.max(0.04, Math.random() * maxScale);
	        dust.scale.set(scale);
	        // scatter them all
	        dust.position.x = Math.random() * this.size.w;
	        dust.position.y = Math.random() * this.size.h;
	        // create a random direction in radians
	        dust.direction = Math.random() * Math.PI * 2;
	        // this number will be used to modify the direction of the sprite over time
	        dust.turningSpeed = Math.random() - 0.8;
	        // create a random speed between 0 - 2, and these maggots are slooww
	        // dust.speed = (4 + Math.random() * 4) * 0.8
	        dust.speed = scale > 0.08 ? (2 + Math.random() * 2) * 0.3 : (4 + Math.random() * 4) * 0.8;
	        dust.offset = Math.random() * 100;
	        dust.maxAlpha = scale > 0.08 ? Math.random() * 0.3 : Math.random() * 0.8;
	        dust.maxAlpha = Math.max(0.1, dust.maxAlpha);
	        // finally we push the dust into the maggots array so it it can be easily accessed later
	        this.particles.push(dust);
	        this.particlesContainer.addChild(dust);
	      }
	
	      this.particles.forEach(function (dust) {
	        // console.log(dust)
	        var dustClone = new PIXI.Sprite(PIXI.Texture.fromFrame('little_particle'));
	        dustClone.anchor.set(0.5);
	        dustClone.scale.set(dust.scale.x);
	        dustClone.position.x = dust.x;
	        dustClone.position.y = dust.y;
	        dustClone.direction = dust.direction;
	        dustClone.turningSpeed = dust.turningSpeed;
	        dustClone.speed = dust.speed;
	        dustClone.offset = dust.offset;
	        dustClone.maxAlpha = dust.maxAlpha;
	        _this3.particlesClones.push(dustClone);
	        _this3.particlesContainer2.addChild(dustClone);
	      });
	    }
	  }, {
	    key: 'positionParticles',
	    value: function positionParticles(flower) {
	      this.size = {
	        w: flower.width,
	        h: flower.height
	      };
	
	      // this.size.w - this.dustBoundsPadding * 2
	      var space = this.size.w - (this.size.w - this.dustBoundsPadding * 2);
	      var spaceY = this.size.h - (this.size.h - this.dustBoundsPadding * 2);
	      var offsetX = flower.x + this.size.w / 2 - space / 2;
	      var offsetY = flower.y + this.size.h * 0.5;
	      this.dustBounds = new PIXI.Rectangle(offsetX + this.dustBoundsPadding, offsetY, this.size.w - this.dustBoundsPadding * 2, this.size.h * 0.4);
	
	      for (var i = 0; i < this.particles.length; i++) {
	        var dust = this.particles[i];
	        // dust.scale.y = 0.95 + Math.sin(time + dust.offset) * 0.05
	        dust.position.x = offsetX + math.random(-1, 1) * this.size.w * 0.2;
	        dust.position.y = offsetY + math.random(-1, 1) * this.size.h * 0.2;
	
	        // if (this.particlesContainer2.alpha === 0) {
	        //   dustClone.x = dust.x
	        //   dustClone.x = dust.y
	        // }
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(time) {
	      if (this.particlesContainer.alpha === 0 && this.particlesContainer2.alpha === 0) return;
	
	      for (var i = 0; i < this.particles.length; i++) {
	        var dust = this.particles[i];
	        var dustClone = this.particlesClones[i];
	        // dust.scale.set(0.03 + (Math.sin(time * (dust.speed / 10))) * 0.03)
	
	        dust.direction += dust.turningSpeed * 0.05;
	        dust.position.x += Math.sin(dust.direction) * (dust.speed * dust.scale.y);
	        dust.position.y += Math.cos(dust.direction) * (dust.speed * dust.scale.y);
	
	        dust.alpha = Math.max(1, Math.sin(time * dust.turningSpeed) * dust.maxAlpha);
	
	        if (this.particlesContainer2.alpha !== 0) {
	          dustClone.direction += dustClone.turningSpeed * 0.05;
	          dustClone.x += Math.sin(dustClone.direction) * (dustClone.speed * dustClone.scale.y);
	          dustClone.position.y += Math.cos(dustClone.direction) * (dustClone.speed * dustClone.scale.y);
	
	          dustClone.alpha = Math.sin(time * dustClone.turningSpeed) * dustClone.maxAlpha;
	        }
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.tweenShow && this.tweenShow.eventCallback('onComplete', null);
	      this.tweenShow && this.tweenShow.kill();
	      this.tweenHide && this.tweenHide.eventCallback('onComplete', null);
	      this.tweenHide && this.tweenHide.kill();
	      this.removeListeners();
	    }
	  }]);
	  return FlowerParticles;
	}();
	
	exports.default = FlowerParticles;
	module.exports = exports['default'];

/***/ },

/***/ 204:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(352);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(88);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(35);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _howler = __webpack_require__(629);
	
	var _css = __webpack_require__(77);
	
	var CSS = _interopRequireWildcard(_css);
	
	var _math = __webpack_require__(56);
	
	var Utils = _interopRequireWildcard(_math);
	
	var _gsap = __webpack_require__(39);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var instance = null;
	
	var SoundManager = function () {
	  function SoundManager(opts) {
	    (0, _classCallCheck3.default)(this, SoundManager);
	
	    if (!instance) {
	      instance = this;
	      this.soundSprites = opts.soundSprites;
	      this.spriteMap = opts.spriteMap;
	      // this.spriteMap = Object.values(opts.spriteMap)
	
	      this.introFirstPlay = true;
	      this.ambientIsPlaying = false;
	      this.isMobile = _Detector2.default.isMobile();
	      this.howler = null;
	      this.sounds = [];
	      this.bindAll();
	      this.init();
	      this.playingSounds = [];
	      this.muted = false;
	      this.mutedAll = false;
	      this.flowerOverSpriteId = -1;
	    }
	    return instance;
	  }
	
	  (0, _createClass3.default)(SoundManager, [{
	    key: 'addListeners',
	    value: function addListeners() {
	      _Emitter2.default.on('SOUND::PLAYINIT', this.playInitSounds);
	      _Emitter2.default.on('SOUND::PLAY_FLOWER_OVER', this.playFlowerOverSounds);
	      _Emitter2.default.on('SOUND::STOP_FLOWER_OVER', this.stopFlowerOverSounds);
	      _Emitter2.default.on('SOUND::PLAY_FLOWER_CLICK', this.playFlowerClickSounds);
	      _Emitter2.default.on('SOUND::PLAY_UI_CLICK', this.playUIClickSound);
	      _Emitter2.default.on('SOUND::PLAY_NAV_CLICK', this.playNavClickSounds);
	
	      _Emitter2.default.on('SOUND::TOGGLE_SOUND', this.toggleSound);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      _Emitter2.default.removeListener('SOUND::PLAYINIT', this.playInitSounds);
	      _Emitter2.default.removeListener('SOUND::PLAY_FLOWER_OVER', this.playFlowerOverSounds);
	      _Emitter2.default.removeListener('SOUND::STOP_FLOWER_OVER', this.stopFlowerOverSounds);
	      _Emitter2.default.removeListener('SOUND::PLAY_FLOWER_CLICK', this.playFlowerClickSounds);
	      _Emitter2.default.removeListener('SOUND::PLAY_UI_CLICK', this.playUIClickSound);
	      _Emitter2.default.removeListener('SOUND::PLAY_NAV_CLICK', this.playNavClickSounds);
	
	      _Emitter2.default.removeListener('SOUND::TOGGLE_SOUND', this.toggleSound);
	    }
	  }, {
	    key: 'initSounds',
	    value: function initSounds() {
	      var _this = this;
	
	      var mergeSprite = (0, _assign2.default)({}, this.spriteMap.core, this.spriteMap.flowerOver, this.spriteMap.flowerClick, this.spriteMap.uiClick, this.spriteMap.navClick);
	      this.sounds = new _howler.Howl({
	        src: [this.soundSprites],
	        format: ['mp3'],
	        sprite: mergeSprite,
	        volume: 1,
	        onload: function onload() {
	          _this.soundsLoaded = true;
	          _this.playInitSounds();
	        }
	      });
	      this.soundsPlayback = new _howler.Howl({
	        src: [this.soundSprites],
	        format: ['mp3'],
	        sprite: mergeSprite,
	        volume: 1
	      });
	      this.sounds.on('fade', this.onFade);
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      this.addListeners();
	      this.initSounds();
	    }
	  }, {
	    key: 'playInitSounds',
	    value: function playInitSounds(params) {
	      if (this.soundsLoaded && this.isIntro === undefined) return;
	
	      if (params) this.isIntro = params.intro;
	
	      if (!this.soundsLoaded) return;
	
	      if (this.isIntro && this.introFirstPlay) {
	        this.playingSounds.intro = [];
	        this.playingSounds.intro.id = this.sounds.play('intro');
	        this.playingSounds.intro.volume = this.muteAll ? 0 : 0.5;
	        this.sounds.volume(this.playingSounds.intro.volume, this.playingSounds.intro.id);
	        this.introFirstPlay = false;
	      }
	
	      if (!this.ambientIsPlaying) {
	        this.playingSounds.ambient = [];
	        this.playingSounds.ambient.id = this.sounds.play('ambient');
	        this.playingSounds.ambient.volume = this.muteAll ? 0 : 0.2;
	        this.sounds.volume(this.playingSounds.ambient.volume, this.playingSounds.ambient.id);
	        this.ambientIsPlaying = true;
	      }
	    }
	  }, {
	    key: 'playFlowerOverSounds',
	    value: function playFlowerOverSounds() {
	      if (this.muteAll) return;
	      if (this.playingSounds.flowerOver && this.sounds.playing(this.playingSounds.flowerOver.id)) {
	        this.playingSounds['flowerOver--playback'] && this.soundsPlayback.stop(this.playingSounds['flowerOver--playback']);
	        this.playingSounds['flowerOver--playback'] = this.soundsPlayback.play(this.playingSounds.flowerOver.spriteName);
	        // this.soundsPlayback.fade(0.8, 0.0, 800, this.playingSounds['flowerOver--playback'])
	        var currentPos = this.sounds.seek(this.playingSounds.flowerOver.id);
	        this.soundsPlayback.seek(currentPos, this.playingSounds['flowerOver--playback']);
	        this.soundsPlayback.fade(this.sounds.volume(this.playingSounds.flowerOver.id), 0, 800, this.playingSounds['flowerOver--playback']);
	
	        this.sounds.stop(this.playingSounds.flowerOver.id);
	      }
	      this.playSounds('flowerOver');
	    }
	  }, {
	    key: 'stopFlowerOverSounds',
	    value: function stopFlowerOverSounds() {
	      if (this.muteAll) return;
	      if (this.soundsPlayback.playing(this.playingSounds['flowerOver--playback'])) {
	        this.sounds.fade(this.sounds.volume(this.playingSounds.flowerOver.id), 0, 800, this.playingSounds.flowerOver.id);
	      }
	    }
	  }, {
	    key: 'playFlowerClickSounds',
	    value: function playFlowerClickSounds() {
	      this.playSounds('flowerClick');
	    }
	
	    // Joue les son de click
	
	  }, {
	    key: 'playUIClickSound',
	    value: function playUIClickSound() {
	      this.playSounds('uiClick');
	    }
	
	    // Joue les sons au click des btn nav sur la page single-plant
	
	  }, {
	    key: 'playNavClickSounds',
	    value: function playNavClickSounds(_ref) {
	      var direction = _ref.direction;
	
	      var directionSprite = direction === 'prev' ? 1 : 0;
	      this.playSounds('navClick', directionSprite);
	    }
	  }, {
	    key: 'playSounds',
	    value: function playSounds(spriteType, spriteId, randomVol) {
	      if (this.muteAll) return;
	      this.playingSounds[spriteType] = [];
	      this[spriteType + 'Id'] = this[spriteType + 'Id'] || -1;
	      var sprite = spriteId === undefined ? this.getRandomSprite(this[spriteType + 'Id'], spriteType) : spriteId;
	      this.playingSounds[spriteType].spriteName = (0, _keys2.default)(this.spriteMap[spriteType])[sprite];
	      this.playingSounds[spriteType].id = this.sounds.play(this.playingSounds[spriteType].spriteName);
	      this.flowerOverSpriteId = sprite;
	
	      if (randomVol) {
	        this.playingSounds[spriteType].volume = Math.floor(Math.random() * (this.spriteMap.volume[spriteType] - 0.1)) + 0.1;
	      } else {
	        this.playingSounds[spriteType].volume = this.spriteMap.volume[spriteType];
	      }
	      this.sounds.volume(this.playingSounds[spriteType].volume, this.playingSounds[spriteType].id);
	    }
	  }, {
	    key: 'fadeIntro',
	    value: function fadeIntro(volume) {
	      if (!this.playingSounds.intro) return;
	      this.playingSounds.intro.volume = volume;
	      if (this.muteAll) return;
	      if (this.mutedFade) return;
	      this.sounds.volume(this.playingSounds.intro.volume, this.playingSounds.intro.id);
	    }
	  }, {
	    key: 'toggleSound',
	    value: function toggleSound(params) {
	      if (params.sender === 'toggleSound') {
	        this.muteAll = !params.muted;
	      }
	      if (this.muteAll && params.sender !== 'toggleSound') return;
	      this.muted = !params.muted;
	      this.toggle = true;
	      // this.sounds.mute(!hasFocus)
	      // this.soundsPlayback.mute(!hasFocus)
	      // if (hasFocus) {
	      //   console.log('SOUND UNMUTED !!')
	      //   TweenMax.to(this.sounds, 2, {
	      //     volume: 0.5,
	      //     ease: Expo.easeOut
	      //   })
	      // } else {
	      //   console.log('SOUND MUTED --')
	      //   let volume = this.sounds.volume()
	      //   this.sounds.fade(volume, 0, 2000)
	      //   this.soundsPlayback.fade(volume, 0, 2000)
	      // }
	
	      for (var i = 0; i < this.sounds._sounds.length; i++) {
	        var sound = this.sounds._sounds[i];
	        if (!sound._ended) {
	          var spriteName = this.playingSounds[sound._sprite] ? sound._sprite : sound._sprite.substring(0, sound._sprite.length - 1);
	          var volumeDest = params.muted ? this.playingSounds[spriteName].volume : 0;
	          var volumeStart = params.muted ? 0 : this.playingSounds[spriteName].volume;
	          this.sounds.fade(volumeStart, volumeDest, 1300, sound._id);
	        }
	      }
	    }
	  }, {
	    key: 'onFade',
	    value: function onFade(idSound) {
	      if (this.toggle && this.muted) {
	        this.mutedFade = true;
	      } else if (this.toggle) {
	        this.mutedFade = false;
	      }
	      this.toggle = false;
	      // console.log(' ON FADE ', idSound, this.playingSounds.length)
	      // for (var i = 0; i < this.playingSounds.length; i++) {
	      //   console.log('IDSOUND:' + idSound + ' ID:' + this.playingSounds[i])
	      //   if (this.playingSounds[i] === idSound) {
	      //     this.playingSounds[i] = false
	      //   }
	      // }
	    }
	  }, {
	    key: 'getRandomSprite',
	    value: function getRandomSprite(previousSprite, spriteType) {
	      if ((0, _keys2.default)(this.spriteMap[spriteType]).length === 1) {
	        return 0;
	      }
	      var randomSprite = void 0;
	      do {
	        randomSprite = Math.round(Math.random() * ((0, _keys2.default)(this.spriteMap[spriteType]).length - 1));
	      } while (randomSprite === this.flowerOverSpriteId);
	      return randomSprite;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'bindAll',
	    value: function bindAll() {
	      var _this2 = this;
	
	      ['playInitSounds', 'playFlowerOverSounds', 'stopFlowerOverSounds', 'onFade', 'playFlowerClickSounds', 'toggleSound', 'playUIClickSound', 'playNavClickSounds'].forEach(function (fn) {
	        return _this2[fn] = _this2[fn].bind(_this2);
	      });
	    }
	  }]);
	  return SoundManager;
	}();
	
	exports.default = SoundManager;
	module.exports = exports['default'];

/***/ },

/***/ 205:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(357);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(89);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(35);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(106);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(209);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(105);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controlkit = __webpack_require__(359);
	
	var _controlkit2 = _interopRequireDefault(_controlkit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Gui class
	 */
	var Gui = function (_ControlKit) {
	  (0, _inherits3.default)(Gui, _ControlKit);
	
	  /**
	   * constructor function
	   * @param {Object} options Options
	   */
	  function Gui(options) {
	    (0, _classCallCheck3.default)(this, Gui);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Gui.__proto__ || (0, _getPrototypeOf2.default)(Gui)).call(this, options));
	
	    _this.panel = _this.addPanel();
	    return _this;
	  }
	
	  /**
	   * addPanel function
	   * @param {Object} options Options
	   */
	
	
	  (0, _createClass3.default)(Gui, [{
	    key: 'addPanel',
	    value: function addPanel() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return (0, _get3.default)(Gui.prototype.__proto__ || (0, _getPrototypeOf2.default)(Gui.prototype), 'addPanel', this).call(this, (0, _extends3.default)({
	        align: 'left',
	        position: [10, 10],
	        opacity: 0.8,
	        width: 275,
	        ratio: 10,
	        fixed: true
	      }, options));
	    }
	  }, {
	    key: 'destroyGui',
	    value: function destroyGui() {
	      _controlkit2.default.destroy();
	      console.log(this);
	      document.body.removeChild(this._node._element);
	    }
	  }]);
	  return Gui;
	}(_controlkit2.default);
	
	exports.default = Gui;
	module.exports = exports['default'];

/***/ },

/***/ 206:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _SocialShare = __webpack_require__(333);
	
	var _SocialShare2 = _interopRequireDefault(_SocialShare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function install(Vue) {
	  var twttrSharing = function twttrSharing(infos) {};
	  Vue.directive('sharebox', {
	    update: function update(el, params, vnode) {
	      if (params.value) {
	        var service = params.value.service;
	        var opts = params.value.opts;
	        // Add Click Listener
	        var serviceUrl = _SocialShare2.default.network[service].url;
	        el.href = _SocialShare2.default.generateUrl(serviceUrl, opts);
	        // console.log(SocialShare.generateUrl(serviceUrl, opts))
	        // addClickListener()
	        el.clickHandler = _SocialShare2.default.doPopup.bind(el);
	        el.addEventListener('click', el.clickHandler);
	      }
	    },
	    inserted: function inserted(el, params, vnode) {
	      if (params.value) {
	        var service = params.value.service;
	        var opts = params.value.opts;
	        // Add Click Listener
	        var serviceUrl = _SocialShare2.default.network[service].url;
	        el.href = _SocialShare2.default.generateUrl(serviceUrl, opts);
	        // console.log(SocialShare.generateUrl(serviceUrl, opts))
	        // addClickListener()
	        el.clickHandler = _SocialShare2.default.doPopup.bind(el);
	        el.addEventListener('click', el.clickHandler);
	      }
	    },
	    unbind: function unbind(el) {
	      el.removeEventListener('click', el.clickHandler);
	      el.clickHandler = null;
	    }
	  });
	}
	if (window.Vue) {
	  Vue.use(install);
	}
	module.exports = install;

/***/ },

/***/ 207:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCanvas = getCanvas;
	exports.getContext = getContext;
	function getCanvas(w, h) {
	  var canvas = document.createElement('canvas');
	  canvas.width = w || 512;
	  canvas.height = h || 512;
	  return canvas;
	}
	function getContext(canvas, w, h) {
	  canvas = canvas || getCanvas(w, h);
	  canvas.width = w || canvas.width;
	  canvas.height = h || canvas.height;
	  return canvas.getContext('2d');
	}

/***/ },

/***/ 264:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 316:
/***/ function(module, exports) {

	module.exports = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 otherMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nvoid main(void)\n{\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n   vTextureCoord = aTextureCoord;\n   vFilterCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n}\n"

/***/ },

/***/ 317:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(335),
	  /* template */
	  __webpack_require__(752),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 318:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(341),
	  /* template */
	  __webpack_require__(744),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 319:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(627)
	
	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(342),
	  /* template */
	  __webpack_require__(748),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 321:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(88);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(35);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	var _css = __webpack_require__(77);
	
	var CSS = _interopRequireWildcard(_css);
	
	var _math = __webpack_require__(56);
	
	var Utils = _interopRequireWildcard(_math);
	
	var _gsap = __webpack_require__(39);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	var _MaskFilter = __webpack_require__(132);
	
	var _MaskFilter2 = _interopRequireDefault(_MaskFilter);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _SoundManager = __webpack_require__(204);
	
	var _SoundManager2 = _interopRequireDefault(_SoundManager);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cover = function () {
	  function Cover(opts) {
	    (0, _classCallCheck3.default)(this, Cover);
	
	    this.size = opts.size;
	    this.renderer = opts.renderer;
	    this.resources = opts.resources;
	    this.scene = opts.scene;
	    this.offsetHeight = 0;
	    this.prefix = CSS.getPrefix();
	    this.isHidden = true;
	    this.isReady = false;
	    this.soundManager = new _SoundManager2.default();
	
	    this.isMobile = _Detector2.default.isMobile();
	
	    this.scrollY = {
	      dest: 0,
	      current: 0
	    };
	
	    this.oldPosition = 0;
	
	    this.dom = {
	      coverSection: document.querySelector('.cover-section'),
	      // coverSpacer: document.querySelector('.cover-spacer'),
	      coverContainer: document.querySelector('.cover-section .cover-container'),
	      coverJardins: document.querySelector('.cover-section .cover-container__jardins'),
	      coverGradient: document.querySelector('.cover-section .cover-container__background-gradient'),
	      coverTitle: document.querySelector('.cover-section .cover-container__title'),
	      coverCta: document.querySelector('.cover-section .cover-container__cta'),
	      coverForeground: document.querySelector('.cover-section .cover-container__foreground'),
	      coverForegroundPlantLeft: document.querySelector('.cover-section .cover-container__foreground .foreground__plant-left'),
	      coverForegroundPlantRight: document.querySelector('.cover-section .cover-container__foreground .foreground__plant-right')
	    };
	
	    this.bounds = {
	      originalBackgroundCoverSize: null,
	      coverSection: null,
	      coverJardins: null,
	      coverContainer: null,
	      coverForeground: null,
	      coverForegroundPlantLeft: null,
	      coverForegroundPlantRight: null
	    };
	
	    this.motions = {
	      easePlantLeft: 0,
	      easePlantRight: 0,
	      rotationPlantLeft: 0,
	      rotationPlantRight: 0,
	      maxRotationPlantLeft: -20,
	      maxRotationPlantRight: 15,
	      maxTitleOpacity: 1,
	      minTitleOpacity: 0.2,
	      minCTAOpacity: 0,
	      maxCTAOpacity: 1,
	      maxTitleScale: 1,
	      minTitleScale: 0.85,
	      titleOpacity: 0,
	      titleScale: 0,
	      ctaOpacity: 1,
	      introSoundVolume: 0.5
	    };
	
	    this.renderTextureMask = PIXI.RenderTexture.create(this.size.w, this.size.h);
	
	    this.container = new PIXI.Container();
	    this.scene.addChild(this.container);
	
	    this.createBackground();
	    this.createMask();
	  }
	
	  (0, _createClass3.default)(Cover, [{
	    key: 'createBackground',
	    value: function createBackground() {
	      this.backgroundBlack = new PIXI.Graphics();
	      this.backgroundBlack.beginFill(0x091726);
	      this.backgroundBlack.drawRect(0, 0, this.size.w, this.size.h);
	      this.backgroundBlack.endFill();
	      this.container.addChild(this.backgroundBlack);
	
	      this.backgroundCover = new PIXI.Sprite(PIXI.Texture.fromFrame('homer_cover_jardins'));
	      this.backgroundCover.anchor.set(0.5);
	      this.bounds.originalBackgroundCoverSize = {
	        width: this.backgroundCover.texture.width,
	        height: this.backgroundCover.texture.height,
	        ratio: this.backgroundCover.texture.width / this.backgroundCover.texture.height
	      };
	      this.container.addChild(this.backgroundCover);
	
	      // this.jardinsSprite = new PIXI.Sprite(PIXI.Texture.fromFrame('home_logo_jardins'))
	      // this.jardinsSprite.anchor.set(0.5)
	      // this.bounds.originalJardinsSize = {
	      //   width: this.jardinsSprite.texture.width,
	      //   height: this.jardinsSprite.texture.height,
	      //   ratio: this.jardinsSprite.texture.width / this.jardinsSprite.texture.height
	      // }
	      // this.backgroundCover.addChild(this.jardinsSprite)
	    }
	  }, {
	    key: 'createMask',
	    value: function createMask() {
	      var _this = this;
	
	      this.maskCoverBg = new PIXI.Graphics();
	      this.maskCoverBg.beginFill(0x000000);
	      this.maskCoverBg.drawRect(0, 0, this.size.w, this.size.h);
	      this.maskCoverBg.endFill();
	
	      this.thresholdSprite = new PIXI.Sprite(PIXI.Texture.fromFrame('threshold'));
	      this.thresholdSprite.width = this.size.w;
	      this.thresholdSprite.height = this.size.h;
	
	      var maskCoverContainer = new PIXI.Container();
	      maskCoverContainer.addChild(this.maskCoverBg);
	      maskCoverContainer.addChild(this.thresholdSprite);
	
	      this.renderer.render(maskCoverContainer, this.renderTextureMask);
	
	      this.maskCoverSprite = new PIXI.Sprite(this.renderTextureMask);
	      this.maskCoverSprite.width = this.size.w;
	      this.maskCoverSprite.height = this.size.h;
	
	      this.maskCoverFilter = new _MaskFilter2.default(this.maskCoverSprite);
	      this.backgroundCover.filters = [this.maskCoverFilter];
	
	      this.container.addChild(this.maskCoverSprite);
	
	      if (window.APP_ALREADY_INIT) {
	        this.maskCoverFilter.uniforms.alpha = 0;
	        var tl = new TimelineMax({
	          onComplete: function onComplete() {
	            _this.backgroundCover.filters = null;
	            _this.container.removeChild(_this.maskCoverSprite);
	            // document.body.classList.remove('locked')
	            // document.body.classList.remove('black')
	            // document.body.classList.add('beige')
	          }
	        });
	        tl.to(this.maskCoverFilter.uniforms, 1.5, {
	          alpha: 1,
	          ease: Cubic.easeOut
	        }, 'start');
	        tl.from(this.dom.coverJardins, 1, {
	          autoAlpha: 0,
	          scale: 0.95,
	          ease: Sine.easeOut
	        }, 'start+=0.2');
	        _gsap2.default.set(this.dom.coverTitle, {
	          scale: this.motions.minTitleScale,
	          opacity: this.motions.minTitleOpacity
	        });
	
	        // this.container.oldCacheAsBitmap = true
	        // this.backgroundCover.cacheAsBitmap = true
	
	        this.isReady = true;
	        document.body.classList.remove('locked');
	        document.body.classList.remove('black');
	        document.body.classList.add('beige');
	      } else {
	        this.maskCoverFilter.uniforms.alpha = 0;
	
	        document.body.classList.add('locked');
	
	        this.showCoverSection();
	
	        _gsap2.default.to(this.maskCoverFilter.uniforms, 3, {
	          alpha: 1,
	          ease: Cubic.easeOut,
	          onComplete: function onComplete() {
	            window.APP_ALREADY_INIT = true;
	            _this.backgroundCover.filters = null;
	            _this.container.removeChild(_this.maskCoverSprite);
	            // this.container.oldCacheAsBitmap = true
	            // this.backgroundCover.cacheAsBitmap = true
	
	            document.body.classList.remove('black');
	            document.body.classList.add('beige');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'showCoverSection',
	    value: function showCoverSection() {
	      var _this2 = this;
	
	      _gsap2.default.set(this.dom.coverTitle, {
	        scale: this.motions.minTitleScale,
	        opacity: this.motions.minTitleOpacity
	      });
	
	      this.showDom();
	      var tl = new TimelineMax({
	        onStart: function onStart() {
	          // SOUND PLAY INTRO
	          _Emitter2.default.emit('SOUND::PLAYINIT', { intro: true });
	        },
	        onComplete: function onComplete() {}
	      });
	
	      tl.addLabel('start', '+=1.5');
	
	      tl.from(this.dom.coverJardins, 3, {
	        autoAlpha: 0,
	        scale: 0.95,
	        ease: Sine.easeOut,
	        onComplete: function onComplete() {
	          _this2.isReady = true;
	          document.body.classList.remove('locked');
	        }
	      }, 'start+=0.2')
	      // .from(this.dom.coverGradient, 1, {
	      //   autoAlpha: 0,
	      //   ease: Cubic.easeInOut
	      // }, 0)
	      .staggerFrom([this.dom.coverCta.children], 2, {
	        autoAlpha: 0,
	        y: -10,
	        ease: Cubic.easeOut
	      }, -0.1);
	      // .to(this.dom.coverSection, 1, {
	      //   autoAlpha: 1,
	      //   ease: Expo.easeOut,
	      //   onComplete: () => {
	      //     this.isReady = true
	      //     document.body.classList.remove('locked')
	      //     document.body.classList.remove('black')
	      //     document.body.classList.add('beige')
	      //   }
	      // }, 'start')
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds() {
	      this.bounds.coverContainer = CSS.getSize(this.dom.coverContainer);
	      // this.bounds.coverSpacer = CSS.getSize(this.dom.coverSpacer)
	      this.bounds.coverContainer.top = this.dom.coverContainer.offsetTop;
	
	      this.bounds.coverForegroundPlantLeft = CSS.getSize(this.dom.coverForegroundPlantLeft);
	      this.bounds.coverForegroundPlantLeft.top = this.dom.coverForegroundPlantLeft.offsetTop;
	      this.bounds.coverForegroundPlantLeft.left = this.dom.coverForegroundPlantLeft.offsetLeft;
	
	      this.bounds.coverForegroundPlantRight = CSS.getSize(this.dom.coverForegroundPlantRight);
	      this.bounds.coverForegroundPlantRight.top = this.dom.coverForegroundPlantRight.offsetTop;
	      this.bounds.coverForegroundPlantRight.right = this.size.w - (this.dom.coverForegroundPlantRight.offsetLeft + this.bounds.coverForegroundPlantRight.width);
	    }
	  }, {
	    key: 'positionDom',
	    value: function positionDom() {
	      this.dom.coverContainer.style.top = this.size.h + 'px';
	
	      var size = Math.min(this.size.h * 0.6, this.isMobile ? this.size.w * 0.75 : 650);
	      var halfSize = size / 2;
	      this.dom.coverJardins.style.height = size + 'px';
	      this.dom.coverJardins.style.width = size + 'px';
	
	      this.dom.coverJardins.style.top = -this.size.h + this.size.h / 2 - halfSize + 'px';
	      this.dom.coverJardins.style.left = this.size.w / 2 - halfSize + 'px';
	
	      // this.dom.coverSpacer.style.top = `${this.dom.coverContainer.offsetTop + this.dom.coverContainer.offsetHeight}px`
	    }
	  }, {
	    key: 'positionBackgroundCover',
	    value: function positionBackgroundCover() {
	      var ratioBox = this.size.w / this.size.h;
	
	      if (ratioBox < this.bounds.originalBackgroundCoverSize.ratio) {
	        var ratioH = this.size.h / this.bounds.originalBackgroundCoverSize.height;
	        this.backgroundCover.scale.set(ratioH);
	      } else {
	        var ratioW = this.size.w / this.bounds.originalBackgroundCoverSize.width;
	        this.backgroundCover.scale.set(ratioW);
	      }
	
	      this.backgroundCover.position.x = this.size.w / 2;
	      this.backgroundCover.position.y = this.size.h / 2;
	
	      // let ratioH = Math.min(this.size.h / this.bounds.originalBackgroundCoverSize.height, (this.size.h * 0.85) / this.bounds.originalBackgroundCoverSize.height)
	      // this.jardinsSprite.scale.set(ratioH)
	
	      this.backgroundBlack.width = this.size.w;
	      this.backgroundBlack.height = this.size.h;
	      // if (ratioBox < this.bounds.originalJardinsSize.ratio) {
	      //
	      // } else {
	      //   let ratioW = Math.min(this.size.w / this.bounds.originalBackgroundCoverSize.width, (this.size.w * 0.8) / this.bounds.originalBackgroundCoverSize.width)
	      //   this.jardinsSprite.scale.set(ratioW)
	      // }
	    }
	  }, {
	    key: 'showDom',
	    value: function showDom() {
	      if (!this.isHidden) return;
	
	      this.isHidden = false;
	      this.dom.coverSection.classList.remove('is-hidden');
	    }
	  }, {
	    key: 'hideDom',
	    value: function hideDom() {
	      if (this.isHidden) return;
	
	      this.isHidden = true;
	      this.dom.coverSection.classList.add('is-hidden');
	    }
	  }, {
	    key: 'update',
	    value: function update(_ref) {
	      var time = _ref.time,
	          scrollY = _ref.scrollY;
	
	      if (!this.isReady) return;
	      this.scrollY = scrollY;
	
	      var limitIn = this.bounds.coverContainer.top - this.size.h;
	      var limitOut = limitIn + this.bounds.coverContainer.height + (this.size.h / 2 - this.bounds.coverContainer.height / 2);
	      var limitOutVp = limitIn + this.bounds.coverContainer.height + this.size.h;
	
	      var vp = this.scrollY.current >= limitIn && this.scrollY.current <= limitOutVp;
	      if (vp && this.isReady) {
	        this.showDom();
	        // this.dom.coverSection.style[this.prefix] = CSS.getTransform(-this.scrollY.current)
	
	        if (this.oldPosition !== -this.scrollY.current) {
	          this.oldPosition = -this.scrollY.current;
	          this.dom.coverSection.style[this.prefix] = CSS.getMatrixTransform(0, this.oldPosition);
	        }
	
	        // // this.jardinsSprite.position.y = (-this.scrollY.current * 0.1)
	        var norm = Utils.clamp((this.scrollY.current - limitIn - this.size.h / 3) / (limitOut - this.size.h / 3), 0, 1);
	        var multiplier = this.isMobile ? 4 : 1.5;
	
	        var xLeft = -norm * (this.bounds.coverForegroundPlantLeft.left * multiplier);
	        var xRight = norm * (this.bounds.coverForegroundPlantRight.right * multiplier);
	
	        var leftRotation = norm * this.motions.maxRotationPlantLeft;
	        var rightRotation = norm * this.motions.maxRotationPlantRight;
	
	        this.motions.easePlantLeft += (xLeft - this.motions.easePlantLeft) * 0.15;
	        this.motions.easePlantLeft = Utils.round(this.motions.easePlantLeft);
	
	        this.motions.easePlantRight += (xRight - this.motions.easePlantRight) * 0.15;
	        this.motions.easePlantRight = Utils.round(this.motions.easePlantRight);
	
	        this.motions.rotationPlantLeft += (leftRotation - this.motions.rotationPlantLeft) * 0.1;
	        this.motions.rotationPlantRight += (rightRotation - this.motions.rotationPlantRight) * 0.1;
	
	        this.dom.coverForegroundPlantLeft.style[this.prefix] = CSS.getMatrixTransform(this.motions.easePlantLeft, 0, 1, this.motions.rotationPlantLeft);
	        this.dom.coverForegroundPlantRight.style[this.prefix] = CSS.getMatrixTransform(this.motions.easePlantRight, 0, 1, this.motions.rotationPlantRight);
	
	        var opacityTitle = this.motions.minTitleOpacity + norm * (this.motions.maxTitleOpacity - this.motions.minTitleOpacity);
	        this.motions.titleOpacity += (opacityTitle - this.motions.titleOpacity) * 0.15;
	        //
	        var scaleTitle = this.motions.minTitleScale + norm * (this.motions.maxTitleScale - this.motions.minTitleScale);
	        this.motions.titleScale += (scaleTitle - this.motions.titleScale) * 0.15;
	
	        if (this.motions.titleOpacity < 1) {
	          var stylesTitle = {};
	          stylesTitle[this.prefix] = CSS.getMatrixTransform(0, 0, this.motions.titleScale);
	          stylesTitle.opacity = Utils.round(this.motions.titleOpacity, 1e3);
	
	          (0, _assign2.default)(this.dom.coverTitle.style, stylesTitle);
	        }
	
	        //
	        // // this.dom.coverTitle.style[this.prefix] = CSS.getTransform(0, 0, 0, this.motions.titleScale)
	        //
	
	        var normFade = Utils.clamp((this.scrollY.current - limitIn - this.size.h / 3) / limitOut, 0, 1);
	        var introFade = 0.5 - normFade * 0.5;
	        this.motions.introSoundVolume += (introFade - this.motions.introSoundVolume) * 0.15;
	        this.soundManager.fadeIntro(this.motions.introSoundVolume);
	
	        var normOpacity = Utils.clamp((this.scrollY.current - limitIn) / (limitOut - this.size.h / 3), 0, 1);
	        var opacityCTA = 1 - normOpacity * this.motions.maxCTAOpacity;
	        this.motions.ctaOpacity += (opacityCTA - this.motions.ctaOpacity) * 0.15;
	
	        var alpha = Utils.round(this.motions.ctaOpacity, 1e3);
	
	        if (alpha > 0) {
	          this.dom.coverCta.style.opacity = alpha;
	
	          this.backgroundCover.alpha = Utils.clamp(alpha, 0.1, 1);
	
	          var stylesJardins = {};
	          stylesJardins[this.prefix] = CSS.getMatrixTransform(0, -this.scrollY.current * 0.1);
	          stylesJardins.opacity = alpha;
	
	          (0, _assign2.default)(this.dom.coverJardins.style, stylesJardins);
	        }
	        // TweenMax.set(this.dom.coverTitle, {
	        //   // scale: this.motions.titleScale
	        //   opacity: this.motions.titleOpacity
	        // })
	      } else {
	        // this.hideDom()
	        if (this.oldPosition !== -limitOutVp) {
	          this.oldPosition = -limitOutVp;
	          this.dom.coverSection.style[this.prefix] = CSS.getMatrixTransform(0, this.oldPosition);
	          this.soundManager.fadeIntro(0);
	        }
	      }
	    }
	  }, {
	    key: 'resize',
	    value: function resize(size) {
	      if (this.container.oldCacheAsBitmap) this.container.cacheAsBitmap = false;
	      this.size = size;
	
	      this.positionBackgroundCover();
	
	      this.positionDom();
	      this.getBounds();
	
	      this.offsetHeight = this.size.h;
	      this.offsetHeight += this.bounds.coverContainer.height;
	      // this.offsetHeight += this.bounds.coverSpacer.height
	
	      if (this.container.oldCacheAsBitmap) this.container.cacheAsBitmap = true;
	    }
	  }]);
	  return Cover;
	}();
	
	exports.default = Cover;
	module.exports = exports['default'];

/***/ },

/***/ 322:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FILTER_TYPES = {
	  'AFFAMÉ': 1,
	  'AFFREUX': 3,
	  'BALLONNÉ': 2,
	  'BLESSÉ': 7,
	  'ENRHUMÉ': 6,
	  'NAUSÉEUX': 8,
	  'RAPLAPLA': 0,
	  'STRESSÉ': 5,
	  'SUANT': 4
	};
	
	exports.default = FILTER_TYPES;
	module.exports = exports['default'];

/***/ },

/***/ 323:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(88);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(35);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	var _css = __webpack_require__(77);
	
	var CSS = _interopRequireWildcard(_css);
	
	var _math = __webpack_require__(56);
	
	var Utils = _interopRequireWildcard(_math);
	
	var _gsap = __webpack_require__(39);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	__webpack_require__(264);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Filters = function () {
	  function Filters(opts) {
	    (0, _classCallCheck3.default)(this, Filters);
	
	    this.size = opts.size;
	    this.resources = opts.resources;
	    this.offsetHeight = 0;
	    this.coverBounds = null;
	    this.isHidden = true;
	    this.isMenuTransparent = true;
	
	    this.isMobile = _Detector2.default.isMobile();
	
	    this.prefix = CSS.getPrefix();
	
	    this.scrollY = {
	      dest: 0,
	      current: 0
	    };
	
	    this.dom = {
	      filtersSection: document.querySelector('.filters-section'),
	      filtersContainer: document.querySelector('.filters-section .filters-container'),
	      filtersLeftPart: document.querySelector('.filters-section .filters__column--left'),
	      filtersRightPart: document.querySelector('.filters-section .filters__column--right'),
	      filtersQuestion: document.querySelector('.filters-section .filters__question'),
	      filtersChoices: document.querySelector('.filters-section .filters__choices')
	    };
	
	    this.bounds = {
	      filtersSection: null,
	      filtersContainer: null
	    };
	
	    this.motions = {};
	  }
	
	  (0, _createClass3.default)(Filters, [{
	    key: 'getBounds',
	    value: function getBounds() {
	      this.bounds.filtersContainer = CSS.getSize(this.dom.filtersContainer);
	      this.bounds.filtersContainer.top = this.dom.filtersContainer.offsetTop;
	
	      this.bounds.filtersChoices = CSS.getSize(this.dom.filtersChoices);
	    }
	  }, {
	    key: 'positionDom',
	    value: function positionDom() {
	      this.dom.filtersContainer.style.top = this.coverBounds.top + this.coverBounds.height + 'px';
	    }
	  }, {
	    key: 'showDom',
	    value: function showDom() {
	      if (!this.isHidden) return;
	
	      this.isHidden = false;
	      this.dom.filtersSection.classList.remove('is-hidden');
	    }
	  }, {
	    key: 'hideDom',
	    value: function hideDom() {
	      if (this.isHidden) return;
	
	      this.isHidden = true;
	      this.dom.filtersSection.classList.add('is-hidden');
	    }
	  }, {
	    key: 'update',
	    value: function update(_ref) {
	      var time = _ref.time,
	          scrollY = _ref.scrollY;
	
	      this.scrollY = scrollY;
	
	      var limitIn = this.bounds.filtersContainer.top - this.size.h;
	      var limitOutVp = limitIn + this.offsetHeight + this.size.h;
	
	      var vp = this.scrollY.current >= limitIn && this.scrollY.current <= limitOutVp;
	
	      if (vp) {
	        this.showDom();
	        if (this.oldPosition !== -this.scrollY.current) {
	          this.oldPosition = -this.scrollY.current;
	          this.dom.filtersSection.style[this.prefix] = CSS.getMatrixTransform(0, this.oldPosition);
	        }
	        // this.dom.filtersQuestion.style[this.prefix] = CSS.getMatrixTransform(0, (-this.scrollY.current * 0.1))
	      } else {
	        if (this.oldPosition !== -limitOutVp) {
	          this.oldPosition = -limitOutVp;
	          this.dom.filtersSection.style[this.prefix] = CSS.getMatrixTransform(0, this.oldPosition);
	        }
	        // this.hideDom()
	      }
	
	      limitIn = this.bounds.filtersContainer.top;
	      var limitOut = limitIn + this.offsetHeight - this.size.h;
	      vp = this.scrollY.current >= limitIn && this.scrollY.current <= limitOut;
	      if (vp) {
	        this.dom.filtersLeftPart.style[this.prefix] = CSS.getMatrixTransform(0, this.scrollY.current - limitIn);
	        this.setMenuWhite();
	      } else {
	        // this.dom.filtersLeftPart.style[this.prefix] = CSS.getMatrixTransform(0, this.scrollY.current - limitIn)
	
	        if (this.scrollY.current <= limitIn) {
	          this.setMenuTransparent();
	        }
	      }
	
	      // // limitOutVp = limitIn + this.offsetHeight - this.size.h - this.bounds.filtersContainer.paddingTop
	      //
	      // vp = this.scrollY.current >= limitIn &&
	      // this.scrollY.current <= limitOut
	      // if (vp) {
	      //   this.dom.filtersSection.style[this.prefix] = CSS.getMatrixTransform(0, (-this.bounds.filtersContainer.top))
	      //
	      //   let norm = Utils.clamp((this.scrollY.current - limitIn) / (limitOut), 0, 1)
	      //   let scroll = this.scrollY.current - limitIn
	      //   this.dom.filtersChoices.style[this.prefix] = CSS.getMatrixTransform(0, -scroll)
	      //
	      //   this.lockPosition = true
	      //   this.setMenuWhite()
	      // } else {
	      //   this.addOffset = false
	      //
	      //   if (this.scrollY.current <= limitIn) {
	      //     this.setMenuTransparent()
	      //     this.dom.filtersChoices.style[this.prefix] = ''
	      //   }
	      //
	      //   if (this.scrollY.current >= limitOut) {
	      //     this.addOffset = true
	      //
	      //     if (this.scrollY.current <= limitOut) {
	      //       this.dom.filtersSection.style[this.prefix] = CSS.getMatrixTransform(0, (-this.scrollY.current + this.offsetHeight))
	      //     }
	      //   }
	      //
	      //   this.lockPosition = false
	      //   // this.dom.filtersSection.style[this.prefix] = ''
	      // }
	      //   if (!this.lockPosition) {
	      //     this.lockedPosition = -this.scrollY.current
	      //   }
	      //
	      //   this.lockPosition = true
	      //   let norm = Utils.clamp((this.scrollY.current - limitIn) / (limitOut), 0, 1)
	      //   let scroll = this.scrollY.current - limitIn
	      //   this.dom.filtersRightPart.style[this.prefix] = CSS.getMatrixTransform(0, -scroll)
	      //   this.dom.filtersSection.style[this.prefix] = CSS.getMatrixTransform(0, this.lockedPosition)
	      //
	      //   this.setMenuWhite()
	      // } else if (this.scrollY.current < limitIn) {
	      //   // this.dom.filtersRightPart.style[this.prefix] = ''
	      //   this.lockPosition = false
	      //   this.setMenuTransparent()
	      // } else {
	      //   this.lockPosition = false
	      // }
	    }
	  }, {
	    key: 'setMenuWhite',
	    value: function setMenuWhite() {
	      if (!this.isMenuTransparent) return;
	
	      this.isMenuTransparent = false;
	      _Emitter2.default.emit('HIDE_MENU');
	    }
	  }, {
	    key: 'setMenuTransparent',
	    value: function setMenuTransparent() {
	      if (this.isMenuTransparent) return;
	
	      this.isMenuTransparent = true;
	      _Emitter2.default.emit('SET_MENU_TRANSPARENT');
	    }
	  }, {
	    key: 'resize',
	    value: function resize(size, coverBounds) {
	      this.size = size;
	      this.coverBounds = coverBounds;
	
	      this.positionDom();
	      this.getBounds();
	
	      var padding = this.bounds.filtersContainer.paddingTop;
	      var hW = this.size.w / 2 - padding;
	      var hH = Utils.clamp(this.size.h * 0.8, 300, this.isMobile ? 400 : 600);
	
	      var leftStyle = {
	        position: 'absolute',
	        top: padding + 'px',
	        left: padding + 'px',
	        width: hW + 'px',
	        height: this.size.h - padding * 2 + 'px'
	      };
	
	      var rightStyle = {
	        position: 'absolute',
	        top: padding + 'px',
	        right: padding + 'px',
	        width: hW + 'px'
	        // height: `${hH}px`
	      };
	
	      (0, _assign2.default)(this.dom.filtersLeftPart.style, leftStyle);
	      (0, _assign2.default)(this.dom.filtersRightPart.style, rightStyle);
	      // this.dom.filtersChoices.style.paddingTop = `${hH / 5}px`
	
	      this.getBounds();
	      this.offsetHeight = this.bounds.filtersChoices.height;
	      // this.offsetFakeHeight = hH
	      this.dom.filtersContainer.style.minHeight = this.offsetHeight + 'px';
	    }
	  }]);
	  return Filters;
	}();
	
	exports.default = Filters;
	module.exports = exports['default'];

/***/ },

/***/ 324:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(35);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	var _css = __webpack_require__(77);
	
	var CSS = _interopRequireWildcard(_css);
	
	var _math = __webpack_require__(56);
	
	var Utils = _interopRequireWildcard(_math);
	
	var _gsap = __webpack_require__(39);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	var _MaskFilter = __webpack_require__(132);
	
	var _MaskFilter2 = _interopRequireDefault(_MaskFilter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeFooter = function () {
	  function HomeFooter(opts) {
	    (0, _classCallCheck3.default)(this, HomeFooter);
	
	    this.size = opts.size;
	    this.offsetHeight = 0;
	    this.startTop = 0;
	    this.prefix = CSS.getPrefix();
	    this.isHidden = true;
	    this.isReady = false;
	
	    // console.log(CSS.getMatrixTransform(100, 20, 2, 30))
	
	    this.isMobile = _Detector2.default.isMobile();
	
	    this.scrollY = {
	      dest: 0,
	      current: 0
	    };
	
	    this.dom = {
	      footerSection: document.querySelector('.home-footer'),
	      footerContainer: document.querySelector('.home-footer .home-footer__container')
	    };
	
	    this.bounds = {
	      footerSection: null,
	      footerContainer: null
	    };
	
	    this.oldPosition = 0;
	
	    this.motions = {
	      easePlantLeft: 0,
	      easePlantRight: 0,
	      rotationPlantLeft: 0,
	      rotationPlantRight: 0,
	      maxRotationPlantLeft: -20,
	      maxRotationPlantRight: 15,
	      maxTitleOpacity: 1,
	      minTitleOpacity: 0.2,
	      minCTAOpacity: 0,
	      maxCTAOpacity: 1,
	      maxTitleScale: 1,
	      minTitleScale: 0.85,
	      titleOpacity: 0,
	      titleScale: 0,
	      ctaOpacity: 1
	    };
	  }
	
	  (0, _createClass3.default)(HomeFooter, [{
	    key: 'getBounds',
	    value: function getBounds() {
	      this.bounds.footerContainer = CSS.getSize(this.dom.footerContainer);
	      this.bounds.footerContainer.top = this.startTop;
	    }
	  }, {
	    key: 'positionDom',
	    value: function positionDom() {
	      // 6230
	      // 5657
	      // 573
	      // console.log((this.startTop) * 0.1)
	      this.dom.footerContainer.style.top = this.startTop + 'px';
	    }
	  }, {
	    key: 'showDom',
	    value: function showDom() {
	      if (!this.isHidden) return;
	
	      this.isHidden = false;
	      this.dom.footerSection.classList.remove('is-hidden');
	    }
	  }, {
	    key: 'hideDom',
	    value: function hideDom() {
	      if (this.isHidden) return;
	
	      this.isHidden = true;
	      this.dom.footerSection.classList.add('is-hidden');
	    }
	  }, {
	    key: 'update',
	    value: function update(_ref) {
	      var time = _ref.time,
	          scrollY = _ref.scrollY;
	
	      this.scrollY = scrollY;
	
	      // this.scrollY.current = this.scrollY.current
	
	      var limitIn = this.bounds.footerContainer.top - this.size.h;
	      var limitOutVp = limitIn + this.bounds.footerContainer.height + this.size.h;
	
	      var vp = this.scrollY.current >= limitIn && this.scrollY.current <= limitOutVp;
	      if (vp) {
	        this.showDom();
	        if (this.oldPosition !== -this.scrollY.current) {
	          this.oldPosition = -this.scrollY.current;
	          this.dom.footerSection.style[this.prefix] = CSS.getMatrixTransform(0, this.oldPosition);
	        }
	      } else {
	        if (this.oldPosition !== -limitOutVp) {
	          this.oldPosition = -limitOutVp;
	          this.dom.footerSection.style[this.prefix] = CSS.getMatrixTransform(0, this.oldPosition);
	        }
	
	        // this.hideDom()
	      }
	    }
	  }, {
	    key: 'resize',
	    value: function resize(size, startTop) {
	      this.size = size;
	      this.startTop = startTop;
	
	      this.getBounds();
	      this.positionDom();
	
	      this.offsetHeight = this.bounds.footerContainer.height;
	    }
	  }]);
	  return HomeFooter;
	}();
	
	exports.default = HomeFooter;
	module.exports = exports['default'];

/***/ },

/***/ 325:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(35);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	var _vue = __webpack_require__(201);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	var _css = __webpack_require__(77);
	
	var CSS = _interopRequireWildcard(_css);
	
	var _math = __webpack_require__(56);
	
	var Utils = _interopRequireWildcard(_math);
	
	var _canvas = __webpack_require__(207);
	
	var Canvas = _interopRequireWildcard(_canvas);
	
	var _simplexNoise = __webpack_require__(199);
	
	var _simplexNoise2 = _interopRequireDefault(_simplexNoise);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _Cover = __webpack_require__(321);
	
	var _Cover2 = _interopRequireDefault(_Cover);
	
	var _Filters = __webpack_require__(323);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _HomeFooter = __webpack_require__(324);
	
	var _HomeFooter2 = _interopRequireDefault(_HomeFooter);
	
	var _Flower = __webpack_require__(202);
	
	var _Flower2 = _interopRequireDefault(_Flower);
	
	var _FlowerParticles = __webpack_require__(203);
	
	var _FlowerParticles2 = _interopRequireDefault(_FlowerParticles);
	
	var _Gui = __webpack_require__(205);
	
	var _Gui2 = _interopRequireDefault(_Gui);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Scene = function () {
	  function Scene() {
	    var _this = this;
	
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, Scene);
	
	    this.container = opts.container;
	    this.prefix = CSS.getPrefix();
	    this.size = _Detector2.default.getScreenSize();
	    this.simplex = new _simplexNoise2.default();
	    this.scrollY = {
	      dest: 0,
	      current: 0
	    };
	
	    this.params = {
	      alphaMask: {
	        value: 1,
	        range: [0, 1]
	      },
	      debug: false,
	      toggleMask: false,
	      toggleBackground: false
	    };
	    this.wind = {
	      force: {
	        value: 5,
	        range: [-45, 90]
	      },
	      speed: {
	        value: 1,
	        range: [-5, 10]
	      }
	    };
	
	    this.createGrid();
	    this.toggleDebugMode();
	
	    // regular scene creation
	    this.scene = new PIXI.Container();
	
	    var pixelRatio = window.devicePixelRatio || 1;
	
	    PIXI.settings.RESOLUTION = pixelRatio;
	    PIXI.settings.RENDER_OPTIONS.autoResize = false;
	
	    var noWebgl = _Detector2.default.isWindow7();
	    // eslint-disable-next-line new-cap
	    this.renderer = new PIXI.autoDetectRenderer(this.size.w, this.size.h, {
	      transparent: true,
	      autoResize: false,
	      resolution: pixelRatio
	    }, noWebgl);
	
	    this.renderer.isCanvas = this.renderer instanceof PIXI.CanvasRenderer;
	
	    this.renderer.plugins.interaction.autoPreventDefault = false;
	    this.renderer.plugins.interaction.interactionFrequency = 1000;
	    this.renderer.view.style['-ms-content-zooming'] = 'auto';
	    this.renderer.view.style['-ms-touch-action'] = 'auto';
	    this.renderer.view.style['touch-action'] = 'auto';
	
	    this.container.appendChild(this.renderer.view);
	
	    this.resources = window.loaderManager.resources;
	    this.flowersData = this.resources['flowers'].data;
	
	    _vue2.default.nextTick(function () {
	      _this.init();
	    });
	  }
	
	  (0, _createClass3.default)(Scene, [{
	    key: 'bindAll',
	    value: function bindAll() {
	      var _this2 = this;
	
	      ['getFilteredItems', 'resetFilter'].forEach(function (fn) {
	        return _this2[fn] = _this2[fn].bind(_this2);
	      });
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      _Emitter2.default.on('CLICK_FILTER', this.getFilteredItems);
	      _Emitter2.default.on('FILTERS:RESET', this.resetFilter);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      _Emitter2.default.removeListener('CLICK_FILTER', this.getFilteredItems);
	      _Emitter2.default.removeListener('FILTERS:RESET', this.resetFilter);
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      this.bindAll();
	      this.addListeners();
	      this.createCover();
	      this.createFilters();
	      this.createHomeFooter();
	      this.createFlowers();
	    }
	  }, {
	    key: 'createGrid',
	    value: function createGrid() {
	      var _this3 = this;
	
	      this.grid = {
	        row: 1,
	        itemsByRow: function itemsByRow() {
	          switch (_this3.size.BP) {
	            case 'mobile':
	            case 'xs-tablet':
	              return 1;
	            case 'tablet':
	              return 3;
	            default:
	              return 5;
	          }
	        },
	        column: function column() {
	          switch (_this3.size.BP) {
	            case 'mobile':
	            case 'xs-tablet':
	              return 1;
	            case 'tablet':
	              return 2;
	            default:
	              return 3;
	          }
	        },
	        maxWidth: 1260,
	        maxHeight: function maxHeight() {
	          switch (_this3.size.BP) {
	            case 'mobile':
	            case 'xs-tablet':
	              return _this3.size.h * 0.7;
	            case 'tablet':
	              return _this3.size.h * 0.8;
	            default:
	              return 850;
	          }
	          // return this.size.w > 1280 ? 850 : this.size.h * 0.5
	        },
	        startTop: 0
	      };
	    }
	
	    // return this.size.w > 1280 ? 3 : 2
	    // return this.size.w > 1280 ? 5 : 3
	
	  }, {
	    key: 'createCover',
	    value: function createCover() {
	      this.coverComp = new _Cover2.default({
	        resources: this.resources,
	        scene: this.scene,
	        renderer: this.renderer,
	        size: this.size
	      });
	    }
	  }, {
	    key: 'createHomeFooter',
	    value: function createHomeFooter() {
	      this.homeFooterComp = new _HomeFooter2.default({
	        size: this.size
	      });
	    }
	  }, {
	    key: 'createFilters',
	    value: function createFilters() {
	      this.filtersComp = new _Filters2.default({
	        resources: this.resources,
	        size: this.size
	      });
	    }
	  }, {
	    key: 'createParticles',
	    value: function createParticles() {
	      this.flowerParticles = new _FlowerParticles2.default({
	        parent: this
	      });
	    }
	  }, {
	    key: 'createFlowers',
	    value: function createFlowers() {
	      var _this4 = this;
	
	      var divFlowers = document.createElement('div');
	      divFlowers.classList.add('flowers');
	      this.container.appendChild(divFlowers);
	
	      var index = 0;
	
	      this.flowers = [];
	      this.filteredFlowers = [];
	      this.flowersData.forEach(function (data) {
	        var flower = new _Flower2.default({
	          index: index,
	          resources: _this4.resources,
	          data: data,
	          scene: _this4.scene,
	          renderer: _this4.renderer
	        });
	
	        _this4.flowers.push(flower);
	        index++;
	      });
	
	      // this.createParticles()
	
	      this.flowersDiv = document.querySelector('.flowers');
	
	      this.isReady = true;
	      this.resize(_Detector2.default.getScreenSize());
	      // Emitter.emit('GET_RESIZE')
	
	      // this.size = Detector.getScreenSize()
	
	      // Emitter.emit('GET_RESIZE')
	      _vue2.default.nextTick(function () {
	        if (_this4.goToFilters && window.APP_ALREADY_INIT) {
	          setTimeout(function () {
	            _this4.resetFilter();
	          }, 1000);
	        }
	      });
	
	      // this.gui()
	    }
	  }, {
	    key: 'getFilteredItems',
	    value: function getFilteredItems(_ref) {
	      var filterId = _ref.filterId;
	
	      var scrollToItem = false;
	      var filteredItems = [];
	      this.flowers.forEach(function (flower, i) {
	        flower.desopacifyFlower();
	
	        if (Utils.isInArray(flower.filtersArray, filterId)) {
	          filteredItems.push(flower);
	          // if (!this.scrollToItem) {
	          //   this.scrollToItem = flower.y - (this.size.h) / 2
	          // }
	        } else {
	          flower.opacifyFlower();
	          // flower.flowerContainer.alpha = 0.3
	        }
	      });
	
	      var mobile = void 0;
	      switch (this.size.BP) {
	        case 'mobile':
	        case 'xs-tablet':
	          mobile = true;
	          break;
	        default:
	          mobile = false;
	          break;
	      }
	
	      if (mobile) {
	        var flower = filteredItems[0];
	        scrollToItem = flower.y - (this.size.h - flower.height) / 2;
	      } else {
	        if (filteredItems.length > 1) {
	          var flower1 = filteredItems[0];
	          var flower2 = filteredItems[1];
	          var top = flower1.y > flower2.y ? flower2.y : flower1.y;
	          var bottom = void 0;
	          var b1 = void 0;
	          var b2 = void 0;
	          var yDiff = void 0;
	          if (top === flower1.y) {
	            b1 = top + flower1.height;
	            yDiff = flower2.y - top;
	            b2 = top + yDiff + flower2.height;
	          } else {
	            b1 = top + flower2.height;
	            yDiff = flower1.y - top;
	            b2 = top + yDiff + flower1.height;
	          }
	
	          bottom = b1 > b2 ? b1 : b2;
	          var height = bottom - top;
	
	          scrollToItem = top - (this.size.h - height) / 2;
	        } else {
	          var _flower = filteredItems[0];
	          scrollToItem = _flower.y - (this.size.h - _flower.height) / 2;
	        }
	      }
	
	      window.scrollTo(0, scrollToItem);
	      filteredItems = [];
	    }
	  }, {
	    key: 'resetFilter',
	    value: function resetFilter() {
	      this.flowers.forEach(function (flower, i) {
	        flower.desopacifyFlower();
	      });
	
	      window.scrollTo(0, this.grid.startTop);
	    }
	
	    /**
	     * gui function
	     */
	
	  }, {
	    key: 'gui',
	    value: function gui() {
	      var _this5 = this;
	
	      this.guiInstance = new _Gui2.default();
	      this.guiInstance.panel.addGroup({ label: 'Mask', enable: true }).addSlider(this.params.alphaMask, 'value', 'range', {
	        label: 'Alpha',
	        dp: 3,
	        onChange: function onChange() {
	          _this5.flowers.forEach(function (flower, i) {
	            return flower.setAlphaMask(_this5.params.alphaMask.value);
	          });
	        }
	      }).addGroup({ label: 'Wind', enable: false }).addSlider(this.wind.force, 'value', 'range', { label: 'Force ', dp: 1 }).addSlider(this.wind.speed, 'value', 'range', { label: 'Speed', dp: 3 }).addGroup({ label: 'Debug', enable: false }).addCheckbox(this.params, 'debug', {
	        label: 'Debug mode',
	        onChange: function onChange() {
	          _this5.toggleDebugMode();
	        }
	      }).addCheckbox(this.params, 'toggleMask', {
	        label: 'Toggle mask',
	        onChange: function onChange() {
	          if (_this5.params.toggleMask) {
	            _this5.flowers.forEach(function (flower, i) {
	              flower.createMask();
	            });
	            _this5.resize();
	          } else {
	            _this5.flowers.forEach(function (flower, i) {
	              return flower.removeMask();
	            });
	          }
	        }
	      }).addCheckbox(this.params, 'toggleBackground', {
	        label: 'Toggle black background',
	        onChange: function onChange() {
	          if (_this5.params.toggleBackground) {
	            _this5.container.style.backgroundColor = '#000';
	          } else {
	            _this5.container.style.backgroundColor = '';
	          }
	        }
	      });
	    }
	  }, {
	    key: 'toggleDebugMode',
	    value: function toggleDebugMode() {
	      if (this.params.debug) {
	        this.container.classList.add('debug');
	      } else {
	        this.container.classList.remove('debug');
	      }
	    }
	  }, {
	    key: 'scroll',
	    value: function scroll(vars) {
	      if (!this.isReady) return;
	      this.scrollY.dest = vars.target;
	      this.scrollY.current = Utils.round(vars.current);
	      this.scrollY.offset = 0;
	    }
	  }, {
	    key: 'resize',
	    value: function resize(size) {
	      var _this6 = this;
	
	      var paddingtop = 50;
	      var paddingBottom = 100;
	      this.size = size;
	      if (PIXI.settings.RESOLUTION) {
	        this.renderer.resize(this.size.w, this.size.h);
	      } else {
	        this.renderer.view.width = '' + this.size.w;
	        this.renderer.view.height = '' + this.size.h;
	      }
	      this.renderer.view.style.width = this.size.w + 'px';
	      this.renderer.view.style.height = this.size.h + 'px';
	
	      if (this.isReady) {
	        this.coverComp.resize(this.size);
	        this.filtersComp.resize(this.size, this.coverComp.bounds.coverContainer);
	
	        var item = 0;
	        var itemsByRow = this.grid.itemsByRow();
	        this.grid.row = 0;
	        this.grid.currentCol = 0;
	        this.grid.startTop = 0;
	        this.grid.startTop = this.coverComp.offsetHeight + this.filtersComp.offsetHeight;
	
	        this.flowers.forEach(function (flower, i) {
	          if (item % _this6.grid.itemsByRow() === 0) {
	            _this6.grid.row++;
	          }
	
	          flower.resize(_this6.size, i, _this6.grid);
	
	          item++;
	
	          if (i % (itemsByRow * 2) === 0 || i % (itemsByRow * 2) === itemsByRow) {
	            _this6.grid.currentCol++;
	          } else {
	            if (i % (itemsByRow * 2) < itemsByRow) {
	              if ((i - 1) % 2) _this6.grid.currentCol++;
	              // console.log('model 1 : ', i, (i - 1) % 2)
	            } else {
	              if (i % 2) _this6.grid.currentCol++;
	              // console.log('model 2 : ', i, i % 2)
	            }
	
	            // console.log((i) % 2)
	            // this.grid.currentCol++
	          }
	
	          if (_this6.grid.currentCol > _this6.grid.column() - 1) _this6.grid.currentCol = 0;
	        });
	
	        this.offsetHeight = this.grid.row * Math.min(this.size.h, this.grid.maxHeight()) + paddingtop + paddingBottom;
	
	        // let offsetFilters = this.filtersComp.offsetHeight
	        var footerTop = this.coverComp.offsetHeight + this.filtersComp.offsetHeight + this.offsetHeight;
	        this.homeFooterComp.resize(this.size, footerTop);
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(time) {
	      var _this7 = this;
	
	      if (this.isReady) {
	        this.coverComp.update({ time: time, scrollY: this.scrollY });
	        this.filtersComp.update({ time: time, scrollY: this.scrollY });
	
	        this.scene.position.y = -this.scrollY.current;
	        // if (!this.filtersComp.lockPosition) {
	        //
	        //   if (this.filtersComp.addOffset) {
	        //     this.scrollY.offset = this.filtersComp.offsetHeight
	        //     this.scene.position.y += this.scrollY.offset
	        //   }
	        // } else {
	        //   this.scene.position.y = -this.filtersComp.bounds.filtersContainer.top
	        // }
	
	        // this.flowerParticles.update(time)
	        this.flowers.forEach(function (flower, i) {
	          flower.update({ time: time, wind: _this7.wind, scrollY: _this7.scrollY });
	        });
	
	        this.homeFooterComp.update({ time: time, scrollY: this.scrollY });
	      }
	
	      this.renderer.render(this.scene);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.removeListeners();
	      this.guiInstance && this.guiInstance.destroyGui();
	      // this.flowerParticles.destroy()
	      this.flowers.forEach(function (flower, i) {
	        return flower.destroy();
	      });
	      this.scene.destroy({
	        children: true
	      });
	      this.renderer.destroy(true);
	    }
	  }]);
	  return Scene;
	}();
	
	exports.default = Scene;
	module.exports = exports['default'];

/***/ },

/***/ 326:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(35);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _gsap = __webpack_require__(39);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	__webpack_require__(623);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var instance = null;
	
	var LoaderManager = function () {
	  function LoaderManager(opts) {
	    (0, _classCallCheck3.default)(this, LoaderManager);
	
	    if (!instance) {
	      instance = this;
	      this.loader = new PIXI.loaders.Loader();
	      this.resources = {};
	      this.files = [];
	
	      this.isShowed = true;
	
	      this.dom = {
	        el: document.querySelector('.loader'),
	        background: document.querySelector('.loader .loader__background'),
	        percent: document.querySelector('.loader .loader__percent'),
	        logo: document.querySelector('.loader .loader__logo')
	      };
	
	      this.bindAll();
	      this.addListeners();
	    }
	    return instance;
	  }
	
	  (0, _createClass3.default)(LoaderManager, [{
	    key: 'addListeners',
	    value: function addListeners() {
	      var _this = this;
	
	      _Emitter2.default.on('LOADER::SHOW', this.showLoader);
	      _Emitter2.default.on('LOADER::HIDE', this.hideLoader);
	      _Emitter2.default.on('LOADER::UPDATE_PERCENT', this.updatePercent);
	      _Emitter2.default.on('LOADER::ADD_FILES', this.addFiles);
	
	      this.loader.onProgress.add(function (_ref) {
	        var progress = _ref.progress;
	
	        _this.updatePercent(progress);
	      });
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {}
	  }, {
	    key: 'bindAll',
	    value: function bindAll() {
	      var _this2 = this;
	
	      ['showLoader', 'hideLoader', 'updatePercent', 'addFiles'].forEach(function (fn) {
	        return _this2[fn] = _this2[fn].bind(_this2);
	      });
	    }
	  }, {
	    key: 'addFiles',
	    value: function addFiles(files) {
	      var _this3 = this;
	
	      files.forEach(function (file, i) {
	        _this3.files.push(file);
	      });
	    }
	  }, {
	    key: 'loadAll',
	    value: function loadAll(cb) {
	      var _this4 = this;
	
	      this.showLoader();
	
	      this.files.forEach(function (file, i) {
	        _this4.loader.add(file);
	      });
	
	      this.loader.load(function (loader, resources) {
	        _this4.resources = resources;
	        _this4.hideLoader(cb);
	      });
	    }
	  }, {
	    key: 'updatePercent',
	    value: function updatePercent(value) {
	      this.dom.percent.innerHTML = Math.round(value) + '%';
	    }
	  }, {
	    key: 'showLoader',
	    value: function showLoader() {
	      if (this.isShowed) return;
	
	      this.isShowed = true;
	      this.dom.el.style.display = '';
	    }
	  }, {
	    key: 'resetCSS',
	    value: function resetCSS() {
	      this.dom.background.style.transformOrigin = '';
	      this.dom.background.style.transform = '';
	      this.dom.percent.style.transform = this.dom.percent.style.visibility = this.dom.percent.style.opacity = '';
	      this.dom.logo.style.transform = this.dom.logo.style.visibility = this.dom.logo.style.opacity = '';
	    }
	  }, {
	    key: 'hideLoader',
	    value: function hideLoader(cb) {
	      var _this5 = this;
	
	      if (!this.isShowed) return;
	
	      this.isShowed = false;
	      var tl = new TimelineMax({
	        onComplete: function onComplete() {
	          _this5.dom.el.style.display = 'none';
	          _this5.resetCSS();
	          if (cb) {
	            cb();
	          }
	        }
	      });
	      tl.to(this.dom.percent, 0.6, {
	        y: 50,
	        autoAlpha: 0,
	        ease: Quint.easeOut,
	        onComplete: function onComplete() {}
	      }, 'start').to(this.dom.logo, 0.6, {
	        autoAlpha: 0,
	        ease: Quint.easeOut
	      }, 'start+=0.1').to([this.dom.background], 0.8, {
	        autoAlpha: 0,
	        ease: Cubic.easeOut
	      }, 'start+=0.4');
	    }
	  }]);
	  return LoaderManager;
	}();
	
	exports.default = LoaderManager;
	module.exports = exports['default'];

/***/ },

/***/ 327:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(35);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	var _css = __webpack_require__(77);
	
	var CSS = _interopRequireWildcard(_css);
	
	var _math = __webpack_require__(56);
	
	var Utils = _interopRequireWildcard(_math);
	
	var _canvas = __webpack_require__(207);
	
	var Canvas = _interopRequireWildcard(_canvas);
	
	var _simplexNoise = __webpack_require__(199);
	
	var _simplexNoise2 = _interopRequireDefault(_simplexNoise);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _Flower = __webpack_require__(202);
	
	var _Flower2 = _interopRequireDefault(_Flower);
	
	var _FlowerParticles = __webpack_require__(203);
	
	var _FlowerParticles2 = _interopRequireDefault(_FlowerParticles);
	
	var _Gui = __webpack_require__(205);
	
	var _Gui2 = _interopRequireDefault(_Gui);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SingleScene = function () {
	  function SingleScene() {
	    var _this = this;
	
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, SingleScene);
	
	    this.container = opts.container;
	    this.flowersData = opts.flowersData;
	    this.prefix = CSS.getPrefix();
	    this.size = _Detector2.default.getScreenSize();
	    this.simplex = new _simplexNoise2.default();
	    this.scrollY = {
	      dest: 0,
	      current: 0
	    };
	    this.isAlreadyInit = false;
	
	    this.params = {
	      alphaMask: {
	        value: 1,
	        range: [0, 1]
	      },
	      debug: false,
	      toggleMask: false,
	      toggleBackground: false
	    };
	    this.wind = {
	      force: {
	        value: 5,
	        range: [-45, 90]
	      },
	      speed: {
	        value: 1,
	        range: [-5, 10]
	      }
	    };
	    this.toggleDebugMode();
	
	    // regular scene creation
	    this.scene = new PIXI.Container();
	
	    var pixelRatio = window.devicePixelRatio || 1;
	
	    PIXI.settings.RESOLUTION = pixelRatio;
	    PIXI.settings.RENDER_OPTIONS.autoResize = false;
	
	    var noWebgl = _Detector2.default.isWindow7();
	
	    // eslint-disable-next-line new-cap
	    this.renderer = new PIXI.autoDetectRenderer(this.size.w, this.size.h, {
	      transparent: true,
	      autoResize: false,
	      resolution: pixelRatio
	    }, noWebgl);
	
	    this.renderer.isCanvas = this.renderer instanceof PIXI.CanvasRenderer;
	
	    this.renderer.plugins.interaction.autoPreventDefault = false;
	    this.renderer.view.style['-ms-content-zooming'] = 'auto';
	    this.renderer.view.style['-ms-touch-action'] = 'auto';
	    this.renderer.view.style['touch-action'] = 'auto';
	
	    this.container.appendChild(this.renderer.view);
	
	    this.resources = window.loaderManager.resources;
	
	    setTimeout(function () {
	      _this.init();
	    }, 0);
	    // this.loadResources()
	  }
	
	  (0, _createClass3.default)(SingleScene, [{
	    key: 'loadResources',
	    value: function loadResources() {
	      var _this2 = this;
	
	      this.loader = PIXI.loader;
	      // this.loader.reset()
	
	      this.loader.load(function (loader, resources) {
	        _this2.resources = resources;
	        _this2.loadSpritesheets();
	      });
	    }
	  }, {
	    key: 'loadSpritesheets',
	    value: function loadSpritesheets() {
	      var _this3 = this;
	
	      var flower = this.flowersData;
	      this.loader.add('/static/assets/img/spritesheets/' + flower.id + '_' + flower.title + '.json');
	
	      this.loader.load(function (loader, resources) {
	        _this3.resources = resources;
	        _this3.bindAll();
	        _this3.addListeners();
	        _this3.createFlower();
	      });
	    }
	  }, {
	    key: 'bindAll',
	    value: function bindAll() {
	      // ['getFilteredItems']
	      //     .forEach((fn) => (this[fn] = this[fn].bind(this)))
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {}
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {}
	  }, {
	    key: 'init',
	    value: function init() {
	      this.bindAll();
	      this.addListeners();
	      this.createFlower();
	    }
	  }, {
	    key: 'createParticles',
	    value: function createParticles() {
	      this.flowerParticles = new _FlowerParticles2.default({
	        parent: this
	      });
	    }
	  }, {
	    key: 'createFlower',
	    value: function createFlower() {
	      var divFlowers = void 0;
	      var index = 0;
	
	      if (!this.isAlreadyInit) {
	        divFlowers = document.createElement('div');
	        divFlowers.classList.add('flowers');
	        this.container.appendChild(divFlowers);
	
	        this.createParticles();
	      }
	
	      this.flower = new _Flower2.default({
	        isSingle: true,
	        index: index,
	        resources: this.resources,
	        data: this.flowersData,
	        scene: this.scene,
	        renderer: this.renderer
	      });
	
	      if (!this.isAlreadyInit) {
	        this.flowersDiv = document.querySelector('.flowers');
	      }
	
	      this.isReady = true;
	
	      _Emitter2.default.emit('GET_RESIZE');
	    }
	
	    /**
	     * gui function
	     */
	
	  }, {
	    key: 'gui',
	    value: function gui() {
	      var _this4 = this;
	
	      this.guiInstance = new _Gui2.default();
	      this.guiInstance.panel.addGroup({ label: 'Mask', enable: true }).addSlider(this.params.alphaMask, 'value', 'range', {
	        label: 'Alpha',
	        dp: 3,
	        onChange: function onChange() {
	          _this4.flowers.forEach(function (flower, i) {
	            return flower.setAlphaMask(_this4.params.alphaMask.value);
	          });
	        }
	      }).addGroup({ label: 'Wind', enable: false }).addSlider(this.wind.force, 'value', 'range', { label: 'Force ', dp: 1 }).addSlider(this.wind.speed, 'value', 'range', { label: 'Speed', dp: 3 }).addGroup({ label: 'Debug', enable: false }).addCheckbox(this.params, 'debug', {
	        label: 'Debug mode',
	        onChange: function onChange() {
	          _this4.toggleDebugMode();
	        }
	      }).addCheckbox(this.params, 'toggleMask', {
	        label: 'Toggle mask',
	        onChange: function onChange() {
	          if (_this4.params.toggleMask) {
	            _this4.flowers.forEach(function (flower, i) {
	              flower.createMask();
	            });
	            _this4.resize();
	          } else {
	            _this4.flowers.forEach(function (flower, i) {
	              return flower.removeMask();
	            });
	          }
	        }
	      }).addCheckbox(this.params, 'toggleBackground', {
	        label: 'Toggle black background',
	        onChange: function onChange() {
	          if (_this4.params.toggleBackground) {
	            _this4.container.style.backgroundColor = '#000';
	          } else {
	            _this4.container.style.backgroundColor = '';
	          }
	        }
	      });
	    }
	  }, {
	    key: 'toggleDebugMode',
	    value: function toggleDebugMode() {
	      if (this.params.debug) {
	        this.container.classList.add('debug');
	      } else {
	        this.container.classList.remove('debug');
	      }
	    }
	  }, {
	    key: 'scroll',
	    value: function scroll(vars) {
	      if (!this.isReady) return;
	      this.scrollY.dest = vars.target;
	      this.scrollY.current = Utils.round(vars.current);
	
	      // this.flowersDiv.style[this.prefix] = CSS.getTransform(-this.scrollY.current)
	      // this.scene.position.y = -this.scrollY.current
	    }
	  }, {
	    key: 'resize',
	    value: function resize(size) {
	      this.size = size;
	
	      this.renderer.resize(this.size.w, this.size.h);
	      this.renderer.view.style.width = this.size.w + 'px';
	      this.renderer.view.style.height = this.size.h + 'px';
	
	      if (this.isReady) {
	        this.flower.resize(this.size);
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(time) {
	      if (this.isReady) {
	        this.flowerParticles.update(time);
	        this.flower.update({ time: time, wind: this.wind, scrollY: this.scrollY });
	      }
	
	      this.renderer.render(this.scene);
	    }
	  }, {
	    key: 'updateFlower',
	    value: function updateFlower(data) {
	      var _this5 = this;
	
	      if (!this.flower) return;
	      this.isAlreadyInit = true;
	
	      // if (this.loaderUpdate) {
	      //   this.loaderUpdate.reset()
	      //   this.loaderUpdate = null
	      // }
	
	      this.flowersData = data;
	
	      // this.loaderUpdate = new PIXI.loaders.Loader()
	      // this.loaderUpdate.add(`/static/assets/img/spritesheets/${this.flowersData.id}_${this.flowersData.title}.json`)
	
	      if (this.renderer.isCanvas) {
	        this.oldFlower = this.flower;
	        this.oldFlower.destroy();
	        this.oldFlower = null;
	        this.isReady = true;
	      } else {
	        if (this.oldFlower) {
	          this.oldFlower.destroy();
	          this.oldFlower = null;
	          this.isReady = true;
	        }
	
	        this.oldFlower = this.flower;
	        this.oldFlower.hideMask(function () {
	          if (_this5.oldFlower) {
	            // this.isReady = false
	            _this5.oldFlower.destroy();
	            _this5.oldFlower = null;
	          }
	        });
	      }
	
	      this.isReady = false;
	      this.createFlower();
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.removeListeners();
	      this.guiInstance && this.guiInstance.destroyGui();
	      this.flowerParticles.destroy();
	      this.flower.destroy();
	      this.scene.destroy({
	        children: true
	      });
	      this.renderer.destroy(true);
	      // this.loader.reset()
	    }
	  }]);
	  return SingleScene;
	}();
	
	exports.default = SingleScene;
	module.exports = exports['default'];

/***/ },

/***/ 328:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(89);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(106);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(105);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import glslify from 'glslify'
	
	var opacifyVS = __webpack_require__(316);
	var opacifyFS = __webpack_require__(726);
	
	var OpacifyFilter = function (_PIXI$Filter) {
	  (0, _inherits3.default)(OpacifyFilter, _PIXI$Filter);
	
	  function OpacifyFilter() {
	    (0, _classCallCheck3.default)(this, OpacifyFilter);
	
	    var opacifyMatrix = new PIXI.Matrix();
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (OpacifyFilter.__proto__ || (0, _getPrototypeOf2.default)(OpacifyFilter)).call(this, opacifyVS, opacifyFS));
	
	    _this.resolution = PIXI.settings.RESOLUTION;
	    // sprite.renderable = false
	
	    // this.maskSprite = sprite
	    // this.maskMatrix = opacifyMatrix
	    return _this;
	  }
	
	  // apply (filterManager, input, output) {
	  //   const maskSprite = this.maskSprite
	  //
	  //   this.uniforms.mask = maskSprite._texture
	  //   this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite)
	  //
	  //   filterManager.applyFilter(this, input, output)
	  // }
	
	
	  return OpacifyFilter;
	}(PIXI.Filter);
	
	exports.default = OpacifyFilter;
	module.exports = exports['default'];

/***/ },

/***/ 329:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(208);
	
	var _vue = __webpack_require__(201);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(757);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _domready = __webpack_require__(612);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _VueShareBox = __webpack_require__(206);
	
	var _VueShareBox2 = _interopRequireDefault(_VueShareBox);
	
	var _vueAnalytics = __webpack_require__(732);
	
	var _vueAnalytics2 = _interopRequireDefault(_vueAnalytics);
	
	var _LoaderManager = __webpack_require__(326);
	
	var _LoaderManager2 = _interopRequireDefault(_LoaderManager);
	
	var _App = __webpack_require__(742);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	var _router = __webpack_require__(330);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.loaderManager = new _LoaderManager2.default();
	var isOld = _Detector2.default.isOld();
	
	console.log('%c Codé avec 🌸 par %cUpian.com', 'background: #000; color: #fff; padding: 5px', 'font-weight:bold; background: #000; color: #fff; padding: 5px; padding-left:0');
	
	(0, _domready2.default)(function () {
	  if (isOld) {
	    document.querySelector('.loader').style.display = 'none';
	    document.querySelector('#outdated').style.display = 'block';
	
	    return;
	  } else {
	    WebFont.load({
	      custom: {
	        families: ['ChronicleTextG1-Roman', 'ChronicleTextG1-Italic', 'Lato-Light', 'Lato-Regular', 'Lato-Medium']
	      },
	      active: function active() {
	        init();
	      }
	    });
	  }
	});
	
	function init() {
	  var ids = [{
	    id: 'UA-93069661-1'
	  }, {
	    id: 'UA-22971293-10',
	    name: 'clientTracker'
	  }];
	
	  _vue2.default.use(_vueAnalytics2.default, { ids: ids, router: _router.router });
	  _vue2.default.use(_vueResource2.default);
	  _vue2.default.use(_VueShareBox2.default);
	  /* eslint-disable no-new */
	  var app = new _vue2.default({
	    // store,
	    router: _router.router,
	    render: function render(h) {
	      return h(_App2.default);
	    }
	  }).$mount('#app');
	
	  window.APP = {
	    router: _router.router
	  };
	}
	
	// let app = new App({
	//   container: document.querySelector('.app')
	// })

/***/ },

/***/ 330:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.router = undefined;
	
	var _vue = __webpack_require__(201);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(758);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(331);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = exports.router = new _vueRouter2.default({
	  scrollBehavior: function scrollBehavior() {
	    return false;
	  },
	  mode: 'history',
	  routes: _routes2.default // short for routes: routes
	});

/***/ },

/***/ 331:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(737);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(738);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(733);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  path: '/',
	  component: _index2.default,
	  name: 'home',
	  beforeEnter: function beforeEnter(to, from, next) {
	    document.body.classList.remove('beige');
	    document.body.classList.add('black');
	    next();
	  }
	}, {
	  path: '/plante/:slug',
	  component: _index4.default,
	  name: 'single-plant',
	  beforeEnter: function beforeEnter(to, from, next) {
	    document.body.classList.remove('black');
	    document.body.classList.add('beige');
	    next();
	  }
	}, {
	  path: '/apropos',
	  component: _index6.default,
	  name: 'about',
	  beforeEnter: function beforeEnter(to, from, next) {
	    document.body.classList.remove('black');
	    document.body.classList.add('beige');
	    next();
	  }
	}, {
	  path: '*',
	  redirect: '/'
	}];
	module.exports = exports['default'];

/***/ },

/***/ 332:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakpoints = [1800, 1050, 800, 600, 400, 0];
	var breakpointsName = ['hd', 'medium', 'desktop', 'tablet', 'xs-tablet', 'mobile'];
	
	exports.default = {
	  detect: function detect(w) {
	    var lastSize = 0;
	    var done = false;
	    breakpoints = breakpoints.sort(function (a, b) {
	      return b - a;
	    });
	
	    for (var bp in breakpoints) {
	      if (w >= breakpoints[bp] && w < breakpoints[bp - 1]) {
	        switch (breakpoints[bp]) {
	          case 0:
	            return 'mobile';
	          case 400:
	            return 'xs-tablet';
	          case 600:
	          case 800:
	            return 'tablet';
	          case 1050:
	            return 'desktop';
	          case 1800:
	            return 'hd';
	        }
	      }
	    }
	
	    if (w >= breakpoints[0]) {
	      return 'hd';
	    }
	  },
	
	  isSmallerThan: function isSmallerThan(width, breakpoint) {
	    var equals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    var index = breakpointsName.indexOf(breakpoint);
	
	    if (equals) {
	      return width <= breakpoints[index];
	    } else {
	      return width < breakpoints[index];
	    }
	  },
	  isBiggerThan: function isBiggerThan(width, breakpoint) {
	    var equals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    var index = breakpointsName.indexOf(breakpoint);
	
	    if (equals) {
	      return width >= breakpoints[index];
	    } else {
	      return width > breakpoints[index];
	    }
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 333:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(133);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  network: {
	    'facebook': {
	      url: 'http://www.facebook.com/sharer.php?u={url}&t={title}'
	    },
	    'facebook_dialog': {
	      url: 'https://www.facebook.com/dialog/share?app_id={app_id}&display=page&href={url}&redirect_uri={redirect_url}'
	    },
	    'twitter': {
	      // url: 'https://twitter.com/share?text={text}&url={url}'
	      url: 'https://twitter.com/intent/tweet?hashtags={hashtags}&text={text}&url={url}&via={via}'
	
	    },
	    'reddit': {
	      url: 'http://reddit.com/submit?url={url}&title={title}'
	    }
	  },
	  generateSocialUrls: function generateSocialUrls(opt) {
	    if ((typeof opt === 'undefined' ? 'undefined' : (0, _typeof3.default)(opt)) !== 'object') {
	      return false;
	    }
	    var links = [];
	    var network = void 0;
	    for (var i = 0; i < this.Networks.length; i++) {
	      network = this.Networks[i];
	      links.push({
	        name: network.name,
	        class: network.class,
	        url: this.generateUrl(network.url, opt)
	      });
	    }
	    return links;
	  },
	  generateUrl: function generateUrl(url, opt) {
	    var prop = void 0;
	    var arg = void 0;
	    var argNe = void 0;
	
	    for (prop in opt) {
	      arg = '{' + prop + '}';
	      if (url.indexOf(arg) !== -1) {
	        url = url.replace(new RegExp(arg, 'g'), encodeURIComponent(opt[prop]));
	      }
	      argNe = '{' + prop + '-ne}';
	      if (url.indexOf(argNe) !== -1) {
	        url = url.replace(new RegExp(argNe, 'g'), opt[prop]);
	      }
	    }
	    return this.cleanUrl(url);
	  },
	  cleanUrl: function cleanUrl(fullUrl) {
	    // firstly, remove any expressions we may have left in the url
	    fullUrl = fullUrl.replace(/{([^{}]*)}/g, '');
	    // then remove any empty parameters left in the url
	    var params = fullUrl.match(/[^=&?]+=[^=&?]+/g);
	    var url = fullUrl.split('?')[0];
	    if (params && params.length > 0) {
	      url += '?' + params.join('&');
	    }
	    return url;
	  },
	  doPopup: function doPopup(e) {
	    e = e || window.event;
	    var t = e.target ? e.target : e.srcElement;
	
	    // Case when <svg> is return instead of <a>
	    t = t.href ? t : t.parentNode;
	
	    // Case when <path> is return instead of <svg>
	    t = t.href ? t : t.parentNode;
	
	    var width = t.data - width || 800;
	    var height = t.data - height || 500;
	    // popup position
	    var px = Math.floor(((screen.availWidth || 1024) - width) / 2);
	    var py = Math.floor(((screen.availHeight || 700) - height) / 2);
	    // open popup
	    var popup = window.open(t.href, 'social', 'width=' + width + ',height=' + height + ',left=' + px + ',top=' + py + ',location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1');
	    if (popup) {
	      popup.focus();
	      if (e.preventDefault) e.preventDefault();
	      e.returnValue = false;
	    }
	    return !!popup;
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 334:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Footer = __webpack_require__(200);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ButtonToHome = __webpack_require__(319);
	
	var _ButtonToHome2 = _interopRequireDefault(_ButtonToHome);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	__webpack_require__(615);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  name: 'about',
	  components: {
	    UiFooter: _Footer2.default,
	    UiButtonToHome: _ButtonToHome2.default
	  },
	  mounted: function mounted() {
	    _Emitter2.default.emit('SET_MENU_WHITE');
	    this.resizeScroll();
	    var tl = new TimelineMax();
	    this.tweenEnter();
	  },
	  beforeDestroy: function beforeDestroy() {
	    _Emitter2.default.emit('SET_MENU_TRANSPARENT');
	  },
	
	  methods: {
	    resizeScroll: function resizeScroll() {
	      this.offsetHeight = this.$el.offsetHeight;
	      this.$parent.fakeScroll.style.height = 'auto';
	    },
	    tweenEnter: function tweenEnter() {
	      var creditEl = this.$el.querySelectorAll('.about__credit');
	      var dataColEl = this.$el.querySelectorAll('.about__data-collect');
	      var contactEl = this.$el.querySelectorAll('.about__contact');
	      var title = this.$el.querySelector('.about__title');
	      var buttonToHome = this.$el.querySelector('.button-to-home');
	      this.tlEnter = new TimelineMax().staggerFrom([title, creditEl, dataColEl, contactEl, buttonToHome], 1, {
	        x: -30,
	        autoAlpha: 0,
	        ease: Cubic.easeOut
	      }, 0.3, '-=1');
	    }
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 335:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(616);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	var _gsap = __webpack_require__(39);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'artwork',
	  data: function data() {
	    return {
	      innerIsHidden: false,
	      content: null,
	      oeuvre1: null,
	      oeuvre2: null,
	      isHome: null
	    };
	  },
	
	  props: ['prefix', 'oeuvre'],
	  computed: {
	    imgExtension: function imgExtension() {
	      return this.oeuvre.transparent ? '.png' : '.jpg';
	    },
	    classesInner: function classesInner() {
	      var c = {};
	      c['artwork__inner--is-hidden'] = this.innerIsHidden;
	
	      return c;
	    },
	    classesContent: function classesContent() {
	      var c = {};
	      c['artwork__content--home'] = this.isHome;
	      c['artwork__content'] = true;
	
	      return c;
	    },
	    classArtwork: function classArtwork() {
	      var c = {};
	      c['artwork--home'] = this.isHome;
	      return c;
	    }
	    // classes () {
	    //   let c = {}
	    //   c[`nav__btn--${this.direction}`] = true
	    //
	    //   return c
	    // }
	
	  },
	
	  watch: {
	    // call again the method if the route changes
	    'prefix': 'updateArtwork'
	  },
	
	  mounted: function mounted() {
	    this.addListeners();
	    this.isHome = this.$route.name === 'home';
	    this.updateArtwork();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.timeoutUpdate) {
	      window.clearTimeout(this.timeoutUpdate);
	      this.timeoutUpdate = null;
	    }
	    if (this.loader) {
	      this.loader.reset();
	    }
	    this.removeListeners();
	  },
	
	  methods: {
	    bindAll: function bindAll() {
	      var _this = this;
	
	      ['resize'].forEach(function (fn) {
	        return _this[fn] = _this[fn].bind(_this);
	      });
	    },
	    loadAssets: function loadAssets() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        // eslint-disable-next-line new-cap
	        if (!_this2.loader) {
	          _this2.loader = new PIXI.loaders.Loader();
	        }
	        _this2.loader.reset();
	        // console.log(`/static/assets/img/plantes/${this.prefix}/${this.prefix}_Oeuvre_01${this.imgExtension}`)
	        if (_this2.isHome) {
	          _this2.loader.add('oeuvre_1', '/static/assets/img/logo_jardin.png');
	          _this2.loader.add('oeuvre_2', '/static/assets/img/plantes/13_Souci/13_Souci_Oeuvre_02.jpg');
	          _this2.content = {
	            artiste: '15 MARS - 24 JUILLET 2017',
	            title: 'GRAND PALAIS'
	          };
	        } else {
	          _this2.loader.add('oeuvre_1', '/static/assets/img/plantes/' + _this2.prefix + '/' + _this2.prefix + '_Oeuvre_01' + _this2.imgExtension);
	          _this2.loader.add('oeuvre_2', '/static/assets/img/plantes/' + _this2.prefix + '/' + _this2.prefix + '_Oeuvre_02.jpg');
	        }
	
	        _this2.loader.load(function (loader, resources) {
	          _this2.oeuvre1 = resources['oeuvre_1'].url;
	          _this2.oeuvre2 = resources['oeuvre_2'].url;
	
	          _this2.content = _this2.isHome ? _this2.content : _this2.oeuvre;
	
	          setTimeout(function () {
	            _this2.init();
	          }, 50);
	        });
	      });
	    },
	    init: function init() {
	      // this.updateArtwork()
	      this.animate();
	    },
	    updateArtwork: function updateArtwork() {
	      var _this3 = this;
	
	      // this.tlHide
	      // .to(this.$refs.inner, 0.8, {
	      //   autoAlpha: 0,
	      //   ease: Expo.easeOut
	      // }, 'start')
	      // .add(() => {
	      //   this.loadAssets()
	      // }, '+=1')
	
	      this.innerIsHidden = true;
	
	      if (this.timeoutUpdate) {
	        window.clearTimeout(this.timeoutUpdate);
	        this.timeoutUpdate = null;
	      }
	
	      var delay = this.isHome ? 0 : 2500;
	      this.timeoutUpdate = setTimeout(function () {
	        _this3.loadAssets();
	      }, delay);
	    },
	    animate: function animate() {
	      var _this4 = this;
	
	      this.innerIsHidden = false;
	
	      this.$nextTick(function () {
	        var size = _Detector2.default.getScreenSize();
	        _this4.resize(size);
	        if (_this4.$parent.resizeScroll) {
	          _this4.$parent.resizeScroll();
	        } else if (_this4.$parent.$parent.resize) {
	          _this4.$parent.$parent.resize({ size: size });
	        }
	      });
	      // if (this.tlShow) {
	      //   this.tlShow.kill()
	      // }
	      //
	      // this.tlShow = new TimelineMax()
	      // this.tlShow
	      // .to(this.$refs.inner, 0.8, {
	      //   autoAlpha: 1,
	      //   ease: Quint.easeOut
	      // }, 'start')
	      // .from(this.$refs.img_background, 0.8, {
	      //   autoAlpha: 0,
	      //   ease: Quint.easeOut
	      // }, 'start')
	      // .from(this.$refs.img_oeuvre, 1.25, {
	      //   autoAlpha: 0,
	      //   rotation: 6,
	      //   y: 40,
	      //   x: -60,
	      //   scale: 0.95,
	      //   ease: Expo.easeOut
	      // }, 'start+=0.3')
	      // .staggerFrom(this.$refs.infos.children, 0.8, {
	      //   autoAlpha: 0,
	      //   y: 20,
	      //   ease: Quint.easeOut
	      // }, 0.05, 'start+=0.4')
	    },
	    onMouseEnter: function onMouseEnter() {
	      _Emitter2.default.emit('SOUND::PLAY_UI_CLICK');
	    },
	    resize: function resize(size) {
	      this.size = size;
	      this.$el.style.minHeight = this.size.h * 0.8 + 'px';
	    },
	    addListeners: function addListeners() {
	      _Emitter2.default.on('RESIZE', this.resize);
	    },
	    removeListeners: function removeListeners() {
	      _Emitter2.default.removeListener('RESIZE', this.resize);
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	module.exports = exports['default'];

/***/ },

/***/ 336:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(619);
	
	exports.default = {
	  name: 'cover',
	  components: {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	module.exports = exports['default'];

/***/ },

/***/ 337:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(264);
	
	var _FilterTypes = __webpack_require__(322);
	
	var _FilterTypes2 = _interopRequireDefault(_FilterTypes);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'filters',
	  data: function data() {
	    return {
	      filters: [],
	      currentFilter: null
	    };
	  },
	
	  filters: {
	    capitalize: function capitalize(value) {
	      if (!value) return '';
	      value = value.toString().toLowerCase();
	      return value.charAt(0).toUpperCase() + value.slice(1);
	    }
	  },
	  mounted: function mounted() {
	    for (var index in _FilterTypes2.default) {
	      var filter = {
	        name: index,
	        value: _FilterTypes2.default[index]
	      };
	      this.filters.push(filter);
	    }
	
	    this.bindAll();
	    this.addListeners();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.removeListeners();
	  },
	
	
	  methods: {
	    bindAll: function bindAll() {
	      var _this = this;
	
	      ['resetFilter'].forEach(function (fn) {
	        return _this[fn] = _this[fn].bind(_this);
	      });
	    },
	    addListeners: function addListeners() {
	      _Emitter2.default.on('FILTERS:RESET', this.resetFilter);
	    },
	    removeListeners: function removeListeners() {
	      _Emitter2.default.removeListener('FILTERS:RESET', this.resetFilter);
	    },
	    resetFilter: function resetFilter() {
	      this.currentFilter = null;
	    },
	    clickFilter: function clickFilter(id) {
	      this.currentFilter = id;
	      /**
	       * TODO
	       * penser à créer un btn d'interface pour reset le filtre
	       */
	      _Emitter2.default.emit('CLICK_FILTER', {
	        filterId: id
	      });
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	module.exports = exports['default'];

/***/ },

/***/ 338:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(621);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _Footer = __webpack_require__(200);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _index = __webpack_require__(317);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'home-footer',
	  data: function data() {
	    return {
	      plant: null
	    };
	  },
	
	
	  components: {
	    Artwork: _index2.default,
	    UiFooter: _Footer2.default
	  },
	
	  created: function created() {},
	  mounted: function mounted() {
	    var _this = this;
	
	    this.container = this.$el.querySelector('.home-footer__container');
	
	    this.bindAll();
	
	    this.addListeners();
	
	    this.$nextTick(function () {
	      _this.init();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.removeListeners();
	  },
	
	
	  methods: {
	    addListeners: function addListeners() {
	      _Emitter2.default.on('TICK', this.update);
	      _Emitter2.default.on('RESIZE', this.resize);
	    },
	    removeListeners: function removeListeners() {
	      _Emitter2.default.removeListener('TICK', this.update);
	      _Emitter2.default.removeListener('RESIZE', this.resize);
	    },
	    init: function init() {
	      this.plant = this.$parent.$parent.flowersData[0];
	    },
	    bindAll: function bindAll() {
	      var _this2 = this;
	
	      ['update', 'resize'].forEach(function (fn) {
	        return _this2[fn] = _this2[fn].bind(_this2);
	      });
	    },
	    resize: function resize(_ref) {
	      var size = _ref.size;
	    },
	    update: function update(_ref2) {
	      var scrollVars = _ref2.scrollVars,
	          globalTime = _ref2.globalTime;
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//

	module.exports = exports['default'];

/***/ },

/***/ 339:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(622);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _Scene = __webpack_require__(325);
	
	var _Scene2 = _interopRequireDefault(_Scene);
	
	var _cover = __webpack_require__(734);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	var _filters = __webpack_require__(735);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _footerHome = __webpack_require__(736);
	
	var _footerHome2 = _interopRequireDefault(_footerHome);
	
	var _CloseButton = __webpack_require__(739);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  name: 'home',
	  components: {
	    CoverSection: _cover2.default,
	    FiltersSection: _filters2.default,
	    HomeFooter: _footerHome2.default,
	    CloseButton: _CloseButton2.default
	  },
	
	  data: function data() {
	    return {
	      isFiltered: false
	    };
	  },
	  created: function created() {
	    document.body.classList.add('black');
	    window.scrollTo(0, 0);
	  },
	  mounted: function mounted() {
	    console.log(':: home mounted');
	    this.container = this.$el;
	
	    this.bindAll();
	
	    this.addListeners();
	    this.init();
	  },
	  beforeDestroy: function beforeDestroy() {
	    _Emitter2.default.emit('SET_MENU_WHITE');
	    this.removeListeners();
	  },
	
	  methods: {
	    addListeners: function addListeners() {
	      _Emitter2.default.on('CLICK_FILTER', this.selectFilter);
	      _Emitter2.default.on('TICK', this.update);
	      _Emitter2.default.on('RESIZE', this.resize);
	    },
	    removeListeners: function removeListeners() {
	      _Emitter2.default.removeListener('CLICK_FILTER', this.selectFilter);
	      _Emitter2.default.removeListener('TICK', this.update);
	      _Emitter2.default.removeListener('RESIZE', this.resize);
	    },
	    init: function init() {
	      this.ticker = PIXI.ticker.shared;
	      this.ticker.autoStart = false;
	
	      this.$parent.scene = new _Scene2.default({
	        container: this.container
	      });
	
	      if (this.$route.params) {
	        if (this.$route.params.goToFilters) {
	          this.$parent.scene.goToFilters = true;
	        }
	      }
	    },
	    bindAll: function bindAll() {
	      var _this = this;
	
	      ['update', 'resize', 'selectFilter'].forEach(function (fn) {
	        return _this[fn] = _this[fn].bind(_this);
	      });
	    },
	    selectFilter: function selectFilter() {
	      this.isFiltered = true;
	    },
	    resetFilter: function resetFilter() {
	      this.isFiltered = false;
	      _Emitter2.default.emit('FILTERS:RESET');
	    },
	    resizeScroll: function resizeScroll() {
	      if (this.$parent.fakeScroll && this.$parent.scene.isReady) {
	        this.offsetHeight = this.$parent.scene.offsetHeight;
	        this.offsetHeight += this.$parent.scene.coverComp.offsetHeight;
	        this.offsetHeight += this.$parent.scene.filtersComp.offsetHeight;
	        this.offsetHeight += this.$parent.scene.homeFooterComp.offsetHeight;
	        this.$parent.fakeScroll.style.height = this.offsetHeight + 'px';
	      }
	    },
	    resize: function resize(_ref) {
	      var size = _ref.size;
	
	      if (!this.$parent.scene) return;
	
	      this.$parent.scene.resize(size);
	
	      this.resizeScroll();
	    },
	    update: function update(_ref2) {
	      var scrollVars = _ref2.scrollVars,
	          globalTime = _ref2.globalTime;
	
	      this.$parent.scene.scroll(scrollVars);
	      this.$parent.scene.update(globalTime);
	    },
	    destroyScene: function destroyScene() {
	      this.$parent.scene.destroy();
	      this.$parent.scene = null;
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//

	module.exports = exports['default'];

/***/ },

/***/ 340:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(626);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _SingleScene = __webpack_require__(327);
	
	var _SingleScene2 = _interopRequireDefault(_SingleScene);
	
	var _index = __webpack_require__(317);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _NavigationButton = __webpack_require__(741);
	
	var _NavigationButton2 = _interopRequireDefault(_NavigationButton);
	
	var _Button = __webpack_require__(318);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Footer = __webpack_require__(200);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ButtonToHome = __webpack_require__(319);
	
	var _ButtonToHome2 = _interopRequireDefault(_ButtonToHome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  name: 'single-plant',
	  components: {
	    Artwork: _index2.default,
	    NavigationButton: _NavigationButton2.default,
	    UiFooter: _Footer2.default,
	    UiButton: _Button2.default,
	    UiButtonToHome: _ButtonToHome2.default
	  },
	  data: function data() {
	    return {
	      loading: false,
	      plant: null,
	      content: null,
	      error: null,
	      nav: null,
	      shareInfos: null
	    };
	  },
	  created: function created() {
	    this.fetchData();
	  },
	  mounted: function mounted() {
	    document.body.classList.remove('locked');
	    this.bindAll();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$parent.scene) {
	      // this.$parent.scene.destroy()
	      // this.$parent.scene = null
	
	      this.removeListeners();
	
	      _Emitter2.default.emit('SET_MENU_TRANSPARENT');
	    }
	  },
	
	
	  watch: {
	    // call again the method if the route changes
	    '$route': 'fetchData'
	  },
	
	  methods: {
	    fetchData: function fetchData() {
	      var _this = this;
	
	      // this.nav = this.plantData = this.content = null
	
	      this.$parent.getSinglePlant(this.$route.params.slug).then(function (_ref) {
	        var plant = _ref.plant,
	            nav = _ref.nav;
	
	        _this.nav = nav;
	        _this.plant = plant;
	        _this.content = plant.content;
	        _this.shareInfos = {
	          url: window.location.protocol + '//' + window.location.host + window.location.pathname,
	          title: _this.content.title,
	          text: 'De\u0301sormais, je prends soin de moi avec ' + _this.content.title + ' ! #ExpoJardins',
	          // hashtags: 'ExpoJardins',
	          via: 'GrandPalaisRmn'
	        };
	        _this.$nextTick(function () {
	          if (!_this.isInit) {
	            _this.init();
	          } else {
	            _this.$parent.scene.updateFlower(plant);
	          }
	        });
	      }, function (_ref2) {
	        var error = _ref2.error;
	
	        _this.error = error;
	      });
	    },
	    addListeners: function addListeners() {
	      _Emitter2.default.on('TICK', this.update);
	      _Emitter2.default.on('RESIZE', this.resize);
	    },
	    removeListeners: function removeListeners() {
	      _Emitter2.default.removeListener('TICK', this.update);
	      _Emitter2.default.removeListener('RESIZE', this.resize);
	    },
	    init: function init() {
	      console.log('Single Plant :: init');
	      this.singleScrollContainer = this.$el.querySelector('.single-plant__scroll-container');
	      this.singleContainer = this.$el.querySelector('.single-plant__container');
	      this.container = this.$el.querySelector('.single-plant__canvas-container');
	
	      this.ticker = PIXI.ticker.shared;
	      this.ticker.autoStart = false;
	      this.isInit = true;
	      this.addListeners();
	      this.$parent.scene = new _SingleScene2.default({
	        container: this.container,
	        flowersData: this.plant
	      });
	      _Emitter2.default.emit('SOUND::PLAYINIT', { intro: false });
	      this.enter();
	    },
	    bindAll: function bindAll() {
	      var _this2 = this;
	
	      ['update', 'resize'].forEach(function (fn) {
	        return _this2[fn] = _this2[fn].bind(_this2);
	      });
	    },
	    resize: function resize(_ref3) {
	      var size = _ref3.size;
	
	      if (!this.$parent.scene) return;
	
	      this.singleContainer.style.minHeight = size.h * 0.8 + 'px';
	
	      var w = size.BP === 'mobile' ? size.w : this.container.offsetWidth * 1.1;
	      var h = Math.max(size.h, this.singleContainer.offsetHeight * 1.2);
	
	      size.w = w;
	      size.hW = w / 2;
	      size.h = h;
	      size.hH = h / 2;
	
	      this.$parent.scene.resize(size);
	
	      if (this.$parent.fakeScroll && this.$parent.scene.isReady) {
	        this.resizeScroll();
	      }
	    },
	    resizeScroll: function resizeScroll() {
	      this.offsetHeight = this.singleScrollContainer.offsetHeight;
	      this.$parent.fakeScroll.style.height = this.offsetHeight + 'px';
	    },
	    update: function update(_ref4) {
	      var scrollVars = _ref4.scrollVars,
	          globalTime = _ref4.globalTime;
	
	      this.$parent.scene.scroll(scrollVars);
	      this.$parent.scene.update(globalTime);
	
	      TweenMax.set(this.singleScrollContainer, {
	        y: -scrollVars.current
	      });
	    },
	    enter: function enter() {
	      var subtile = this.$el.querySelector('.single-plant__subtitle');
	      var title = this.$el.querySelector('.single-plant__title');
	      var description = this.$el.querySelector('.single-plant__description');
	      var sharingTxt = this.$el.querySelector('.sharing__text');
	      var shargingBtns = this.$el.querySelectorAll('.sharing__btns .sharing__btn');
	      var btnHome = this.$el.querySelector('.button-to-home');
	      this.tlEnter = new TimelineMax();
	      this.tlEnter.from([this.$refs.plantText, this.$refs.artwork.$el, this.$refs.uiFooter.$el], 1, {
	        autoAlpha: 0
	      }, '+=1');
	
	      this.tlEnter.addLabel('start', '-=1');
	      this.tlEnter.timeScale(1.5);
	      this.tlEnter.staggerFrom(this.$refs.plantText.children, 1, {
	        x: -30,
	        autoAlpha: 0,
	        ease: Cubic.easeOut,
	        clearProps: 'all'
	      }, 0.2, 'start').from(sharingTxt, 1, {
	        x: -30,
	        autoAlpha: 0,
	        ease: Cubic.easeOut
	      }, 'start+=0.6').staggerFrom(shargingBtns, 1, {
	        x: -30,
	        autoAlpha: 0,
	        ease: Cubic.easeOut
	      }, -0.05, 'start+=0.7').from(btnHome, 0.8, {
	        y: 30,
	        autoAlpha: 0,
	        ease: Back.easeOut
	      }, 'start+=0.8');
	      // tl.to(subtile,2,)
	    },
	    tweenContent: function tweenContent(dir) {
	      var title = this.$el.querySelector('.single-plant__title');
	      var description = this.$el.querySelector('.single-plant__description');
	
	      if (this.tlPrev) {
	        this.tlPrev.kill();
	        TweenMax.set([title, description], { clearProps: 'all' });
	        this.tlPrev.clear();
	      } else {
	        this.tlPrev = new TimelineMax();
	      }
	      var x = dir === 'next' ? -30 : 30;
	      this.tlPrev.timeScale(1);
	      this.tlPrev.staggerFrom([title, description], 1, {
	        x: x,
	        autoAlpha: 0,
	        ease: Expo.easeOut
	      }, 0.1);
	    }
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 341:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(348);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _gsap = __webpack_require__(39);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _VueShareBox = __webpack_require__(206);
	
	var _VueShareBox2 = _interopRequireDefault(_VueShareBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'button',
	  data: function data() {
	    return {
	      muted: false
	    };
	  },
	
	  props: ['type', 'shareInfos', 'isTransparent'],
	  computed: {
	    classes: function classes() {
	      var c = {};
	      var parentClass = this.$parent.$options.name === 'single-plant' ? 'sharing__btn' : 'menu__btn';
	      if (this.type === 'facebook') {
	        c[parentClass + '--fb'] = true;
	      } else if (this.type === 'twitter') {
	        c[parentClass + '--twitter'] = true;
	      }
	      c[parentClass] = true;
	
	      return c;
	    }
	  },
	  mounted: function mounted() {
	    this.addListeners();
	    this.circleEl = this.$el.querySelector('.circle');
	    this.icons = this.$el.querySelectorAll('.icon');
	    this.svgEl = this.$el.querySelector('.sharing__btn__img') || this.$el;
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(this.icons), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var icon = _step.value;
	
	        icon.style.fill = this.$route.name === 'single-plant' ? 'rgb(0, 0, 0)' : 'rgb(255, 255, 255)';
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.removeListeners();
	  },
	
	  methods: {
	    addListeners: function addListeners() {
	      _Emitter2.default.on('MENU_BLACK_BTNS', this.setButtonBlack);
	      _Emitter2.default.on('SET_MENU_TRANSPARENT', this.setButtonWhite);
	    },
	    removeListeners: function removeListeners() {
	      _Emitter2.default.removeListener('MENU_BLACK_BTNS', this.setButtonBlack);
	      _Emitter2.default.removeListener('SET_MENU_TRANSPARENT', this.setButtonWhite);
	    },
	    setButtonWhite: function setButtonWhite() {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.icons), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var icon = _step2.value;
	
	          icon.style.fill = 'rgb(255, 255, 255)';
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    },
	    setButtonBlack: function setButtonBlack() {
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(this.icons), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var icon = _step3.value;
	
	          icon.style.fill = 'rgb(0, 0, 0)';
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    },
	    toggleSound: function toggleSound() {
	      this.muted = !this.muted;
	      _Emitter2.default.emit('SOUND::TOGGLE_SOUND', {
	        muted: !this.muted,
	        sender: 'toggleSound'
	      });
	    },
	    getShareInfos: function getShareInfos() {
	      return this.shareInfos;
	    },
	    onMouseEnter: function onMouseEnter() {
	      _Emitter2.default.emit('SOUND::PLAY_UI_CLICK');
	      var tl = new TimelineMax();
	      // tl.to(this.circleEl, 0.5, {
	      //   transformOrigin: '50% 50%',
	      //   scale: 1.6,
	      //   // transformOrigin: '50% 50%',
	      //   ease: Back.easeOut
	      // }, 'start')
	      // .to(this.icons, 0.4, {
	      //   transformOrigin: '50% 50%',
	      //   scale: 1.15,
	      //   ease: Quint.easeOut
	      // }, 'start')
	      tl.to(this.icons, 0.5, {
	        transformOrigin: '50% 50%',
	        scale: 0.93,
	        // transformOrigin: '50% 50%',
	        ease: Expo.easeOut
	      }, 'start');
	    },
	    onMouseLeave: function onMouseLeave() {
	      var tl = new TimelineMax();
	      // tl.to(this.circleEl, 0.6, {
	      //   transformOrigin: '50% 50%',
	      //   scale: 1,
	      //   ease: Quint.easeOut
	      // }, 'start')
	      // .to(this.icons, 0.4, {
	      //   transformOrigin: '50% 50%',
	      //   scale: 1,
	      //   ease: Quint.easeOut
	      // }, 'start')
	      tl.to(this.icons, 0.6, {
	        transformOrigin: '50% 50%',
	        scale: 1,
	        ease: Quint.easeOut
	      }, 'start');
	    },
	    pushTheButton: function pushTheButton() {
	      // let tl = new TimelineMax()
	      // tl.to(this.circleEl, 0.3, {
	      //   transformOrigin: '50% 50%',
	      //   scale: 1.3,
	      //   ease: Sine.easeOut
	      // }, 'first')
	      // .to(this.circleEl, 0.4, {
	      //   transformOrigin: '50% 50%',
	      //   scale: 1.6,
	      //   ease: Quint.easeOut
	      // }, 'second')
	      // .to(this.icons, 0.4, {
	      //   transformOrigin: '50% 50%',
	      //   scale: 0.8,
	      //   ease: Quint.easeOut
	      // }, 'first')
	      // .to(this.icons, 0.4, {
	      //   transformOrigin: '50% 50%',
	      //   scale: 1.15,
	      //   ease: Quint.easeOut
	      // }, 'second')
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	// import 'styles/components/ui-button.styl'
	
	module.exports = exports['default'];

/***/ },

/***/ 342:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(617);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  name: 'button-to-home',
	  props: ['goToFilters'],
	  methods: {
	    tweenAllPlantsEnter: function tweenAllPlantsEnter() {
	      _Emitter2.default.emit('SOUND::PLAY_UI_CLICK');
	      var icon = this.$el.querySelector('.icon__path');
	      var tl = new TimelineMax();
	      tl.to(icon, 1, {
	        transformOrigin: 'center',
	        fill: '#f3f1dd',
	        rotation: 5,
	        scale: 0.9,
	        ease: Cubic.easeOut
	      });
	    },
	    tweenAllPlantsLeave: function tweenAllPlantsLeave() {
	      var icon = this.$el.querySelector('.icon__path');
	      var tl = new TimelineMax();
	      tl.to(icon, 1, {
	        transformOrigin: 'center',
	        fill: '#FFF',
	        rotation: 0,
	        scale: 1,
	        ease: Cubic.easeOut
	      });
	    }
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 343:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(618);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _gsap = __webpack_require__(39);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'close-button',
	  data: function data() {
	    return {};
	  },
	
	
	  props: ['direction'],
	
	  computed: {
	    classes: function classes() {
	      var c = {};
	      c['close__btn--' + this.direction] = true;
	
	      return c;
	    }
	  },
	  mounted: function mounted() {
	    this.addListeners();
	
	    this.circleEl = this.$el.querySelector('.circle');
	    this.arrowEl = this.$el.querySelector('.cross');
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.removeListeners();
	  },
	
	  methods: {
	    addListeners: function addListeners() {},
	    removeListeners: function removeListeners() {},
	    onMouseEnter: function onMouseEnter() {
	      var tl = new TimelineMax();
	      tl.to(this.circleEl, 0.5, {
	        transformOrigin: '50% 50%',
	        scale: 1.4,
	        // transformOrigin: '50% 50%',
	        ease: Back.easeOut
	      }, 'start').to(this.arrowEl, 0.4, {
	        transformOrigin: '50% 50%',
	        scale: 1.15,
	        rotation: 90,
	        ease: Back.easeOut
	      }, 'start');
	    },
	    onMouseLeave: function onMouseLeave() {
	      var tl = new TimelineMax();
	      tl.to(this.circleEl, 0.6, {
	        transformOrigin: '50% 50%',
	        scale: 1,
	        ease: Quint.easeOut
	      }, 'start').to(this.arrowEl, 0.4, {
	        transformOrigin: '50% 50%',
	        scale: 1,
	        rotation: 0,
	        ease: Quint.easeOut
	      }, 'start');
	    },
	    pushTheButton: function pushTheButton() {
	      _Emitter2.default.emit('SOUND::PLAY_UI_CLICK');
	      var tl = new TimelineMax();
	      tl.to(this.circleEl, 0.3, {
	        transformOrigin: '50% 50%',
	        scale: 1.3,
	        ease: Sine.easeOut
	      }, 'first').to(this.circleEl, 0.4, {
	        transformOrigin: '50% 50%',
	        scale: 1.4,
	        ease: Quint.easeOut
	      }, 'second').to(this.arrowEl, 0.4, {
	        transformOrigin: '50% 50%',
	        scale: 0.8,
	        ease: Quint.easeOut
	      }, 'first').to(this.arrowEl, 0.4, {
	        transformOrigin: '50% 50%',
	        scale: 1.15,
	        ease: Quint.easeOut
	      }, 'second');
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	module.exports = exports['default'];

/***/ },

/***/ 344:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(620);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _gsap = __webpack_require__(39);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'footer',
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    classes: function classes() {
	      var c = {};
	      c['footer--about'] = this.$route.name === 'about';
	      return c;
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	module.exports = exports['default'];

/***/ },

/***/ 345:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(624);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _Button = __webpack_require__(318);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'menu',
	  components: {
	    UiButton: _Button2.default
	  },
	  data: function data() {
	    return {
	      isTransparent: true,
	      isHidden: false,
	      muted: false
	    };
	  },
	
	  computed: {
	    classes: function classes() {
	      var c = {};
	      c['menu--is-hidden'] = this.isHidden;
	      c['menu--is-transparent'] = this.isTransparent;
	      c['menu--is-white'] = !this.isTransparent ? 1 : 0;
	      c['menu--is-single-page'] = this.isSinglePage;
	
	      return c;
	    },
	    isSinglePage: function isSinglePage() {
	      return this.$route.name === 'single-plant';
	    }
	  },
	  mounted: function mounted() {
	    this.isTransparent = this.isSinglePage ? 0 : 1;
	    this.addListeners();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.removeListeners();
	  },
	
	  methods: {
	    addListeners: function addListeners() {
	      _Emitter2.default.on('HIDE_MENU', this.hideMenu);
	      _Emitter2.default.on('SET_MENU_WHITE', this.setMenuWhite);
	      _Emitter2.default.on('SET_MENU_TRANSPARENT', this.setMenuTransparent);
	      _Emitter2.default.on('SCROLL', this.scroll);
	    },
	    removeListeners: function removeListeners() {
	      _Emitter2.default.removeListener('HIDE_MENU', this.hideMenu);
	      _Emitter2.default.removeListener('SET_MENU_WHITE', this.setMenuWhite);
	      _Emitter2.default.removeListener('SET_MENU_TRANSPARENT', this.setMenuTransparent);
	      _Emitter2.default.removeListener('SCROLL', this.scroll);
	    },
	    bindAll: function bindAll() {
	      var _this = this;
	
	      ['setMenuWhite', 'setMenuTransparent', 'showMenu', 'hideMenu', 'scroll'].forEach(function (fn) {
	        return _this[fn] = _this[fn].bind(_this);
	      });
	    },
	    scroll: function scroll(_ref) {
	      var _this2 = this;
	
	      var scrollVars = _ref.scrollVars;
	
	      if (scrollVars.target > scrollVars.last) {
	        if (!this.isHidden && !this.isTransparent) {
	          if (!this.timeoutHide) {
	            this.timeoutHide = setTimeout(function () {
	              _this2.isHidden = true;
	            }, 1000);
	          }
	        }
	      } else {
	        if (this.timeoutHide) {
	          window.clearTimeout(this.timeoutHide);
	          this.timeoutHide = null;
	        }
	        if (this.isHidden) {
	          this.isHidden = false;
	        }
	      }
	    },
	    setMenuWhite: function setMenuWhite() {
	      this.isTransparent = false;
	      _Emitter2.default.emit('MENU_BLACK_BTNS');
	    },
	    hideMenu: function hideMenu() {
	      var _this3 = this;
	
	      this.isHidden = true;
	
	      if (this.timeoutHideMenu) {
	        window.clearTimeout(this.timeoutHideMenu);
	        this.timeoutHideMenu = null;
	      }
	
	      this.timeoutHideMenu = setTimeout(function () {
	        _this3.setMenuWhite();
	      }, 400);
	    },
	    showMenu: function showMenu() {
	      this.isHidden = false;
	    },
	    setMenuTransparent: function setMenuTransparent() {
	      this.isTransparent = true;
	    },
	
	
	    // toggleSound () {
	    //   this.muted = !this.muted
	    //   console.log('toggleSound',  !this.muted);
	    //   Emitter.emit('SOUND::TOGGLE_SOUND', {muted: !this.muted, sender: 'toggleSound'})
	    // },
	    shareInfos: function shareInfos() {
	      return {
	        url: window.location.protocol + '//' + window.location.host,
	        text: 'D\xE9couvrez les secrets des plantes avec le Grand Palais ! #ExpoJardins',
	        // hashtags: 'ExpoJardins',
	        via: 'GrandPalaisRmn'
	      };
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	module.exports = exports['default'];

/***/ },

/***/ 346:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(625);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _gsap = __webpack_require__(39);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'navigation-button',
	  data: function data() {
	    return {};
	  },
	
	  props: ['slug', 'direction'],
	  computed: {
	    classes: function classes() {
	      var c = {};
	      c['nav__btn--' + this.direction] = true;
	
	      return c;
	    }
	  },
	  mounted: function mounted() {
	    this.addListeners();
	
	    this.circleEl = this.$el.querySelector('.circle');
	    this.arrowEl = this.$el.querySelector('.arrow');
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.removeListeners();
	  },
	
	  methods: {
	    addListeners: function addListeners() {},
	    removeListeners: function removeListeners() {},
	    onMouseEnter: function onMouseEnter() {
	      this.focus = true;
	      this.tlEnter = new TimelineMax();
	      this.tlEnter.to(this.circleEl, 0.5, {
	        transformOrigin: '50% 50%',
	        scale: 1.6,
	        // transformOrigin: '50% 50%',
	        ease: Back.easeOut
	      }, 'start').to(this.arrowEl, 0.4, {
	        transformOrigin: '50% 50%',
	        scale: 1.15,
	        ease: Quint.easeOut
	      }, 'start');
	    },
	    onMouseLeave: function onMouseLeave() {
	      this.focus = false;
	      this.tlPush && this.tlPush.isActive() && this.tlPush.kill();
	      this.tlLeave = new TimelineMax();
	      this.tlLeave.to(this.circleEl, 0.6, {
	        transformOrigin: '50% 50%',
	        scale: 1,
	        ease: Quint.easeOut
	      }, 'start').to(this.arrowEl, 0.4, {
	        transformOrigin: '50% 50%',
	        scale: 1,
	        ease: Quint.easeOut
	      }, 'start');
	    },
	    pushTheButton: function pushTheButton() {
	      var circleScale = this.focus ? 1.6 : 1;
	      var arrowScale = this.focus ? 1.15 : 1;
	      _Emitter2.default.emit('SOUND::PLAY_NAV_CLICK', { direction: this.direction });
	      this.tlPush = new TimelineMax();
	      this.tlPush.to(this.circleEl, 0.3, {
	        transformOrigin: '50% 50%',
	        scale: 1.3,
	        ease: Sine.easeOut
	      }, 'first').to(this.circleEl, 0.4, {
	        transformOrigin: '50% 50%',
	        scale: circleScale,
	        ease: Quint.easeOut
	      }, 'second').to(this.arrowEl, 0.4, {
	        transformOrigin: '50% 50%',
	        scale: 0.8,
	        ease: Quint.easeOut
	      }, 'first').to(this.arrowEl, 0.4, {
	        transformOrigin: '50% 50%',
	        scale: arrowScale,
	        ease: Quint.easeOut
	      }, 'second');
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	module.exports = exports['default'];

/***/ },

/***/ 347:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(354);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(88);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	__webpack_require__(614);
	
	var _vuex = __webpack_require__(760);
	
	var _pixi = __webpack_require__(26);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	var _Emitter = __webpack_require__(11);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _Detector = __webpack_require__(22);
	
	var _Detector2 = _interopRequireDefault(_Detector);
	
	var _stats = __webpack_require__(727);
	
	var _stats2 = _interopRequireDefault(_stats);
	
	var _SoundManager = __webpack_require__(204);
	
	var _SoundManager2 = _interopRequireDefault(_SoundManager);
	
	var _Menu = __webpack_require__(740);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      fakeScroll: null,
	      isReady: false,
	      isLoading: true
	    };
	  },
	
	  components: {
	    MenuComp: _Menu2.default
	  },
	  computed: {
	    // ...mapGetters({
	    //   deviceInformations: 'deviceInformations',
	    //   lightSensitivity: 'deviceLightSensitivity',
	    //   isDark: 'isDark'
	    // }),
	  },
	  created: function created() {
	    this.scrollVars = {
	      ease: _Detector2.default.isMobile() ? 0.15 : 0.1,
	      last: 0,
	      current: 0,
	      target: 0
	    };
	
	    this.loadJson();
	  },
	  mounted: function mounted() {
	    this.bindAll();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.removeListeners();
	    this.removeFakeScroll();
	    // this.removeFpsMeter()
	
	    window.loaderManager.loader.reset();
	
	    if (this.soundManager) {
	      this.soundManager.destroy();
	      this.soundManager = null;
	    }
	
	    this.resources = {};
	  },
	
	
	  methods: {
	    // ...mapActions([
	    //   'setChapter',
	    //   'setDeviceInformations',
	    //   'setLightSensitivity',
	    //   'setIsDark'
	    // ]),
	    bindAll: function bindAll() {
	      var _this = this;
	
	      ['update', 'resize', 'scroll', 'openSinglePlant', 'checkFocus'].forEach(function (fn) {
	        return _this[fn] = _this[fn].bind(_this);
	      });
	    },
	    loadJson: function loadJson() {
	      var _this2 = this;
	
	      var loader = new PIXI.loaders.Loader();
	      loader.reset();
	
	      loader.add('flowers', '/static/assets/data/flowers.json');
	      loader.load(function (loader, resources) {
	        _this2.flowers = resources['flowers'];
	        _this2.flowersData = resources['flowers'].data;
	
	        var files = [{ name: 'spriteMap', url: '/static/assets/sounds/spriteMap.json' }, { name: 'soundSprites', url: '/static/assets/sounds/soundsprites.mp3', xhrType: PIXI.loaders.Resource.XHR_RESPONSE_TYPE.BLOB, loadType: PIXI.loaders.Resource.LOAD_TYPE.XHR }, { name: 'little_particle', url: '/static/assets/img/particule_A_02.png' }, { name: 'threshold', url: '/static/assets/img/threshold.jpg' }];
	        window.loaderManager.addFiles(files);
	
	        _this2.loadResources();
	      });
	    },
	    loadResources: function loadResources() {
	      var _this3 = this;
	
	      if (this.oldRoute === this.$route.name) return;
	
	      this.isLoading = true;
	
	      var files = [{ name: 'mask_1', url: '/static/assets/img/mask_1.png' }, { name: 'home_logo_jardins', url: '/static/assets/img/logo_jardin.png' }, { name: 'home_logo_rmn', url: '/static/assets/img/home/home_logo_rmn.png' }, { name: 'homer_cover_jardins', url: '/static/assets/img/home/homer_cover_jardins.jpg' }, { name: 'secrets_vertus_plantes', url: '/static/assets/img/home/secrets_vertus_plantes@2x.png' }, { name: 'home_left_plant', url: '/static/assets/img/home/home_left_plant.png' }, { name: 'home_right_plant', url: '/static/assets/img/home/home_right_plant.png' }, { name: '13_Souci_Oeuvre_02', url: '/static/assets/img/plantes/13_Souci/13_Souci_Oeuvre_02.jpg' }, { name: 'BG_fleur', url: '/static/assets/img/home/BG_fleur.jpg' }];
	
	      this.flowersData.forEach(function (flower) {
	        files.push({ name: flower.title, url: '/static/assets/img/spritesheets/' + flower.id + '_' + flower.title + '.json' });
	      });
	
	      window.loaderManager.addFiles(files);
	
	      window.loaderManager.loadAll(function () {
	        (0, _assign2.default)(window.loaderManager.resources, { flowers: _this3.flowers });
	
	        if (!_this3.firstInit) {
	          _this3.init();
	        }
	
	        _this3.isLoading = false;
	      });
	    },
	    init: function init() {
	      this.soundSprite = window.URL.createObjectURL(window.loaderManager.resources['soundSprites'].data);
	      this.spriteMap = window.loaderManager.resources['spriteMap'].data;
	
	      this.globalTime = Math.random() * 10000;
	      this.firstInit = true;
	      this.isReady = true;
	      // this.addFpsMeter()
	      this.addFakeScroll();
	      this.addListeners();
	      this.soundManager = new _SoundManager2.default({
	        soundSprites: this.soundSprite,
	        spriteMap: this.spriteMap
	      });
	      if (!this.requestId) {
	        this.update();
	      }
	    },
	    addListeners: function addListeners() {
	      _Emitter2.default.on('OPEN_SINGLE', this.openSinglePlant);
	      _Emitter2.default.on('GET_RESIZE', this.resize);
	
	      window.addEventListener('scroll', this.scroll);
	      var visibilityChange = void 0;
	      if (typeof document.hidden !== 'undefined') {
	        visibilityChange = 'visibilitychange';
	      } else if (typeof document.mozHidden !== 'undefined') {
	        visibilityChange = 'mozvisibilitychange';
	      } else if (typeof document.msHidden !== 'undefined') {
	        visibilityChange = 'msvisibilitychange';
	      } else if (typeof document.webkitHidden !== 'undefined') {
	        visibilityChange = 'webkitvisibilitychange';
	      }
	
	      document.addEventListener(visibilityChange, this.checkFocus);
	      window.addEventListener('focus', this.checkFocus);
	      window.addEventListener('blur', this.checkFocus);
	
	      if (_Detector2.default.isMobile()) {
	        window.addEventListener('orientationchange', this.resize);
	      } else {
	        window.addEventListener('resize', this.resize);
	      }
	    },
	    removeListeners: function removeListeners() {
	      _Emitter2.default.removeListener('OPEN_SINGLE', this.openSinglePlant);
	      _Emitter2.default.removeListener('GET_RESIZE', this.resize);
	
	      window.removeEventListener('scroll', this.scroll);
	
	      if (_Detector2.default.isMobile()) {
	        window.removeEventListener('orientationchange', this.resize);
	      } else {
	        window.removeEventListener('resize', this.resize);
	      }
	
	      if (this.requestId) {
	        window.cancelAnimationFrame(this.requestId);
	        this.requestId = undefined;
	      }
	    },
	    checkFocus: function checkFocus() {
	      _Emitter2.default.emit('SOUND::TOGGLE_SOUND', { muted: document.hasFocus(), sender: 'checkFocus' });
	    },
	    addFpsMeter: function addFpsMeter() {
	      this.meter = new _stats2.default();
	      this.meter.dom.classList.add('fps-meter');
	      this.meter.dom.style.left = '';
	      this.meter.dom.style.right = '0px';
	      document.body.appendChild(this.meter.dom);
	    },
	    removeFpsMeter: function removeFpsMeter() {
	      document.body.removeChild(this.meter.dom);
	    },
	    resize: function resize() {
	      this.size = _Detector2.default.getScreenSize();
	
	      _Emitter2.default.emit('RESIZE', {
	        size: this.size
	      });
	    },
	    scroll: function scroll() {
	      this.scrollVars.target = window.pageYOffset;
	
	      _Emitter2.default.emit('SCROLL', {
	        scrollVars: this.scrollVars
	      });
	
	      this.scrollVars.last = this.scrollVars.target;
	    },
	    update: function update() {
	      // this.meter.begin()
	      this.globalTime += 0.01;
	
	      this.scrollVars.current += (this.scrollVars.target - this.scrollVars.current) * this.scrollVars.ease;
	      this.scrollVars.current < 0.1 && (this.scrollVars.current = 0);
	
	      _Emitter2.default.emit('TICK', {
	        scrollVars: this.scrollVars,
	        globalTime: this.globalTime
	      });
	
	      // this.meter.end()
	      this.requestId = window.requestAnimationFrame(this.update);
	    },
	    addFakeScroll: function addFakeScroll() {
	      this.fakeScroll = document.createElement('div');
	      this.fakeScroll.classList.add('fake-scroll');
	      document.body.appendChild(this.fakeScroll);
	    },
	    removeFakeScroll: function removeFakeScroll() {
	      document.body.removeChild(this.fakeScroll);
	      this.fakeScroll = null;
	    },
	    getSinglePlant: function getSinglePlant(slug) {
	      var _this4 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var arr = _this4.flowersData.filter(function (item) {
	          var slugItem = item.title.toLowerCase();
	          return slug === slugItem;
	        });
	
	        var item = arr[0];
	        var index = _this4.flowersData.indexOf(item);
	
	        var previousIndex = Math.max(-1, index - 1);
	        if (previousIndex === -1) {
	          previousIndex = _this4.flowersData.length - 1;
	        }
	        var previousSlug = _this4.flowersData[previousIndex].title.toLowerCase();
	
	        var nextIndex = Math.min(index + 1, _this4.flowersData.length - 1);
	        if (nextIndex === _this4.flowersData.length - 1) {
	          nextIndex = 0;
	        }
	        var nextSlug = _this4.flowersData[nextIndex].title.toLowerCase();
	
	        if (item) {
	          resolve({
	            plant: item,
	            nav: {
	              prev: previousSlug,
	              next: nextSlug
	            }
	          });
	        } else {
	          reject({
	            error: {
	              'code': '404',
	              'msg': 'La plante n\' existe pas. '
	            }
	          });
	        }
	      });
	    },
	    openSinglePlant: function openSinglePlant(title) {
	      var slug = title.toLowerCase();
	      this.$router.push({
	        name: 'single-plant',
	        params: {
	          slug: slug
	        }
	      });
	    },
	    enter: function enter(el, done) {
	      if (el.className === 'single-plant') {
	        this.enterSinglePlant(el, done);
	      } else if (el.className === 'home') {
	        this.enterHome(el, done);
	      } else {
	        window.scrollTo(0, 0);
	        this.scrollVars.current = 0;
	        done();
	      }
	    },
	    leave: function leave(el, done) {
	      if (el.className === 'single-plant') {
	        this.leaveSinglePlant(el, done);
	      } else if (el.className === 'home') {
	        this.leaveHome(el, done);
	      } else {
	        this.leaveAbout(el, done);
	      }
	    },
	    enterHome: function enterHome(el, done) {
	      done();
	    },
	    enterSinglePlant: function enterSinglePlant(el, done) {
	      done();
	    },
	    leaveHome: function leaveHome(el, done) {
	      var _this5 = this;
	
	      window.scrollTo(0, 0);
	      this.scrollVars.current = 0;
	      TweenMax.to(el, 0.6, {
	        opacity: 0,
	        ease: Expo.easeOut,
	        onComplete: function onComplete() {
	          _this5.scene.destroy();
	          _this5.scene = null;
	          done();
	        }
	      });
	    },
	    leaveSinglePlant: function leaveSinglePlant(el, done) {
	      var _this6 = this;
	
	      var canvasContainer = el.querySelector('.single-plant__canvas-container');
	      var tl = new TimelineMax({
	        onComplete: function onComplete() {
	          _this6.scene.destroy();
	          _this6.scene = null;
	          done();
	        }
	      });
	      tl.to(canvasContainer, 0.3, {
	        autoAlpha: 0,
	        ease: Expo.easeOut
	      }).to(el, 0.6, {
	        autoAlpha: 0,
	        ease: Expo.easeOut
	      });
	    },
	    leaveAbout: function leaveAbout(el, done) {
	      window.scrollTo(0, 0);
	      this.scrollVars.current = 0;
	      TweenMax.to(el, 1, {
	        opacity: 0,
	        ease: Expo.easeOut,
	        onComplete: function onComplete() {
	          done();
	        }
	      });
	    }
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 614:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 615:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 616:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 617:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 618:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 619:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 620:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 621:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 622:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 623:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 624:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 625:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 626:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 627:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 725:
/***/ function(module, exports) {

	module.exports = "\nprecision mediump float;\n\nvarying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform sampler2D mask;\nuniform float alpha;\n\nvoid main(void)\n{\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    float threshold = texture2D(mask, vFilterCoord).r;\n\n    float mask = smoothstep(1.0 - alpha * 1.4, 1.0 - alpha * 1.4 + 0.4, threshold);\n\n    float intensity = pow(min(1.0, alpha * 5.0), 5.0);\n\n    gl_FragColor = vec4(original*mask*intensity);\n}\n"

/***/ },

/***/ 726:
/***/ function(module, exports) {

	module.exports = "\nprecision mediump float;\n\nvarying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float alpha;\n\n\nvec4 Desaturate(vec4 texture, float Desaturation)\n{\n  vec3 grayXfer = vec3(0.3, 0.59, 0.11);\n  vec3 color = texture.rgb;\n  vec3 gray = vec3(dot(grayXfer, color));\n  return vec4(mix(color, gray, Desaturation), texture.a);\n}\n\nvoid main(void)\n{\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    vec4 desaturateVec = Desaturate(original, 1.0 - alpha);\n\n    gl_FragColor = vec4(desaturateVec*alpha);\n    // gl_FragColor = vec4(Desaturate(original*alpha, 1.0));\n}\n"

/***/ },

/***/ 733:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(334),
	  /* template */
	  __webpack_require__(754),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 734:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(336),
	  /* template */
	  __webpack_require__(747),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 735:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(337),
	  /* template */
	  __webpack_require__(746),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 736:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(338),
	  /* template */
	  __webpack_require__(751),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 737:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(339),
	  /* template */
	  __webpack_require__(755),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 738:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(340),
	  /* template */
	  __webpack_require__(745),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 739:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(343),
	  /* template */
	  __webpack_require__(756),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 740:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(345),
	  /* template */
	  __webpack_require__(753),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 741:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(346),
	  /* template */
	  __webpack_require__(749),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 742:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(27)(
	  /* script */
	  __webpack_require__(347),
	  /* template */
	  __webpack_require__(743),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 743:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isReady && !_vm.isLoading) ? _c('div', {
	    staticClass: "app",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('menu-comp'), _vm._v(" "), _c('transition', {
	    attrs: {
	      "mode": "out-in",
	      "css": false
	    },
	    on: {
	      "enter": _vm.enter,
	      "leave": _vm.leave
	    }
	  }, [_c('router-view')], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ },

/***/ 744:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.type !== 'sound') ? _c('a', {
	    directives: [{
	      name: "sharebox",
	      rawName: "v-sharebox",
	      value: ({
	        'service': this.type,
	        'opts': _vm.getShareInfos()
	      }),
	      expression: "{'service':this.type, 'opts':getShareInfos()}"
	    }],
	    class: _vm.classes,
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('svg', {
	    staticStyle: {
	      "enable-background": "new 0 0 33 33.2"
	    },
	    attrs: {
	      "version": "1.1",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "x": "0px",
	      "y": "0px",
	      "viewBox": "0 0 33 33.2",
	      "xml:space": "preserve",
	      "height": "34px",
	      "width": "33px"
	    },
	    on: {
	      "mouseenter": function($event) {
	        _vm.onMouseEnter()
	      },
	      "touchstart": function($event) {
	        _vm.onMouseEnter()
	      },
	      "mouseleave": function($event) {
	        _vm.onMouseLeave()
	      },
	      "touchend": function($event) {
	        _vm.onMouseLeave()
	      }
	    }
	  }, [(_vm.type == 'facebook') ? _c('path', {
	    staticClass: "icon",
	    attrs: {
	      "d": "M16.5,0C7.4,0,0,7.4,0,16.6c0,9.1,7.4,16.6,16.5,16.6c9.1,0,16.5-7.4,16.5-16.6C33,7.4,25.6,0,16.5,0z\n         M20.6,17.2h-2.7v9.6h-4v-9.6H12v-3.4h1.9v-2.2c0-1.6,0.7-4,4-4l2.9,0v3.3h-2.1c-0.4,0-0.8,0.2-0.8,0.9v2h3L20.6,17.2z"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'twitter') ? _c('path', {
	    staticClass: "icon",
	    attrs: {
	      "d": "M16.5,0C7.4,0,0,7.4,0,16.6c0,9.1,7.4,16.6,16.5,16.6c9.1,0,16.5-7.4,16.5-16.6C33,7.4,25.6,0,16.5,0z\n         M23.8,12.8c0,0.2,0,0.3,0,0.5c0,5-3.8,10.9-10.8,10.9c-2.1,0-4.1-0.6-5.8-1.7c0.3,0,0.6,0.1,0.9,0.1c1.8,0,3.4-0.6,4.7-1.6\n         c-1.7,0-3.1-1.1-3.5-2.7c0.2,0,0.5,0.1,0.7,0.1c0.3,0,0.7,0,1-0.1c-1.7-0.3-3-1.9-3-3.7c0,0,0,0,0,0c0.5,0.3,1.1,0.5,1.7,0.5\n         C8.7,14.1,8,13,8,11.6c0-0.7,0.2-1.4,0.5-1.9c1.9,2.3,4.7,3.8,7.8,4c-0.1-0.3-0.1-0.6-0.1-0.9C16.3,10.7,18,9,20,9\n         c1.1,0,2.1,0.5,2.8,1.2c0.9-0.2,1.7-0.5,2.4-0.9c-0.3,0.9-0.9,1.6-1.7,2.1c0.8-0.1,1.5-0.3,2.2-0.6C25.2,11.6,24.6,12.2,23.8,12.8\n         z"
	    }
	  }) : _vm._e()])]) : _c('div', {
	    class: _vm.classes
	  }, [_c('svg', {
	    staticStyle: {
	      "enable-background": "new 0 0 33 33.2"
	    },
	    attrs: {
	      "version": "1.1",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "x": "0px",
	      "y": "0px",
	      "viewBox": "0 0 33 33.2",
	      "xml:space": "preserve",
	      "height": "34px",
	      "width": "33px"
	    },
	    on: {
	      "click": _vm.toggleSound,
	      "mouseenter": function($event) {
	        _vm.onMouseEnter()
	      },
	      "touchstart": function($event) {
	        _vm.onMouseEnter()
	      },
	      "mouseleave": function($event) {
	        _vm.onMouseLeave()
	      },
	      "touchend": function($event) {
	        _vm.onMouseLeave()
	      }
	    }
	  }, [_c('path', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.muted),
	      expression: "!muted"
	    }],
	    staticClass: "icon",
	    attrs: {
	      "d": "M16.5,0C7.4,0,0,7.4,0,16.6c0,9.1,7.4,16.6,16.5,16.6c9.1,0,16.5-7.4,16.5-16.6C33,7.4,25.6,0,16.5,0z\n        M16,22.3c0,0.4-0.2,0.7-0.5,0.8c-0.1,0.1-0.3,0.1-0.4,0.1c-0.2,0-0.4-0.1-0.6-0.2l-5-4.1H6.9c-0.5,0-0.9-0.4-0.9-0.9v-3.6\n        c0-0.5,0.4-0.9,0.9-0.9h2.6l5-4.1c0.3-0.2,0.6-0.3,1-0.1C15.8,9.2,16,9.6,16,9.9V22.3z M19.5,20.8C19.5,20.8,19.4,20.8,19.5,20.8\n        c-0.3,0-0.5-0.1-0.7-0.3l-0.1-0.1c-0.3-0.3-0.4-0.8-0.1-1.2c0.7-0.9,1-2,1-3.2c0-1.2-0.4-2.4-1.2-3.4c-0.3-0.4-0.3-0.9,0.1-1.2\n        l0.1-0.1c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3c1.1,1.3,1.6,2.9,1.6,4.6c0,1.6-0.5,3.1-1.4,4.4\n        C20,20.7,19.8,20.8,19.5,20.8z M23.2,23.7c-0.2,0.2-0.4,0.3-0.7,0.3c0,0,0,0,0,0c-0.2,0-0.5-0.1-0.6-0.3l-0.1-0.1\n        c-0.3-0.3-0.4-0.9-0.1-1.2c1.5-1.8,2.3-4,2.3-6.3c0-2.4-0.9-4.7-2.4-6.5c-0.3-0.4-0.3-0.9,0-1.3l0.1-0.1C21.9,8.1,22.1,8,22.4,8\n        c0.2,0,0.5,0.1,0.7,0.3c1.9,2.1,2.9,4.9,2.9,7.8C26,18.9,25,21.6,23.2,23.7z"
	    }
	  }), _vm._v(" "), _c('path', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.muted),
	      expression: "muted"
	    }],
	    staticClass: "icon",
	    attrs: {
	      "d": "M16.5,0C7.4,0,0,7.4,0,16.6\n          c0,9.1,7.4,16.6,16.5,16.6c9.1,0,16.5-7.4,16.5-16.6C33,7.4,25.6,0,16.5,0z M16,22.3c0,0.4-0.2,0.7-0.5,0.8\n          c-0.1,0.1-0.3,0.1-0.4,0.1c-0.2,0-0.4-0.1-0.6-0.2l-5-4.1H6.9c-0.5,0-0.9-0.4-0.9-0.9v-3.6c0-0.5,0.4-0.9,0.9-0.9h2.6l5-4.1\n          c0.3-0.2,0.6-0.3,1-0.1C15.8,9.2,16,9.6,16,9.9V22.3z M23.4,18.8c-0.4,0.4-1,0.4-1.4,0l-1.3-1.3l-1.3,1.3c-0.4,0.4-1,0.4-1.4,0\n          c-0.4-0.4-0.4-1,0-1.4l1.3-1.3L18,14.8c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l1.3,1.3l1.3-1.3c0.4-0.4,1-0.4,1.4,0\n          c0.4,0.4,0.4,1,0,1.4l-1.3,1.3l1.3,1.3C23.8,17.8,23.8,18.4,23.4,18.8z"
	    }
	  })])])
	},staticRenderFns: []}

/***/ },

/***/ 745:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "single-plant"
	  }, [_c('div', {
	    staticClass: "single-plant__scroll-container"
	  }, [(_vm.content) ? _c('div', {
	    staticClass: "single-plant__container"
	  }, [_c('div', {
	    staticClass: "single-plant__wrapper"
	  }, [_c('div', {
	    ref: "plantText"
	  }, [_c('h2', {
	    staticClass: "single-plant__subtitle"
	  }, [_vm._v("Aujourd'hui, la plante qu'il vous faut est :")]), _vm._v(" "), _c('h1', {
	    staticClass: "single-plant__title"
	  }, [_vm._v(_vm._s(_vm.content.title))]), _vm._v(" "), _c('p', {
	    staticClass: "single-plant__description"
	  }, [_vm._v(_vm._s(_vm.content.desc))])]), _vm._v(" "), _c('div', {
	    staticClass: "single-plant__sharing"
	  }, [_c('p', {
	    staticClass: "sharing__text"
	  }, [_vm._v("Partagez votre plante prodigieuse :")]), _vm._v(" "), _c('div', {
	    staticClass: "sharing__btns"
	  }, [_c('ui-button', {
	    attrs: {
	      "shareInfos": _vm.shareInfos,
	      "type": "facebook"
	    }
	  }), _vm._v(" "), _c('ui-button', {
	    attrs: {
	      "shareInfos": _vm.shareInfos,
	      "type": "twitter"
	    }
	  })], 1)]), _vm._v(" "), _c('ui-button-to-home', {
	    attrs: {
	      "goToFilters": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    ref: "canvas",
	    staticClass: "single-plant__canvas-container"
	  })]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
	    staticClass: "single-plant__container single-plant__container--error"
	  }, [_c('h1', [_vm._v("Erreur " + _vm._s(_vm.error.code))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.error.msg))])]) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('artwork', {
	    ref: "artwork",
	    attrs: {
	      "prefix": ((_vm.plant.id) + "_" + (_vm.plant.title)),
	      "oeuvre": _vm.content.oeuvre
	    }
	  }) : _vm._e(), _vm._v(" "), _c('ui-footer', {
	    ref: "uiFooter"
	  }), _vm._v(" "), (_vm.nav) ? _c('div', {
	    staticClass: "single-plant__nav"
	  }, [_c('navigation-button', {
	    attrs: {
	      "slug": _vm.nav.prev,
	      "direction": "prev"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.tweenContent('prev')
	      }
	    }
	  }), _vm._v(" "), _c('navigation-button', {
	    attrs: {
	      "slug": _vm.nav.next,
	      "direction": "next"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.tweenContent('next')
	      }
	    }
	  })], 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ },

/***/ 746:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filters-section is-hidden"
	  }, [_c('div', {
	    staticClass: "filters-container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "filters__column filters__column--right"
	  }, [_c('div', {
	    staticClass: "filters__choices"
	  }, _vm._l((_vm.filters), function(filter) {
	    return _c('div', {
	      staticClass: "filters__choice",
	      class: {
	        'filters__choice--active': _vm.currentFilter == filter.value
	      }
	    }, [_c('a', {
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.clickFilter(filter.value)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "choice-inner"
	    }, [_vm._v(_vm._s(_vm._f("capitalize")(filter.name)))])])])
	  }))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filters__column filters__column--left"
	  }, [_c('div', {
	    staticClass: "filters__question"
	  }, [_c('h1', [_vm._v("Aujourd’hui"), _c('br'), _vm._v("vous vous sentez ?")])])])
	}]}

/***/ },

/***/ 747:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cover-section is-hidden"
	  }, [_c('div', {
	    staticClass: "cover-container"
	  }, [_c('div', {
	    staticClass: "cover-container__jardins"
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 347 451",
	      "enable-background": "new 0 0 347 451"
	    }
	  }, [_c('path', {
	    staticClass: "st0",
	    attrs: {
	      "d": "M3.2 125.3c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm6.1 9.8c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 .1-1.5 1.3-3 3-3zm9 7.5c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 0-1.8 1.5-3 3-3zm11 3.8c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c.1-1.5 1.3-3 3-3zm12.2.8c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.2-3 3-3zm11.4-2.3c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c.1-1.7 1.3-3 3-3zm10-6c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 .1-1.5 1.3-3 3-3zm7-9.1c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm3.9-11.1c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm1.5-11.6c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm.2-106.2c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.7 1.3-3 3-3zm0 11.7c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm0 11.7c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 0-1.5 1.3-3 3-3zm0 11.9c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm0 11.7c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 0-1.5 1.3-3 3-3zm0 11.9c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.7 1.3-3 3-3zm0 11.7c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm0 11.9c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.7 1.3-3 3-3zm0 11.7c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3z",
	      "id": "J"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "st0",
	    attrs: {
	      "d": "M5.1 168.8c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm0 11.9c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 0-1.5 1.3-3 3-3zm0 12.1c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm0 11.9c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 0-1.5 1.3-3 3-3zm0 12.1c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm0 12.2c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.8 1.3-3 3-3zm0 11.9c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 0-1.5 1.3-3 3-3zm0 12.1c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm0 12.1c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.7 1.3-3 3-3zm0 11.9c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm0 12.1c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.7 1.3-3 3-3zm0 12c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 0-1.6 1.3-3 3-3zm0 12.1c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm11.9-144.4c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm0 144.4c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm11.7-144.4c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm0 144.4c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm11.9-144.4c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm0 144.4c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 .1-1.7 1.5-3 3-3zm11.9-143.6c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 .1-1.7 1.6-3 3-3zm0 142.7c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.6-3 3-3zm11.7-140.5c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c.1-1.8 1.3-3 3-3zm0 138.4c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c.1-1.7 1.3-3 3-3zm11.3-134.8c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm0 131c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm10.6-125.7c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c.1-1.7 1.3-3 3-3zm0 120.4c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm9.4-7.1c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm.2-106.3c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.7 1.3-3 3-3zm7.9 97.6c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm.2-89.1c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 0-1.5 1.3-3 3-3zm6.2 10c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm0 69.1c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm4.2-58c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm0 47.2c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 0-1.7 1.5-3 3-3zm2.6-35.5c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.8 1.3-3 3-3zm0 23.8c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm.8-11.9c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3z",
	      "id": "D"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "st0",
	    attrs: {
	      "d": "M76.4 281.2c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm0 11.9c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3-1.5 0-3-1.3-3-3 0-1.5 1.5-3 3-3zm0 12.1c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm0 12.2c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 0-1.8 1.5-3 3-3zm0 11.9c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3 0-1.8 1.5-3 3-3zm0 12.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 0-1.7 1.5-3 3-3zm0 11.9c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3-1.5 0-3-1.3-3-3 0-1.5 1.5-3 3-3zm0 12.1c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm0 11.9c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3-1.5 0-3-1.3-3-3 0-1.5 1.5-3 3-3zm0 12.1c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm0 12.2c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 0-1.8 1.5-3 3-3zm0 11.9c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm0 12.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 0-1.7 1.5-3 3-3z",
	      "id": "I"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "st0",
	    attrs: {
	      "d": "M119.2 300.3c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.8 1.3-3 3-3zm0 13.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm0 11.9c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm0 12c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm0 11.9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c0-1.8 1.3-3 3-3zm0 11.9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c0-1.8 1.3-3 3-3zm0 11.9c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm0 12.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm0 11.9c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm0 11.9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm0 11.9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm0 11.9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm0 12c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.6 1.3-3 3-3zm9.1-134.2c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm7.3 9.5c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 0-1.5 1.3-3 3-3zm7.2 9.8c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.7 1.3-3 3-3zm7.2 9.6c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm7.3 9.6c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm7.2 9.5c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 0-1.5 1.3-3 3-3zm7.2 9.8c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.7 1.3-3 3-3zm7.3 9.6c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm7.2 9.5c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 0-1.5 1.3-3 3-3zm7.2 9.8c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.7 1.3-3 3-3zm7.2 9.6c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm7.3 9.6c1.5 0 3 1.3 3 3s-1.5 3-3.2 3c-1.5 0-2.8-1.3-2.8-3 0-1.8 1.3-3 3-3zm7.2 9.5c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 0-1.5 1.3-3 3-3zm7.2 9.8c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm9-135.4c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.6 1.3-3 3-3zm0 12.3c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm0 12.3c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm0 11.9c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm0 12.2c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.8 1.3-3 3-3zm0 11.9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c0-1.8 1.3-3 3-3zm0 11.9c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm0 12.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm0 11.9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm0 11.9c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm0 12.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm0 11.9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm0 12c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.6 1.3-3 3-3z",
	      "id": "N"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "st0",
	    attrs: {
	      "d": "M261.7 390c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm.9-92.1c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm.6-12.3c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm2.8 23.6c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 0-1.5 1.3-3 3-3zm1.2-34.7c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm2.8 123.6c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm3.6-80.2c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3 .1-1.7 1.5-3 3-3zm1.3-52.3c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3-1.5 0-3-1.3-3-3 0-1.5 1.5-3 3-3zm5.7 138c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm3.4-79.9c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c.1-1.5 1.3-3 3-3zm1.3-63.8c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm6.8 146.5c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 .1-1.7 1.5-3 3-3zm3.2-78.5c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm1.5-70.8c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm7.7 149.7c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm2.3-75.3c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm2.1-75c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm7.3 148.6c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm1.9-69.7c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm2.7-77.4c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c.1-1.6 1.3-3 3-3zm6.4 142.7c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.8 1.3-3 3-3zm1.7-60c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.7 1.3-3 3-3zm3-78.3c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm4 130.6c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 .1-1.7 1.5-3 3-3zm2-44.9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.2-3 3-3zm2.9-78c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm.9 112.5c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm1.3-24.1c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm.8 12.4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3z",
	      "id": "S"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "st0",
	    attrs: {
	      "d": "M79.1 193.3c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3-1.5 0-3-1.3-3-3 0-1.5 1.5-3 3-3zm4.7-11c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.8 1.3-3 3-3zm4.7-11.3c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm4.4-11.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 .1-1.7 1.5-3 3-3zm4.7-11.2c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm4.7-11.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm4.5-11.3c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm2.9 22.4c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c.1-1.6 1.3-3 3-3zm1.7-33.4c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c.1-1.8 1.3-3 3-3zm4.7-11.3c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm4.7-11.1c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.7 1.3-3 3-3zm1.1 55.8c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.6 1.3-3 3-3zm3.4-67c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c0-1.8 1.3-3 3-3zm4.6-11.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c.1-1.7 1.3-3 3-3zm4.1 78.1c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 0-1.6 1.3-3 3-3zm.6-89.4c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm5.5-11.7c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c.1-1.7 1.3-3 3-3zm5.6 11.7c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm.2 89.4c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3-1.5 0-3-1.3-3-3 0-1.6 1.5-3 3-3zm4.5-78.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.2-3 3-3zm4.4 11.1c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3 0-1.8 1.5-3 3-3zm3.2 67c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.6 1.3-3 3-3zm1.5-55.8c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm4.7 11.1c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm4.4 11.3c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 .1-1.8 1.6-3 3-3zm1.5 33.4c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c.1-1.6 1.3-3 3-3zm3.2-22.4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm4.7 11.3c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm4.7 11.1c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm4.4 11.2c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c.1-1.7 1.3-3 3-3zm4.7 11.1c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm4.7 11.3c1.5 0 3 1.3 3 3 0 1.5-1.5 3-3 3-1.7 0-3-1.5-3-3 0-1.8 1.3-3 3-3zm4.5 11c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3-1.5 0-3-1.3-3-3 0-1.5 1.5-3 3-3z",
	      "id": "A"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "st0",
	    attrs: {
	      "d": "M228.2 100.5c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c.1-1.7 1.3-3 3-3zm0 11.9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c.1-1.7 1.3-3 3-3zm0 12.2c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c.1-1.8 1.3-3 3-3zm0 11.9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c.1-1.7 1.3-3 3-3zm0 12.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c.1-1.7 1.3-3 3-3zm0 11.9c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c.1-1.5 1.3-3 3-3zm0 12.1c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm0 12.2c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c.1-1.8 1.3-3 3-3zm0 11.9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm0 12.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c.1-1.7 1.3-3 3-3zm0 11.9c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c.1-1.5 1.3-3 3-3zm0 12.1c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm0 12.1c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c.1-1.5 1.3-3 3-3zm10.7-72.3c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 0-1.7 1.5-3 3-3zm1.5-72.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm10.6 72.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 0-1.7 1.5-3 3-3zm1.5-72.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm10.6 72.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 0-1.7 1.5-3 3-3zm1.5-72.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm5.7 81.3c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 .1-1.5 1.3-3 3-3zm5.1-9.4c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 .1-1.7 1.6-3 3-3zm1.3 18.5c1.5 0 3 1.3 3 3s-1.5 3-3 3c-1.7 0-3-1.3-3-3s1.3-3 3-3zm.2-90.2c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c.1-1.7 1.3-3 3-3zm6.2 99.4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c0-1.8 1.3-3 3-3zm4.3-30.2c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm1.4-66.8c1.5 0 3 1.5 3 3 0 1.7-1.5 3-3 3-1.7 0-3-1.3-3-3 .1-1.5 1.3-3 3-3zm.7 106.1c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3s-3-1.5-3-3c0-1.7 1.3-3 3-3zm6.4 8.9c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.5 1.3-3 3-3zm1.7-54.4c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3-1.5 0-3-1.3-3-3 0-1.5 1.5-3 3-3zm1.4-54.7c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3-1.5 0-3-1.3-3-3 .1-1.5 1.6-3 3-3zm3.2 118.3c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c.1-1.5 1.3-3 3-3zm2.8-73c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm1.1-35.5c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 0-1.7 1.5-3 3-3zm2.5 117.6c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3zm.2-93.5c1.7 0 3 1.5 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3c.1-1.6 1.3-3 3-3zm.2-12.4c1.7 0 3 1.3 3 3 0 1.5-1.3 3-3 3-1.5 0-3-1.5-3-3 .1-1.7 1.6-3 3-3zm6 115.3c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.5 0-3-1.3-3-3s1.5-3 3-3z",
	      "id": "R"
	    }
	  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "cover-container__background-gradient"
	  }), _vm._v(" "), _vm._m(1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cover-container__imgs_wrapper"
	  }, [_c('div', {
	    staticClass: "cover-container__content"
	  }, [_c('div', {
	    staticClass: "cover-container__title"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/assets/img/home/secrets_vertus_plantes@2x.png",
	      "alt": "",
	      "width": "336px",
	      "height": "414px"
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "cover-container__excerpt"
	  }, [_vm._v("A l'occasion de l'exposition Jardins au Grand Palais, libérez l'herboriste qui sommeille en vous et découvrez les plantes qui vous remettront d'aplomb...")])]), _vm._v(" "), _c('div', {
	    staticClass: "cover-container__foreground"
	  }, [_c('img', {
	    staticClass: "foreground__plant-left",
	    attrs: {
	      "src": "/static/assets/img/home/home_left_plant.png",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "foreground__plant-right",
	    attrs: {
	      "src": "/static/assets/img/home/home_right_plant.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "cover-container__background"
	  }, [_c('img', {
	    staticClass: "background__plant background__plant-1",
	    attrs: {
	      "src": "/static/assets/img/home/BG_fleur.jpg",
	      "alt": ""
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cover-container__cta"
	  }, [_c('p', {
	    staticClass: "cover-container__cta-title"
	  }, [_vm._v("Faites défiler")]), _vm._v(" "), _c('img', {
	    staticClass: "cover-container__cta-img",
	    attrs: {
	      "src": "/static/assets/img/home_scolldown.png",
	      "alt": ""
	    }
	  })])
	}]}

/***/ },

/***/ 748:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home',
	        params: {
	          goToFilters: _vm.goToFilters
	        }
	      }
	    }
	  }, [_c('div', {
	    staticClass: "button-to-home",
	    on: {
	      "mouseenter": function($event) {
	        _vm.tweenAllPlantsEnter()
	      },
	      "touchstart": function($event) {
	        _vm.tweenAllPlantsEnter()
	      },
	      "mouseleave": function($event) {
	        _vm.tweenAllPlantsLeave()
	      },
	      "touchend": function($event) {
	        _vm.tweenAllPlantsLeave()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "button-to-home__wrapper"
	  }, [_c('svg', {
	    staticClass: "button-to-home__icon",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "width": "25px",
	      "height": "30px",
	      "viewBox": " 0 0 25 30"
	    }
	  }, [_c('path', {
	    staticClass: "icon__path",
	    attrs: {
	      "fill-rule": "evenodd",
	      "fill": "rgb(255, 255, 255)",
	      "d": "M22.055,17.091 C21.264,16.822 20.546,16.692 19.900,16.703 C19.255,16.715 18.601,16.825 17.938,17.033 C17.276,17.243 16.722,17.474 16.277,17.728 C15.832,17.982 15.400,18.271 14.983,18.596 C14.565,18.921 14.290,19.147 14.156,19.273 C14.023,19.400 13.922,19.502 13.856,19.579 C14.412,18.080 14.819,16.522 15.075,14.902 L15.358,14.952 C15.548,14.984 15.806,15.009 16.135,15.026 C16.463,15.043 16.839,15.047 17.263,15.043 C17.685,15.037 18.131,14.984 18.599,14.885 C19.066,14.786 19.537,14.653 20.010,14.488 C20.483,14.323 20.937,14.073 21.370,13.736 C21.805,13.400 22.192,13.006 22.531,12.554 C22.871,12.103 23.150,11.527 23.366,10.828 C23.584,10.127 23.703,9.348 23.725,8.489 C22.969,8.236 22.231,8.103 21.512,8.092 C20.795,8.081 20.171,8.161 19.642,8.332 C19.113,8.502 18.604,8.748 18.114,9.068 C17.624,9.386 17.229,9.693 16.928,9.984 C16.628,10.276 16.347,10.596 16.086,10.943 C15.824,11.290 15.654,11.527 15.576,11.654 C15.498,11.781 15.443,11.882 15.409,11.959 C15.420,11.673 15.426,11.278 15.426,10.777 C15.426,10.276 15.420,9.998 15.409,9.943 L15.526,9.695 C15.615,9.530 15.711,9.299 15.810,9.001 C15.911,8.703 16.016,8.361 16.128,7.976 C16.239,7.591 16.311,7.169 16.345,6.712 C16.378,6.255 16.381,5.783 16.353,5.299 C16.325,4.814 16.211,4.324 16.011,3.828 C15.810,3.331 15.543,2.864 15.209,2.423 C14.876,1.982 14.405,1.560 13.798,1.158 C13.191,0.756 12.482,0.417 11.669,0.142 C11.100,0.892 10.711,1.654 10.500,2.431 C10.288,3.207 10.222,3.907 10.299,4.530 C10.377,5.153 10.561,5.772 10.850,6.389 C11.139,7.006 11.440,7.518 11.752,7.926 C12.063,8.335 12.418,8.728 12.812,9.108 C13.207,9.489 13.480,9.733 13.631,9.843 C13.781,9.954 13.900,10.042 13.990,10.108 C13.990,10.912 13.923,11.987 13.789,13.331 L13.723,13.066 C13.667,12.901 13.578,12.684 13.455,12.414 C13.332,12.144 13.179,11.835 12.996,11.488 C12.812,11.141 12.579,10.794 12.294,10.447 C12.010,10.100 11.699,9.764 11.360,9.439 C11.019,9.114 10.611,8.839 10.132,8.613 C9.653,8.387 9.141,8.222 8.595,8.117 C8.050,8.012 7.423,8.007 6.717,8.100 C6.010,8.194 5.266,8.395 4.488,8.703 C4.554,9.475 4.713,10.177 4.963,10.811 C5.213,11.444 5.516,11.965 5.873,12.373 C6.229,12.780 6.646,13.139 7.126,13.447 C7.604,13.756 8.072,13.990 8.528,14.149 C8.985,14.310 9.478,14.436 10.006,14.529 C10.535,14.624 10.989,14.678 11.367,14.695 C11.746,14.712 12.133,14.715 12.528,14.703 C12.923,14.692 13.182,14.678 13.304,14.662 C13.427,14.646 13.528,14.632 13.606,14.621 C13.315,16.383 12.876,17.986 12.286,19.430 C12.007,18.945 11.693,18.494 11.343,18.075 C10.991,17.656 10.499,17.232 9.864,16.802 C9.230,16.372 8.536,16.061 7.785,15.868 C7.034,15.675 6.101,15.634 4.988,15.744 C3.874,15.855 2.683,16.169 1.414,16.687 C1.781,17.601 2.196,18.406 2.658,19.100 C3.120,19.793 3.591,20.345 4.069,20.752 C4.548,21.160 5.060,21.485 5.606,21.728 C6.151,21.970 6.668,22.127 7.159,22.198 C7.648,22.271 8.155,22.285 8.678,22.240 C9.202,22.196 9.664,22.124 10.064,22.025 C10.466,21.926 10.866,21.799 11.267,21.644 C10.132,23.717 8.731,25.339 7.067,26.512 C5.402,27.686 3.607,28.278 1.681,28.289 C1.469,28.289 1.291,28.358 1.147,28.496 C1.001,28.634 0.929,28.807 0.929,29.016 C0.929,29.225 1.001,29.402 1.147,29.545 C1.291,29.688 1.469,29.760 1.681,29.760 C3.996,29.749 6.137,29.019 8.102,27.570 C10.067,26.121 11.679,24.141 12.937,21.629 L13.221,21.793 C13.399,21.904 13.656,22.028 13.989,22.165 C14.323,22.303 14.709,22.455 15.150,22.619 C15.589,22.785 16.071,22.907 16.594,22.983 C17.118,23.060 17.655,23.108 18.206,23.123 C18.757,23.140 19.321,23.060 19.901,22.884 C20.480,22.707 21.031,22.451 21.554,22.115 C22.077,21.779 22.584,21.292 23.074,20.653 C23.564,20.014 23.987,19.253 24.343,18.372 C23.607,17.788 22.845,17.361 22.055,17.091 L22.055,17.091 Z"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "button-to-home__text"
	  }, [_vm._v("Toutes les plantes prodigieuses")])])])])
	},staticRenderFns: []}

/***/ },

/***/ 749:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    staticClass: "nav__btn",
	    class: _vm.classes,
	    attrs: {
	      "to": {
	        name: 'single-plant',
	        params: {
	          slug: _vm.slug
	        }
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "nav__arrow",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "width": "54px",
	      "height": "54px"
	    },
	    on: {
	      "click": function($event) {
	        _vm.pushTheButton()
	      },
	      "mouseenter": function($event) {
	        _vm.onMouseEnter()
	      },
	      "touchstart": function($event) {
	        _vm.onMouseEnter()
	      },
	      "mouseleave": function($event) {
	        _vm.onMouseLeave()
	      },
	      "touchend": function($event) {
	        _vm.onMouseLeave()
	      }
	    }
	  }, [_c('defs', [_c('filter', {
	    attrs: {
	      "filterUnits": "userSpaceOnUse",
	      "id": "Filter_0",
	      "x": "0px",
	      "y": "0px",
	      "width": "54px",
	      "height": "54px"
	    }
	  }, [_c('feOffset', {
	    attrs: {
	      "in": "SourceAlpha",
	      "dx": "0",
	      "dy": "0"
	    }
	  }), _vm._v(" "), _c('feGaussianBlur', {
	    attrs: {
	      "result": "blurOut",
	      "stdDeviation": "3"
	    }
	  }), _vm._v(" "), _c('feFlood', {
	    attrs: {
	      "flood-color": "rgb(0, 0, 0)",
	      "result": "floodOut"
	    }
	  }), _vm._v(" "), _c('feComposite', {
	    attrs: {
	      "operator": "atop",
	      "in": "floodOut",
	      "in2": "blurOut"
	    }
	  }), _vm._v(" "), _c('feComponentTransfer', [_c('feFuncA', {
	    attrs: {
	      "type": "linear",
	      "slope": "0.26"
	    }
	  })], 1), _vm._v(" "), _c('feMerge', [_c('feMergeNode'), _vm._v(" "), _c('feMergeNode', {
	    attrs: {
	      "in": "SourceGraphic"
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('path', {
	    staticClass: "circle-shadow",
	    attrs: {
	      "filter": "url(#Filter_0)",
	      "fill-rule": "evenodd",
	      "fill": "rgb(255, 255, 255)",
	      "d": "M26.000,10.500 C34.837,10.500 42.000,17.663 42.000,26.500 C42.000,35.337 34.837,42.500 26.000,42.500 C17.163,42.500 10.000,35.337 10.000,26.500 C10.000,17.663 17.163,10.500 26.000,10.500 Z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "circle",
	    attrs: {
	      "fill-rule": "evenodd",
	      "fill": "rgb(255, 255, 255)",
	      "d": "M26.000,10.500 C34.837,10.500 42.000,17.663 42.000,26.500 C42.000,35.337 34.837,42.500 26.000,42.500 C17.163,42.500 10.000,35.337 10.000,26.500 C10.000,17.663 17.163,10.500 26.000,10.500 Z"
	    }
	  }), _vm._v(" "), (_vm.direction == 'prev') ? _c('g', {
	    staticClass: "arrow",
	    attrs: {
	      "transform": "translate(20,18)"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill-rule": "evenodd",
	      "fill": "rgb(197, 195, 176)",
	      "d": "M7.895,16.192 L0.495,9.000 L7.895,1.808 C8.463,2.235 8.984,2.720 9.437,3.266 L3.537,9.000 L9.437,14.734 C8.984,15.280 8.463,15.765 7.895,16.192 Z"
	    }
	  })]) : _c('g', {
	    staticClass: "arrow",
	    attrs: {
	      "transform": "translate(21,18)"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill-rule": "evenodd",
	      "fill": "rgb(197, 195, 176)",
	      "d": "M3.605,1.808 L11.005,9.000 L3.605,16.192 C3.037,15.765 2.516,15.280 2.063,14.734 L7.963,9.000 L2.063,3.266 C2.516,2.720 3.037,2.235 3.605,1.808 Z"
	    }
	  })])])])
	},staticRenderFns: []}

/***/ },

/***/ 750:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer",
	    class: _vm.classes
	  }, [_c('div', {
	    staticClass: "footer__container"
	  }, [_vm._m(0), _vm._v(" "), _c('nav', {
	    staticClass: "footer__nav"
	  }, [_c('router-link', {
	    staticClass: "nav__link",
	    attrs: {
	      "to": {
	        name: 'about'
	      }
	    }
	  }, [_vm._v("\n        À propos\n      ")]), _vm._v(" "), _c('p', {
	    staticClass: "nav__credits"
	  }, [_vm._v("© RMN - Grand Palais")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer__rmn"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.grandpalais.fr/fr/evenement/jardins",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/assets/img/logo_rmn.png",
	      "alt": "Rmn"
	    }
	  })])])
	}]}

/***/ },

/***/ 751:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "home-footer is-hidden"
	  }, [_c('div', {
	    staticClass: "home-footer__container"
	  }, [(_vm.plant) ? _c('artwork', {
	    ref: "artwork",
	    attrs: {
	      "prefix": ((_vm.plant.id) + "_" + (_vm.plant.title)),
	      "oeuvre": _vm.plant.content.oeuvre
	    }
	  }) : _vm._e(), _vm._v(" "), _c('ui-footer')], 1)])
	},staticRenderFns: []}

/***/ },

/***/ 752:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "artwork",
	    class: _vm.classArtwork
	  }, [_c('div', {
	    staticClass: "artwork__bg-color"
	  }), _vm._v(" "), (_vm.content) ? _c('div', {
	    ref: "inner",
	    staticClass: "artwork__inner",
	    class: _vm.classesInner
	  }, [_c('div', {
	    staticClass: "artwork__bg"
	  }, [_c('div', {
	    ref: "img_background",
	    staticClass: "artwork__bg-image"
	  }, [(_vm.oeuvre2) ? _c('img', {
	    attrs: {
	      "src": _vm.oeuvre2,
	      "alt": ((_vm.content.title) + " - " + (_vm.content.artiste))
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "artwork__content"
	  }, [_c('div', {
	    staticClass: "artwork__col artwork__col--infos artwork__col--mobile-only"
	  }, [_c('div', {
	    ref: "infos",
	    staticClass: "infos"
	  }, [(_vm.content.artiste) ? _c('p', {
	    staticClass: "infos__author"
	  }, [_vm._v(_vm._s(_vm.content.artiste))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    ref: "img_oeuvre",
	    staticClass: "artwork__col artwork__col--oeuvre"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isHome),
	      expression: "!isHome"
	    }],
	    ref: "infos",
	    staticClass: "infos"
	  }, [_c('div', {
	    staticClass: "infos__top"
	  }, [(_vm.content.title) ? _c('p', {
	    staticClass: "infos__name"
	  }, [_vm._v(_vm._s(_vm.content.title))]) : _vm._e(), _vm._v(" "), (_vm.content.artiste) ? _c('p', {
	    staticClass: "infos__author"
	  }, [_vm._v(_vm._s(_vm.content.artiste))]) : _vm._e()]), _vm._v(" "), (_vm.content.credits) ? _c('p', {
	    staticClass: "infos__credits"
	  }, [_vm._v(_vm._s(_vm.content.credits) + " "), (_vm.content.date) ? _c('span', [_vm._v("– " + _vm._s(_vm.content.date))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.content.credits && _vm.content.date) ? _c('p', {
	    staticClass: "infos__credits"
	  }, [_vm._v(_vm._s(_vm.content.date))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "oeuvre-container"
	  }, [(_vm.oeuvre1) ? _c('img', {
	    staticClass: "oeuvre-img--desktop",
	    attrs: {
	      "src": _vm.oeuvre1,
	      "alt": ((_vm.content.title) + " - " + (_vm.content.artiste))
	    }
	  }) : _vm._e(), _vm._v(" "), _c('img', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isHome),
	      expression: "isHome"
	    }],
	    staticClass: "oeuvre-img--mobile",
	    attrs: {
	      "src": "/static/assets/img/jardins_small.png",
	      "alt": ""
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "artwork__col artwork__col--infos"
	  }, [_c('div', {
	    ref: "infos",
	    staticClass: "infos"
	  }, [(_vm.content.title) ? _c('p', {
	    staticClass: "infos__name"
	  }, [_vm._v(_vm._s(_vm.content.title))]) : _vm._e(), _vm._v(" "), (_vm.content.artiste) ? _c('p', {
	    staticClass: "infos__author"
	  }, [_vm._v(_vm._s(_vm.content.artiste))]) : _vm._e(), _vm._v(" "), (_vm.content.credits) ? _c('p', {
	    staticClass: "infos__credits"
	  }, [_vm._v(_vm._s(_vm.content.credits) + " "), (_vm.content.date) ? _c('span', [_vm._v("– " + _vm._s(_vm.content.date))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.content.credits && _vm.content.date) ? _c('p', {
	    staticClass: "infos__credits"
	  }, [_vm._v(_vm._s(_vm.content.date))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "promo"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isHome),
	      expression: "!isHome"
	    }],
	    staticClass: "promo__logo-jardins"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/assets/img/jardins_small.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), (!_vm.isHome) ? _c('p', {
	    staticClass: "promo__text"
	  }, [_vm._v("Retrouvez cette plante dans l’expo Jardins au Grand Palais jusqu’au 24 juillet 2017 et visitez là autrement avec le parcours botanique de l’application !")]) : _c('p', {
	    staticClass: "promo__text"
	  }, [_vm._v("Miroir du monde, le jardin rend compte d'une manière de voir la nature, de la mettre en scène et de la penser.")]), _vm._v(" "), _c('a', {
	    staticClass: "promo__btn",
	    attrs: {
	      "href": "http://www.grandpalais.fr/fr/article/jardins-lapplication-mobile-de-lexposition",
	      "target": "_blank"
	    },
	    on: {
	      "mouseenter": function($event) {
	        _vm.onMouseEnter()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "smartphone"
	  }), _vm._v(" "), _c('span', [_vm._v("Découvrez l’appli de l’exposition")])])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ },

/***/ 753:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "menu",
	    class: _vm.classes
	  }, [_c('div', {
	    staticClass: "menu__background"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "menu__container"
	  }, [_c('div', {
	    staticClass: "menu__rmn"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.grandpalais.fr/fr/evenement/jardins",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isTransparent),
	      expression: "isTransparent"
	    }],
	    attrs: {
	      "src": "/static/assets/img/logo_rmn.png",
	      "alt": "Rmn"
	    }
	  }), _vm._v(" "), _c('img', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isTransparent),
	      expression: "!isTransparent"
	    }],
	    attrs: {
	      "src": "/static/assets/img/logo_rmn_black.png",
	      "alt": "Rmn"
	    }
	  })])]), _vm._v(" "), _c('router-link', {
	    staticClass: "menu__home-link",
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "menu__title"
	  }, [_c('span', {
	    staticClass: "title__big"
	  }, [_vm._v("Secrets")]), _vm._v(" "), _c('span', {
	    staticClass: "title__small"
	  }, [_vm._v("et")]), _vm._v(" "), _c('span', {
	    staticClass: "title__big"
	  }, [_vm._v("Vertus")]), _vm._v(" "), _c('span', {
	    staticClass: "title__small"
	  }, [_vm._v("des")]), _vm._v(" "), _c('span', {
	    staticClass: "title__big"
	  }, [_vm._v("Plantes")])])]), _vm._v(" "), _c('div', {
	    staticClass: "menu__btns"
	  }, [_c('ui-button', {
	    attrs: {
	      "shareInfos": _vm.shareInfos(),
	      "type": "sound",
	      "isTransparent": _vm.isTransparent
	    }
	  }), _vm._v(" "), _c('ui-button', {
	    attrs: {
	      "shareInfos": _vm.shareInfos(),
	      "type": "facebook",
	      "isTransparent": _vm.isTransparent
	    }
	  }), _vm._v(" "), _c('ui-button', {
	    attrs: {
	      "shareInfos": _vm.shareInfos(),
	      "type": "twitter",
	      "isTransparent": _vm.isTransparent
	    }
	  })], 1)], 1)])
	},staticRenderFns: []}

/***/ },

/***/ 754:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "about"
	  }, [_c('div', {
	    staticClass: "about__container"
	  }, [_c('h1', {
	    staticClass: "about__title"
	  }, [_vm._v("À propos")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ui-button-to-home', {
	    attrs: {
	      "goToFilters": false
	    }
	  })], 1), _vm._v(" "), _c('ui-footer', {
	    ref: "uiFooter"
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "about__credit about__texts"
	  }, [_c('h2', {
	    staticClass: "about__subtitle"
	  }, [_vm._v("Crédits")]), _vm._v(" "), _c('p', {
	    staticClass: "about__production about__text"
	  }, [_c('span', {
	    staticClass: "about__text--bold"
	  }, [_vm._v("Production : ")]), _vm._v("Réunion des musées nationaux - Grand Palais")]), _vm._v(" "), _c('p', {
	    staticClass: "about__project-management about__text"
	  }, [_c('span', {
	    staticClass: "about__text--bold"
	  }, [_vm._v("Gestion de projet : ")]), _vm._v("Léa Ducré - UPIAN")]), _vm._v(" "), _c('p', {
	    staticClass: "about__project-management about__text"
	  }, [_c('span', {
	    staticClass: "about__text--bold"
	  }, [_vm._v("Conception, direction artistique : ")]), _vm._v("Karim Moreau - UPIAN")]), _vm._v(" "), _c('p', {
	    staticClass: "about__project-management about__text"
	  }, [_c('span', {
	    staticClass: "about__text--bold"
	  }, [_vm._v("Code créatif & développement : ")]), _vm._v("Emmanuel Durgoni, Geoffrey Legenty - UPIAN")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "about__data-collect about__texts"
	  }, [_c('h2', {
	    staticClass: "about__subtitle"
	  }, [_vm._v("Protection des données")]), _vm._v(" "), _c('p', {
	    staticClass: "about__text"
	  }, [_vm._v("Aucune donnée personnelle afférente à l'utilisation du site n'est collectée\n        de façon permanente ni transmise à des tiers.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "about__contact about__texts"
	  }, [_c('h2', {
	    staticClass: "about__subtitle"
	  }, [_vm._v("Contact")]), _vm._v(" "), _c('p', {
	    staticClass: "about__text about__text--mail"
	  }, [_vm._v("webmaster@rmngp.fr")])])
	}]}

/***/ },

/***/ 755:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "home"
	  }, [_c('cover-section'), _vm._v(" "), _c('filters-section'), _vm._v(" "), _c('home-footer', {
	    ref: "homeFooter"
	  }), _vm._v(" "), (_vm.isFiltered) ? _c('close-button', {
	    attrs: {
	      "direction": "right"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.resetFilter($event)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ },

/***/ 756:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "close__btn",
	    class: _vm.classes
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "width": "64px",
	      "height": "64px"
	    },
	    on: {
	      "click": function($event) {
	        _vm.pushTheButton()
	      },
	      "mouseenter": function($event) {
	        _vm.onMouseEnter()
	      },
	      "touchstart": function($event) {
	        _vm.onMouseEnter()
	      },
	      "mouseleave": function($event) {
	        _vm.onMouseLeave()
	      },
	      "touchend": function($event) {
	        _vm.onMouseLeave()
	      }
	    }
	  }, [_c('defs', [_c('filter', {
	    attrs: {
	      "filterUnits": "userSpaceOnUse",
	      "id": "Filter_0",
	      "x": "0px",
	      "y": "0px",
	      "width": "64px",
	      "height": "64px"
	    }
	  }, [_c('feOffset', {
	    attrs: {
	      "in": "SourceAlpha",
	      "dx": "0",
	      "dy": "0"
	    }
	  }), _vm._v(" "), _c('feGaussianBlur', {
	    attrs: {
	      "result": "blurOut",
	      "stdDeviation": "3"
	    }
	  }), _vm._v(" "), _c('feFlood', {
	    attrs: {
	      "flood-color": "rgb(0, 0, 0)",
	      "result": "floodOut"
	    }
	  }), _vm._v(" "), _c('feComposite', {
	    attrs: {
	      "operator": "atop",
	      "in": "floodOut",
	      "in2": "blurOut"
	    }
	  }), _vm._v(" "), _c('feComponentTransfer', [_c('feFuncA', {
	    attrs: {
	      "type": "linear",
	      "slope": "0.26"
	    }
	  })], 1), _vm._v(" "), _c('feMerge', [_c('feMergeNode'), _vm._v(" "), _c('feMergeNode', {
	    attrs: {
	      "in": "SourceGraphic"
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('path', {
	    staticClass: "circle-shadow",
	    attrs: {
	      "filter": "url(#Filter_0)",
	      "fill-rule": "evenodd",
	      "fill": "rgb(255, 255, 255)",
	      "d": "M31.500,10.000 C43.374,10.000 53.000,19.626 53.000,31.500 C53.000,43.374 43.374,53.000 31.500,53.000 C19.626,53.000 10.000,43.374 10.000,31.500 C10.000,19.626 19.626,10.000 31.500,10.000 Z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "circle",
	    attrs: {
	      "fill-rule": "evenodd",
	      "fill": "rgb(255, 255, 255)",
	      "d": "M31.500,10.000 C43.374,10.000 53.000,19.626 53.000,31.500 C53.000,43.374 43.374,53.000 31.500,53.000 C19.626,53.000 10.000,43.374 10.000,31.500 C10.000,19.626 19.626,10.000 31.500,10.000 Z"
	    }
	  }), _vm._v(" "), _c('g', {
	    staticClass: "cross",
	    attrs: {
	      "transform": "translate(22.5,23.5)"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill-rule": "evenodd",
	      "fill": "rgb(255, 54, 0)",
	      "d": "M16.574,13.654 L13.991,16.236 L8.501,10.750 L3.012,16.236 L0.429,13.654 L5.918,8.169 L0.429,2.683 L3.012,0.101 L8.501,5.587 L13.991,0.101 L16.574,2.683 L11.085,8.169 L16.574,13.654 Z"
	    }
	  })])])])
	},staticRenderFns: []}

/***/ },

/***/ 763:
/***/ function(module, exports) {

	/* (ignored) */

/***/ }

});


/** WEBPACK FOOTER **
 ** static/js/app.3a44875c64922210d68e.js
 **/